/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Kerberus Auth API
 * Auth / user / organization endpoints
 * OpenAPI spec version: 1.0.0
 */
import useSwr from 'swr';
import type { Arguments, Key, SWRConfiguration } from 'swr';

import useSWRMutation from 'swr/mutation';
import type { SWRMutationConfiguration } from 'swr/mutation';

import type {
    ActivityProfile,
    Address,
    AddressOwner,
    AddressRequest,
    ApiHiddenTime,
    ApiSite,
    Area,
    AreaRequest,
    Calendar,
    CalendarByOwnerParams,
    CalendarEventCreate,
    CalendarEventCreateRequest,
    CalendarEventDetail,
    CalendarEventList,
    CalendarEventListRequest,
    Company,
    CompanyCreationRequest,
    CompanyCreationRequestRequest,
    CompanyDashboardSelect,
    CompanyDashboardSelectRequest,
    CompanyRequest,
    CompanyUser,
    ConferenceRoom,
    ConferenceRoomRequest,
    Dashboard,
    DashboardCompanyUser,
    DashboardRequest,
    DashboardSocialGroup,
    DashboardTokenNew,
    DashboardTokenNewRequest,
    Device,
    DeviceGroup,
    DeviceGroupRequest,
    DeviceOnline,
    DeviceRequest,
    EventApiUsers,
    Firmware,
    FirmwareRequest,
    GroupRequests,
    HiddenTime,
    HiddenTimeRequest,
    JwtUser,
    Layer,
    LayerRequest,
    PatchedAddressRequest,
    PatchedAreaRequest,
    PatchedCalendarEventListRequest,
    PatchedCompanyCreationRequestRequest,
    PatchedCompanyDashboardSelectRequest,
    PatchedCompanyRequest,
    PatchedDashboardRequest,
    PatchedDeviceGroupRequest,
    PatchedDeviceRequest,
    PatchedFirmwareRequest,
    PatchedLayerRequest,
    PatchedPointRequest,
    PatchedSiteRequest,
    PatchedSocialGroupDashboardSelectRequest,
    PatchedSocialGroupRequest,
    PatchedTaskRequest,
    PatchedTypeSerialzerRequest,
    PatchedUserBaseRequest,
    PatchedUserManageUpdateRequest,
    PatchedUserPreloadSetRequest,
    Point,
    PointRequest,
    ProfileList,
    PushSubscription,
    PushSubscriptionRequest,
    RegisterRequest,
    Screen,
    ScreenRequest,
    Site,
    SiteRequest,
    SiteSelect,
    SocialGroup,
    SocialGroupDashboardSelect,
    SocialGroupDashboardSelectRequest,
    SocialGroupInfo,
    SocialGroupRequest,
    Task,
    TaskRequest,
    TimeTableUser,
    TypeSerialzer,
    TypeSerialzerRequest,
    UserBase,
    UserBaseRequest,
    UserManage,
    UserManageUpdate,
    UserManageUpdateRequest,
    UserPreloadGet,
    UserPreloadSet,
    UserPreloadSetRequest,
    UsersCalendarEventsListParams,
    UsersConferenceRoomInviteCreateBodyOne,
    UsersConferenceRoomInviteCreateBodyThree,
    UsersConferenceRoomInviteCreateBodyTwo,
    UsersConferenceRoomInviteCreateParams,
} from './model';

import alarmsApialarmhandlerRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import alarmsCreateUserAlarmCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesAddaddressCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesAddaddressdevgroupCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesAddressListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesAddressCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesAddressRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesAddressUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesAddressPartialUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesAddressDestroyMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesAddressownerListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesAllRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesAlldevicesListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesAlldevicesCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesAlldevicesRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesAlldevicesUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesAlldevicesPartialUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesAlldevicesDestroyMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesApiSiteInfoRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesApiendpointRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesApisitesListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesDeletesiteDestroyMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesDeviceListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesDeviceCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesDeviceRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesDeviceUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesDevicePartialUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesDeviceDestroyMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesDevicegroupListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesDevicegroupCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesDevicegroupRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesDevicegroupUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesDevicegroupPartialUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesDevicegroupDestroyMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesDevicegrouplocationCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesDeviceonlineRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesFirmwareListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesFirmwareCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesFirmwareRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesFirmwareUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesFirmwarePartialUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesFirmwareDestroyMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesFwdownloadRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesFwupdateRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesMaindevicesListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesMaindevicesCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesMaindevicesRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesMaindevicesUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesMaindevicesPartialUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesMaindevicesDestroyMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesNewLayerCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesRebindAllCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesRemoveaddressDestroyMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesRemoveaddressdevgroupDestroyMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesScreenListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesScreenCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesScreenRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesScreenDestroyMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesSiteListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesSiteCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesSiteRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesSiteUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesSitePartialUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesSiteDestroyMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesSiteselectListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesTypeListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesTypeCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesTypeRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesTypeUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesTypePartialUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesTypeDestroyMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesUnboundListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesUnboundCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesUnboundRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesUnboundUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesUnboundPartialUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesUnboundDestroyMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesUpdateLayerPartialUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import devicesValidScreenRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import mapsAreaListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import mapsAreaCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import mapsAreaRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import mapsAreaUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import mapsAreaPartialUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import mapsAreaDestroyMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import mapsAreasForDeviceRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import mapsLayerListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import mapsLayerCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import mapsLayerRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import mapsLayerUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import mapsLayerPartialUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import mapsLayerDestroyMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import mapsPointListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import mapsPointCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import mapsPointRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import mapsPointUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import mapsPointPartialUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import mapsPointDestroyMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import mapsRemoveAreaForDeviceCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import tasksApiInstanceDescriptionRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import tasksInstanceDescriptionRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import tasksInstanceInfoRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import tasksInstancePublicRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import tasksRestartServerCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import tasksSyncallRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import tasksTaskListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import tasksTaskCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import tasksTaskRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import tasksTaskUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import tasksTaskPartialUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import tasksTaskDestroyMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import tasksTokenPermissionSelfRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import tasksTokenPermissionSettingsRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import tasksUpdateInstanceDescriptionUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import tasksUpdateInstanceDescriptionPartialUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import tasksUpdateInstanceInfoUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import tasksUpdateInstanceInfoPartialUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import tasksUpdateTokenPermissionSettingsUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import tasksUpdateTokenPermissionSettingsPartialUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersActivityprofileRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersAdvertisedRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersApiBulkMessageserverCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersApiCompanyInfoRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersApiMessagePermsRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersApiRenkiApiPermsRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersApiSocialInfoRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersApiUserSitesRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersApigroupedaddressesRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersApihiddenListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersCalendarListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersCalendarEventsListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersCalendarEventsCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersCalendarEventsRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersCalendarEventsUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersCalendarEventsPartialUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersCalendarEventsDestroyMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersCalendarRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import calendarByOwnerMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersCancelhideCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersCompanyListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersCompanyCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersCompanyRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersCompanyUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersCompanyPartialUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersCompanycreationrequestListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersCompanycreationrequestCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersCompanycreationrequestRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersCompanycreationrequestUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersCompanycreationrequestPartialUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersCompanycreationrequestDestroyMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersCompanydashboardselectListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersCompanydashboardselectRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersCompanydashboardselectUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersCompanydashboardselectPartialUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersCompanylistsocialListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersCompanylistsocialRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersCompanyselectListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersConferenceRoomListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersConferenceRoomCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersConferenceRoomRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersConferenceRoomDestroyMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersConferenceRoomInviteCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersConferenceRoomJoinCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersConferenceRoomLeaveCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersCreateInviteCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersCreateSocialInviteCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersDashboardListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersDashboardCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersDashboardRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersDashboardUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersDashboardPartialUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersDashboardDestroyMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersDashboardWithTokenRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersDashboardcompanyRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersDashboardsocialgroupRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersDashboardtokenListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersDashboardtokenCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersDashboardtokenRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersDashboardtokenDestroyMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersDeleteCompanyDestroyMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersDeleteGroupDestroyMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersEventapiusersListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersExtendDashboardTokenPartialUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersGrouprequestsListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersHandleCompanyCreationRequestCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersHandleGroupRequestCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersHandleRegisterRequestCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersHasAccountRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersHiddentimeCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersJoinSocialDirectCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersJwtuserListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersKickFromCompanyCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersKickFromSocialCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersLeaveCompanyCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersLeaveInstanceDestroyMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersLeaveSocialCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersNewUserCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersPreloadWithEmailsCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersProfilelistsocialListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersRegisterrequestListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersRegisterrequestRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersRoleUsersRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersRoomQrTokenRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersScreenDashboardRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersSendGroupRequestCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersSocialgroupdashboardselectListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersSocialgroupdashboardselectRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersSocialgroupdashboardselectUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersSocialgroupdashboardselectPartialUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersSocialgroupinfoRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersSocialgrouplistListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersSocialgrouplistRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersSocialgrouppublicListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersSocialgroupselectListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersSocialgroupselectCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersSocialgroupselectUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersSocialgroupselectPartialUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersSsouserRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersSubscriptionCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersTestCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import currentUserListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersTimetableprofileCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersTimetableprofileRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersTimetableprofileUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersTimetableprofilePartialUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersTimetableprofileUpdatePartialUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersUpdateDashboardCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersUpdateSocialGroupPermCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersUploadPermsRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersUsePreloadCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersUserConnectionsRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersUsermanageListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersUsermanageUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersUsermanagePartialUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersUserpreloadListMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersUserpreloadCreateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersUserpreloadRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersUserpreloadUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersUserpreloadPartialUpdateMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersUserpreloadDestroyMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
import usersUsersitesRetrieveMutator from '../cloak-auth/src/Client/OrvalDjangoFetcher';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getAlarmsApialarmhandlerRetrieveUrl = () => {
    return `/api/alarms/apialarmhandler`;
};

export const alarmsApialarmhandlerRetrieve = async (options?: RequestInit): Promise<void> => {
    return alarmsApialarmhandlerRetrieveMutator<void>(getAlarmsApialarmhandlerRetrieveUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getAlarmsApialarmhandlerRetrieveKey = () => [`/api/alarms/apialarmhandler`] as const;

export type AlarmsApialarmhandlerRetrieveQueryResult = NonNullable<
    Awaited<ReturnType<typeof alarmsApialarmhandlerRetrieve>>
>;
export type AlarmsApialarmhandlerRetrieveQueryError = unknown;

export const useAlarmsApialarmhandlerRetrieve = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof alarmsApialarmhandlerRetrieve>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof alarmsApialarmhandlerRetrieveMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getAlarmsApialarmhandlerRetrieveKey() : null));
    const swrFn = () => alarmsApialarmhandlerRetrieve(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getAlarmsCreateUserAlarmCreateUrl = () => {
    return `/api/alarms/create_user_alarm`;
};

export const alarmsCreateUserAlarmCreate = async (options?: RequestInit): Promise<void> => {
    return alarmsCreateUserAlarmCreateMutator<void>(getAlarmsCreateUserAlarmCreateUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getAlarmsCreateUserAlarmCreateMutationFetcher = (
    options?: SecondParameter<typeof alarmsCreateUserAlarmCreateMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return alarmsCreateUserAlarmCreate(options);
    };
};
export const getAlarmsCreateUserAlarmCreateMutationKey = () => [`/api/alarms/create_user_alarm`] as const;

export type AlarmsCreateUserAlarmCreateMutationResult = NonNullable<
    Awaited<ReturnType<typeof alarmsCreateUserAlarmCreate>>
>;
export type AlarmsCreateUserAlarmCreateMutationError = unknown;

export const useAlarmsCreateUserAlarmCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof alarmsCreateUserAlarmCreate>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof alarmsCreateUserAlarmCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof alarmsCreateUserAlarmCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getAlarmsCreateUserAlarmCreateMutationKey();
    const swrFn = getAlarmsCreateUserAlarmCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesAddaddressCreateUrl = () => {
    return `/api/devices/addaddress`;
};

export const devicesAddaddressCreate = async (options?: RequestInit): Promise<void> => {
    return devicesAddaddressCreateMutator<void>(getDevicesAddaddressCreateUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getDevicesAddaddressCreateMutationFetcher = (
    options?: SecondParameter<typeof devicesAddaddressCreateMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return devicesAddaddressCreate(options);
    };
};
export const getDevicesAddaddressCreateMutationKey = () => [`/api/devices/addaddress`] as const;

export type DevicesAddaddressCreateMutationResult = NonNullable<Awaited<ReturnType<typeof devicesAddaddressCreate>>>;
export type DevicesAddaddressCreateMutationError = unknown;

export const useDevicesAddaddressCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof devicesAddaddressCreate>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof devicesAddaddressCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof devicesAddaddressCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesAddaddressCreateMutationKey();
    const swrFn = getDevicesAddaddressCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesAddaddressdevgroupCreateUrl = () => {
    return `/api/devices/addaddressdevgroup`;
};

export const devicesAddaddressdevgroupCreate = async (options?: RequestInit): Promise<void> => {
    return devicesAddaddressdevgroupCreateMutator<void>(getDevicesAddaddressdevgroupCreateUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getDevicesAddaddressdevgroupCreateMutationFetcher = (
    options?: SecondParameter<typeof devicesAddaddressdevgroupCreateMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return devicesAddaddressdevgroupCreate(options);
    };
};
export const getDevicesAddaddressdevgroupCreateMutationKey = () => [`/api/devices/addaddressdevgroup`] as const;

export type DevicesAddaddressdevgroupCreateMutationResult = NonNullable<
    Awaited<ReturnType<typeof devicesAddaddressdevgroupCreate>>
>;
export type DevicesAddaddressdevgroupCreateMutationError = unknown;

export const useDevicesAddaddressdevgroupCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof devicesAddaddressdevgroupCreate>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof devicesAddaddressdevgroupCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof devicesAddaddressdevgroupCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesAddaddressdevgroupCreateMutationKey();
    const swrFn = getDevicesAddaddressdevgroupCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesAddressListUrl = () => {
    return `/api/devices/address/`;
};

export const devicesAddressList = async (options?: RequestInit): Promise<Address[]> => {
    return devicesAddressListMutator<Address[]>(getDevicesAddressListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getDevicesAddressListKey = () => [`/api/devices/address/`] as const;

export type DevicesAddressListQueryResult = NonNullable<Awaited<ReturnType<typeof devicesAddressList>>>;
export type DevicesAddressListQueryError = unknown;

export const useDevicesAddressList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof devicesAddressList>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof devicesAddressListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getDevicesAddressListKey() : null));
    const swrFn = () => devicesAddressList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesAddressCreateUrl = () => {
    return `/api/devices/address/`;
};

export const devicesAddressCreate = async (addressRequest: AddressRequest, options?: RequestInit): Promise<Address> => {
    return devicesAddressCreateMutator<Address>(getDevicesAddressCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(addressRequest),
    });
};

export const getDevicesAddressCreateMutationFetcher = (
    options?: SecondParameter<typeof devicesAddressCreateMutator>,
) => {
    return (_: Key, { arg }: { arg: AddressRequest }) => {
        return devicesAddressCreate(arg, options);
    };
};
export const getDevicesAddressCreateMutationKey = () => [`/api/devices/address/`] as const;

export type DevicesAddressCreateMutationResult = NonNullable<Awaited<ReturnType<typeof devicesAddressCreate>>>;
export type DevicesAddressCreateMutationError = unknown;

export const useDevicesAddressCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof devicesAddressCreate>>,
        TError,
        Key,
        AddressRequest,
        Awaited<ReturnType<typeof devicesAddressCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof devicesAddressCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesAddressCreateMutationKey();
    const swrFn = getDevicesAddressCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesAddressRetrieveUrl = (id: number) => {
    return `/api/devices/address/${id}/`;
};

export const devicesAddressRetrieve = async (id: number, options?: RequestInit): Promise<Address> => {
    return devicesAddressRetrieveMutator<Address>(getDevicesAddressRetrieveUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getDevicesAddressRetrieveKey = (id: number) => [`/api/devices/address/${id}/`] as const;

export type DevicesAddressRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof devicesAddressRetrieve>>>;
export type DevicesAddressRetrieveQueryError = unknown;

export const useDevicesAddressRetrieve = <TError = unknown>(
    id: number,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof devicesAddressRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof devicesAddressRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getDevicesAddressRetrieveKey(id) : null));
    const swrFn = () => devicesAddressRetrieve(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesAddressUpdateUrl = (id: number) => {
    return `/api/devices/address/${id}/`;
};

export const devicesAddressUpdate = async (
    id: number,
    addressRequest: AddressRequest,
    options?: RequestInit,
): Promise<Address> => {
    return devicesAddressUpdateMutator<Address>(getDevicesAddressUpdateUrl(id), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(addressRequest),
    });
};

export const getDevicesAddressUpdateMutationFetcher = (
    id: number,
    options?: SecondParameter<typeof devicesAddressUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: AddressRequest }) => {
        return devicesAddressUpdate(id, arg, options);
    };
};
export const getDevicesAddressUpdateMutationKey = (id: number) => [`/api/devices/address/${id}/`] as const;

export type DevicesAddressUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof devicesAddressUpdate>>>;
export type DevicesAddressUpdateMutationError = unknown;

export const useDevicesAddressUpdate = <TError = unknown>(
    id: number,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof devicesAddressUpdate>>,
            TError,
            Key,
            AddressRequest,
            Awaited<ReturnType<typeof devicesAddressUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof devicesAddressUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesAddressUpdateMutationKey(id);
    const swrFn = getDevicesAddressUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesAddressPartialUpdateUrl = (id: number) => {
    return `/api/devices/address/${id}/`;
};

export const devicesAddressPartialUpdate = async (
    id: number,
    patchedAddressRequest: PatchedAddressRequest,
    options?: RequestInit,
): Promise<Address> => {
    return devicesAddressPartialUpdateMutator<Address>(getDevicesAddressPartialUpdateUrl(id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(patchedAddressRequest),
    });
};

export const getDevicesAddressPartialUpdateMutationFetcher = (
    id: number,
    options?: SecondParameter<typeof devicesAddressPartialUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: PatchedAddressRequest }) => {
        return devicesAddressPartialUpdate(id, arg, options);
    };
};
export const getDevicesAddressPartialUpdateMutationKey = (id: number) => [`/api/devices/address/${id}/`] as const;

export type DevicesAddressPartialUpdateMutationResult = NonNullable<
    Awaited<ReturnType<typeof devicesAddressPartialUpdate>>
>;
export type DevicesAddressPartialUpdateMutationError = unknown;

export const useDevicesAddressPartialUpdate = <TError = unknown>(
    id: number,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof devicesAddressPartialUpdate>>,
            TError,
            Key,
            PatchedAddressRequest,
            Awaited<ReturnType<typeof devicesAddressPartialUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof devicesAddressPartialUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesAddressPartialUpdateMutationKey(id);
    const swrFn = getDevicesAddressPartialUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesAddressDestroyUrl = (id: number) => {
    return `/api/devices/address/${id}/`;
};

export const devicesAddressDestroy = async (id: number, options?: RequestInit): Promise<void> => {
    return devicesAddressDestroyMutator<void>(getDevicesAddressDestroyUrl(id), {
        ...options,
        method: 'DELETE',
    });
};

export const getDevicesAddressDestroyMutationFetcher = (
    id: number,
    options?: SecondParameter<typeof devicesAddressDestroyMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return devicesAddressDestroy(id, options);
    };
};
export const getDevicesAddressDestroyMutationKey = (id: number) => [`/api/devices/address/${id}/`] as const;

export type DevicesAddressDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof devicesAddressDestroy>>>;
export type DevicesAddressDestroyMutationError = unknown;

export const useDevicesAddressDestroy = <TError = unknown>(
    id: number,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof devicesAddressDestroy>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof devicesAddressDestroy>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof devicesAddressDestroyMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesAddressDestroyMutationKey(id);
    const swrFn = getDevicesAddressDestroyMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesAddressownerListUrl = () => {
    return `/api/devices/addressowner/`;
};

export const devicesAddressownerList = async (options?: RequestInit): Promise<AddressOwner[]> => {
    return devicesAddressownerListMutator<AddressOwner[]>(getDevicesAddressownerListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getDevicesAddressownerListKey = () => [`/api/devices/addressowner/`] as const;

export type DevicesAddressownerListQueryResult = NonNullable<Awaited<ReturnType<typeof devicesAddressownerList>>>;
export type DevicesAddressownerListQueryError = unknown;

export const useDevicesAddressownerList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof devicesAddressownerList>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof devicesAddressownerListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getDevicesAddressownerListKey() : null));
    const swrFn = () => devicesAddressownerList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesAllRetrieveUrl = () => {
    return `/api/devices/all/`;
};

export const devicesAllRetrieve = async (options?: RequestInit): Promise<void> => {
    return devicesAllRetrieveMutator<void>(getDevicesAllRetrieveUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getDevicesAllRetrieveKey = () => [`/api/devices/all/`] as const;

export type DevicesAllRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof devicesAllRetrieve>>>;
export type DevicesAllRetrieveQueryError = unknown;

export const useDevicesAllRetrieve = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof devicesAllRetrieve>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof devicesAllRetrieveMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getDevicesAllRetrieveKey() : null));
    const swrFn = () => devicesAllRetrieve(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesAlldevicesListUrl = () => {
    return `/api/devices/alldevices/`;
};

export const devicesAlldevicesList = async (options?: RequestInit): Promise<Device[]> => {
    return devicesAlldevicesListMutator<Device[]>(getDevicesAlldevicesListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getDevicesAlldevicesListKey = () => [`/api/devices/alldevices/`] as const;

export type DevicesAlldevicesListQueryResult = NonNullable<Awaited<ReturnType<typeof devicesAlldevicesList>>>;
export type DevicesAlldevicesListQueryError = unknown;

export const useDevicesAlldevicesList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof devicesAlldevicesList>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof devicesAlldevicesListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getDevicesAlldevicesListKey() : null));
    const swrFn = () => devicesAlldevicesList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesAlldevicesCreateUrl = () => {
    return `/api/devices/alldevices/`;
};

export const devicesAlldevicesCreate = async (deviceRequest: DeviceRequest, options?: RequestInit): Promise<Device> => {
    return devicesAlldevicesCreateMutator<Device>(getDevicesAlldevicesCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(deviceRequest),
    });
};

export const getDevicesAlldevicesCreateMutationFetcher = (
    options?: SecondParameter<typeof devicesAlldevicesCreateMutator>,
) => {
    return (_: Key, { arg }: { arg: DeviceRequest }) => {
        return devicesAlldevicesCreate(arg, options);
    };
};
export const getDevicesAlldevicesCreateMutationKey = () => [`/api/devices/alldevices/`] as const;

export type DevicesAlldevicesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof devicesAlldevicesCreate>>>;
export type DevicesAlldevicesCreateMutationError = unknown;

export const useDevicesAlldevicesCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof devicesAlldevicesCreate>>,
        TError,
        Key,
        DeviceRequest,
        Awaited<ReturnType<typeof devicesAlldevicesCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof devicesAlldevicesCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesAlldevicesCreateMutationKey();
    const swrFn = getDevicesAlldevicesCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesAlldevicesRetrieveUrl = (id: string) => {
    return `/api/devices/alldevices/${id}/`;
};

export const devicesAlldevicesRetrieve = async (id: string, options?: RequestInit): Promise<Device> => {
    return devicesAlldevicesRetrieveMutator<Device>(getDevicesAlldevicesRetrieveUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getDevicesAlldevicesRetrieveKey = (id: string) => [`/api/devices/alldevices/${id}/`] as const;

export type DevicesAlldevicesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof devicesAlldevicesRetrieve>>>;
export type DevicesAlldevicesRetrieveQueryError = unknown;

export const useDevicesAlldevicesRetrieve = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof devicesAlldevicesRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof devicesAlldevicesRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getDevicesAlldevicesRetrieveKey(id) : null));
    const swrFn = () => devicesAlldevicesRetrieve(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesAlldevicesUpdateUrl = (id: string) => {
    return `/api/devices/alldevices/${id}/`;
};

export const devicesAlldevicesUpdate = async (
    id: string,
    deviceRequest: DeviceRequest,
    options?: RequestInit,
): Promise<Device> => {
    return devicesAlldevicesUpdateMutator<Device>(getDevicesAlldevicesUpdateUrl(id), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(deviceRequest),
    });
};

export const getDevicesAlldevicesUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof devicesAlldevicesUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: DeviceRequest }) => {
        return devicesAlldevicesUpdate(id, arg, options);
    };
};
export const getDevicesAlldevicesUpdateMutationKey = (id: string) => [`/api/devices/alldevices/${id}/`] as const;

export type DevicesAlldevicesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof devicesAlldevicesUpdate>>>;
export type DevicesAlldevicesUpdateMutationError = unknown;

export const useDevicesAlldevicesUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof devicesAlldevicesUpdate>>,
            TError,
            Key,
            DeviceRequest,
            Awaited<ReturnType<typeof devicesAlldevicesUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof devicesAlldevicesUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesAlldevicesUpdateMutationKey(id);
    const swrFn = getDevicesAlldevicesUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesAlldevicesPartialUpdateUrl = (id: string) => {
    return `/api/devices/alldevices/${id}/`;
};

export const devicesAlldevicesPartialUpdate = async (
    id: string,
    patchedDeviceRequest: PatchedDeviceRequest,
    options?: RequestInit,
): Promise<Device> => {
    return devicesAlldevicesPartialUpdateMutator<Device>(getDevicesAlldevicesPartialUpdateUrl(id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(patchedDeviceRequest),
    });
};

export const getDevicesAlldevicesPartialUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof devicesAlldevicesPartialUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: PatchedDeviceRequest }) => {
        return devicesAlldevicesPartialUpdate(id, arg, options);
    };
};
export const getDevicesAlldevicesPartialUpdateMutationKey = (id: string) => [`/api/devices/alldevices/${id}/`] as const;

export type DevicesAlldevicesPartialUpdateMutationResult = NonNullable<
    Awaited<ReturnType<typeof devicesAlldevicesPartialUpdate>>
>;
export type DevicesAlldevicesPartialUpdateMutationError = unknown;

export const useDevicesAlldevicesPartialUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof devicesAlldevicesPartialUpdate>>,
            TError,
            Key,
            PatchedDeviceRequest,
            Awaited<ReturnType<typeof devicesAlldevicesPartialUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof devicesAlldevicesPartialUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesAlldevicesPartialUpdateMutationKey(id);
    const swrFn = getDevicesAlldevicesPartialUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesAlldevicesDestroyUrl = (id: string) => {
    return `/api/devices/alldevices/${id}/`;
};

export const devicesAlldevicesDestroy = async (id: string, options?: RequestInit): Promise<void> => {
    return devicesAlldevicesDestroyMutator<void>(getDevicesAlldevicesDestroyUrl(id), {
        ...options,
        method: 'DELETE',
    });
};

export const getDevicesAlldevicesDestroyMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof devicesAlldevicesDestroyMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return devicesAlldevicesDestroy(id, options);
    };
};
export const getDevicesAlldevicesDestroyMutationKey = (id: string) => [`/api/devices/alldevices/${id}/`] as const;

export type DevicesAlldevicesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof devicesAlldevicesDestroy>>>;
export type DevicesAlldevicesDestroyMutationError = unknown;

export const useDevicesAlldevicesDestroy = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof devicesAlldevicesDestroy>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof devicesAlldevicesDestroy>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof devicesAlldevicesDestroyMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesAlldevicesDestroyMutationKey(id);
    const swrFn = getDevicesAlldevicesDestroyMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesApiSiteInfoRetrieveUrl = (siteId: string) => {
    return `/api/devices/api_site_info/${siteId}`;
};

export const devicesApiSiteInfoRetrieve = async (siteId: string, options?: RequestInit): Promise<void> => {
    return devicesApiSiteInfoRetrieveMutator<void>(getDevicesApiSiteInfoRetrieveUrl(siteId), {
        ...options,
        method: 'GET',
    });
};

export const getDevicesApiSiteInfoRetrieveKey = (siteId: string) => [`/api/devices/api_site_info/${siteId}`] as const;

export type DevicesApiSiteInfoRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof devicesApiSiteInfoRetrieve>>>;
export type DevicesApiSiteInfoRetrieveQueryError = unknown;

export const useDevicesApiSiteInfoRetrieve = <TError = unknown>(
    siteId: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof devicesApiSiteInfoRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof devicesApiSiteInfoRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!siteId;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getDevicesApiSiteInfoRetrieveKey(siteId) : null));
    const swrFn = () => devicesApiSiteInfoRetrieve(siteId, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesApiendpointRetrieveUrl = () => {
    return `/api/devices/apiendpoint`;
};

export const devicesApiendpointRetrieve = async (options?: RequestInit): Promise<void> => {
    return devicesApiendpointRetrieveMutator<void>(getDevicesApiendpointRetrieveUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getDevicesApiendpointRetrieveKey = () => [`/api/devices/apiendpoint`] as const;

export type DevicesApiendpointRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof devicesApiendpointRetrieve>>>;
export type DevicesApiendpointRetrieveQueryError = unknown;

export const useDevicesApiendpointRetrieve = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof devicesApiendpointRetrieve>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof devicesApiendpointRetrieveMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getDevicesApiendpointRetrieveKey() : null));
    const swrFn = () => devicesApiendpointRetrieve(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesApisitesListUrl = () => {
    return `/api/devices/apisites/`;
};

export const devicesApisitesList = async (options?: RequestInit): Promise<ApiSite[]> => {
    return devicesApisitesListMutator<ApiSite[]>(getDevicesApisitesListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getDevicesApisitesListKey = () => [`/api/devices/apisites/`] as const;

export type DevicesApisitesListQueryResult = NonNullable<Awaited<ReturnType<typeof devicesApisitesList>>>;
export type DevicesApisitesListQueryError = unknown;

export const useDevicesApisitesList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof devicesApisitesList>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof devicesApisitesListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getDevicesApisitesListKey() : null));
    const swrFn = () => devicesApisitesList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesDeletesiteDestroyUrl = () => {
    return `/api/devices/deletesite`;
};

export const devicesDeletesiteDestroy = async (options?: RequestInit): Promise<void> => {
    return devicesDeletesiteDestroyMutator<void>(getDevicesDeletesiteDestroyUrl(), {
        ...options,
        method: 'DELETE',
    });
};

export const getDevicesDeletesiteDestroyMutationFetcher = (
    options?: SecondParameter<typeof devicesDeletesiteDestroyMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return devicesDeletesiteDestroy(options);
    };
};
export const getDevicesDeletesiteDestroyMutationKey = () => [`/api/devices/deletesite`] as const;

export type DevicesDeletesiteDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof devicesDeletesiteDestroy>>>;
export type DevicesDeletesiteDestroyMutationError = unknown;

export const useDevicesDeletesiteDestroy = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof devicesDeletesiteDestroy>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof devicesDeletesiteDestroy>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof devicesDeletesiteDestroyMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesDeletesiteDestroyMutationKey();
    const swrFn = getDevicesDeletesiteDestroyMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesDeviceListUrl = () => {
    return `/api/devices/device/`;
};

export const devicesDeviceList = async (options?: RequestInit): Promise<Device[]> => {
    return devicesDeviceListMutator<Device[]>(getDevicesDeviceListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getDevicesDeviceListKey = () => [`/api/devices/device/`] as const;

export type DevicesDeviceListQueryResult = NonNullable<Awaited<ReturnType<typeof devicesDeviceList>>>;
export type DevicesDeviceListQueryError = unknown;

export const useDevicesDeviceList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof devicesDeviceList>>, TError> & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof devicesDeviceListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getDevicesDeviceListKey() : null));
    const swrFn = () => devicesDeviceList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesDeviceCreateUrl = () => {
    return `/api/devices/device/`;
};

export const devicesDeviceCreate = async (deviceRequest: DeviceRequest, options?: RequestInit): Promise<Device> => {
    return devicesDeviceCreateMutator<Device>(getDevicesDeviceCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(deviceRequest),
    });
};

export const getDevicesDeviceCreateMutationFetcher = (options?: SecondParameter<typeof devicesDeviceCreateMutator>) => {
    return (_: Key, { arg }: { arg: DeviceRequest }) => {
        return devicesDeviceCreate(arg, options);
    };
};
export const getDevicesDeviceCreateMutationKey = () => [`/api/devices/device/`] as const;

export type DevicesDeviceCreateMutationResult = NonNullable<Awaited<ReturnType<typeof devicesDeviceCreate>>>;
export type DevicesDeviceCreateMutationError = unknown;

export const useDevicesDeviceCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof devicesDeviceCreate>>,
        TError,
        Key,
        DeviceRequest,
        Awaited<ReturnType<typeof devicesDeviceCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof devicesDeviceCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesDeviceCreateMutationKey();
    const swrFn = getDevicesDeviceCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesDeviceRetrieveUrl = (id: string) => {
    return `/api/devices/device/${id}/`;
};

export const devicesDeviceRetrieve = async (id: string, options?: RequestInit): Promise<Device> => {
    return devicesDeviceRetrieveMutator<Device>(getDevicesDeviceRetrieveUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getDevicesDeviceRetrieveKey = (id: string) => [`/api/devices/device/${id}/`] as const;

export type DevicesDeviceRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof devicesDeviceRetrieve>>>;
export type DevicesDeviceRetrieveQueryError = unknown;

export const useDevicesDeviceRetrieve = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof devicesDeviceRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof devicesDeviceRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getDevicesDeviceRetrieveKey(id) : null));
    const swrFn = () => devicesDeviceRetrieve(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesDeviceUpdateUrl = (id: string) => {
    return `/api/devices/device/${id}/`;
};

export const devicesDeviceUpdate = async (
    id: string,
    deviceRequest: DeviceRequest,
    options?: RequestInit,
): Promise<Device> => {
    return devicesDeviceUpdateMutator<Device>(getDevicesDeviceUpdateUrl(id), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(deviceRequest),
    });
};

export const getDevicesDeviceUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof devicesDeviceUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: DeviceRequest }) => {
        return devicesDeviceUpdate(id, arg, options);
    };
};
export const getDevicesDeviceUpdateMutationKey = (id: string) => [`/api/devices/device/${id}/`] as const;

export type DevicesDeviceUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof devicesDeviceUpdate>>>;
export type DevicesDeviceUpdateMutationError = unknown;

export const useDevicesDeviceUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof devicesDeviceUpdate>>,
            TError,
            Key,
            DeviceRequest,
            Awaited<ReturnType<typeof devicesDeviceUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof devicesDeviceUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesDeviceUpdateMutationKey(id);
    const swrFn = getDevicesDeviceUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesDevicePartialUpdateUrl = (id: string) => {
    return `/api/devices/device/${id}/`;
};

export const devicesDevicePartialUpdate = async (
    id: string,
    patchedDeviceRequest: PatchedDeviceRequest,
    options?: RequestInit,
): Promise<Device> => {
    return devicesDevicePartialUpdateMutator<Device>(getDevicesDevicePartialUpdateUrl(id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(patchedDeviceRequest),
    });
};

export const getDevicesDevicePartialUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof devicesDevicePartialUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: PatchedDeviceRequest }) => {
        return devicesDevicePartialUpdate(id, arg, options);
    };
};
export const getDevicesDevicePartialUpdateMutationKey = (id: string) => [`/api/devices/device/${id}/`] as const;

export type DevicesDevicePartialUpdateMutationResult = NonNullable<
    Awaited<ReturnType<typeof devicesDevicePartialUpdate>>
>;
export type DevicesDevicePartialUpdateMutationError = unknown;

export const useDevicesDevicePartialUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof devicesDevicePartialUpdate>>,
            TError,
            Key,
            PatchedDeviceRequest,
            Awaited<ReturnType<typeof devicesDevicePartialUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof devicesDevicePartialUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesDevicePartialUpdateMutationKey(id);
    const swrFn = getDevicesDevicePartialUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesDeviceDestroyUrl = (id: string) => {
    return `/api/devices/device/${id}/`;
};

export const devicesDeviceDestroy = async (id: string, options?: RequestInit): Promise<void> => {
    return devicesDeviceDestroyMutator<void>(getDevicesDeviceDestroyUrl(id), {
        ...options,
        method: 'DELETE',
    });
};

export const getDevicesDeviceDestroyMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof devicesDeviceDestroyMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return devicesDeviceDestroy(id, options);
    };
};
export const getDevicesDeviceDestroyMutationKey = (id: string) => [`/api/devices/device/${id}/`] as const;

export type DevicesDeviceDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof devicesDeviceDestroy>>>;
export type DevicesDeviceDestroyMutationError = unknown;

export const useDevicesDeviceDestroy = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof devicesDeviceDestroy>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof devicesDeviceDestroy>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof devicesDeviceDestroyMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesDeviceDestroyMutationKey(id);
    const swrFn = getDevicesDeviceDestroyMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesDevicegroupListUrl = () => {
    return `/api/devices/devicegroup/`;
};

export const devicesDevicegroupList = async (options?: RequestInit): Promise<DeviceGroup[]> => {
    return devicesDevicegroupListMutator<DeviceGroup[]>(getDevicesDevicegroupListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getDevicesDevicegroupListKey = () => [`/api/devices/devicegroup/`] as const;

export type DevicesDevicegroupListQueryResult = NonNullable<Awaited<ReturnType<typeof devicesDevicegroupList>>>;
export type DevicesDevicegroupListQueryError = unknown;

export const useDevicesDevicegroupList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof devicesDevicegroupList>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof devicesDevicegroupListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getDevicesDevicegroupListKey() : null));
    const swrFn = () => devicesDevicegroupList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesDevicegroupCreateUrl = () => {
    return `/api/devices/devicegroup/`;
};

export const devicesDevicegroupCreate = async (
    deviceGroupRequest: DeviceGroupRequest,
    options?: RequestInit,
): Promise<DeviceGroup> => {
    return devicesDevicegroupCreateMutator<DeviceGroup>(getDevicesDevicegroupCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(deviceGroupRequest),
    });
};

export const getDevicesDevicegroupCreateMutationFetcher = (
    options?: SecondParameter<typeof devicesDevicegroupCreateMutator>,
) => {
    return (_: Key, { arg }: { arg: DeviceGroupRequest }) => {
        return devicesDevicegroupCreate(arg, options);
    };
};
export const getDevicesDevicegroupCreateMutationKey = () => [`/api/devices/devicegroup/`] as const;

export type DevicesDevicegroupCreateMutationResult = NonNullable<Awaited<ReturnType<typeof devicesDevicegroupCreate>>>;
export type DevicesDevicegroupCreateMutationError = unknown;

export const useDevicesDevicegroupCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof devicesDevicegroupCreate>>,
        TError,
        Key,
        DeviceGroupRequest,
        Awaited<ReturnType<typeof devicesDevicegroupCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof devicesDevicegroupCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesDevicegroupCreateMutationKey();
    const swrFn = getDevicesDevicegroupCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesDevicegroupRetrieveUrl = (id: string) => {
    return `/api/devices/devicegroup/${id}/`;
};

export const devicesDevicegroupRetrieve = async (id: string, options?: RequestInit): Promise<DeviceGroup> => {
    return devicesDevicegroupRetrieveMutator<DeviceGroup>(getDevicesDevicegroupRetrieveUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getDevicesDevicegroupRetrieveKey = (id: string) => [`/api/devices/devicegroup/${id}/`] as const;

export type DevicesDevicegroupRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof devicesDevicegroupRetrieve>>>;
export type DevicesDevicegroupRetrieveQueryError = unknown;

export const useDevicesDevicegroupRetrieve = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof devicesDevicegroupRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof devicesDevicegroupRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getDevicesDevicegroupRetrieveKey(id) : null));
    const swrFn = () => devicesDevicegroupRetrieve(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesDevicegroupUpdateUrl = (id: string) => {
    return `/api/devices/devicegroup/${id}/`;
};

export const devicesDevicegroupUpdate = async (
    id: string,
    deviceGroupRequest: DeviceGroupRequest,
    options?: RequestInit,
): Promise<DeviceGroup> => {
    return devicesDevicegroupUpdateMutator<DeviceGroup>(getDevicesDevicegroupUpdateUrl(id), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(deviceGroupRequest),
    });
};

export const getDevicesDevicegroupUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof devicesDevicegroupUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: DeviceGroupRequest }) => {
        return devicesDevicegroupUpdate(id, arg, options);
    };
};
export const getDevicesDevicegroupUpdateMutationKey = (id: string) => [`/api/devices/devicegroup/${id}/`] as const;

export type DevicesDevicegroupUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof devicesDevicegroupUpdate>>>;
export type DevicesDevicegroupUpdateMutationError = unknown;

export const useDevicesDevicegroupUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof devicesDevicegroupUpdate>>,
            TError,
            Key,
            DeviceGroupRequest,
            Awaited<ReturnType<typeof devicesDevicegroupUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof devicesDevicegroupUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesDevicegroupUpdateMutationKey(id);
    const swrFn = getDevicesDevicegroupUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesDevicegroupPartialUpdateUrl = (id: string) => {
    return `/api/devices/devicegroup/${id}/`;
};

export const devicesDevicegroupPartialUpdate = async (
    id: string,
    patchedDeviceGroupRequest: PatchedDeviceGroupRequest,
    options?: RequestInit,
): Promise<DeviceGroup> => {
    return devicesDevicegroupPartialUpdateMutator<DeviceGroup>(getDevicesDevicegroupPartialUpdateUrl(id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(patchedDeviceGroupRequest),
    });
};

export const getDevicesDevicegroupPartialUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof devicesDevicegroupPartialUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: PatchedDeviceGroupRequest }) => {
        return devicesDevicegroupPartialUpdate(id, arg, options);
    };
};
export const getDevicesDevicegroupPartialUpdateMutationKey = (id: string) =>
    [`/api/devices/devicegroup/${id}/`] as const;

export type DevicesDevicegroupPartialUpdateMutationResult = NonNullable<
    Awaited<ReturnType<typeof devicesDevicegroupPartialUpdate>>
>;
export type DevicesDevicegroupPartialUpdateMutationError = unknown;

export const useDevicesDevicegroupPartialUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof devicesDevicegroupPartialUpdate>>,
            TError,
            Key,
            PatchedDeviceGroupRequest,
            Awaited<ReturnType<typeof devicesDevicegroupPartialUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof devicesDevicegroupPartialUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesDevicegroupPartialUpdateMutationKey(id);
    const swrFn = getDevicesDevicegroupPartialUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesDevicegroupDestroyUrl = (id: string) => {
    return `/api/devices/devicegroup/${id}/`;
};

export const devicesDevicegroupDestroy = async (id: string, options?: RequestInit): Promise<void> => {
    return devicesDevicegroupDestroyMutator<void>(getDevicesDevicegroupDestroyUrl(id), {
        ...options,
        method: 'DELETE',
    });
};

export const getDevicesDevicegroupDestroyMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof devicesDevicegroupDestroyMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return devicesDevicegroupDestroy(id, options);
    };
};
export const getDevicesDevicegroupDestroyMutationKey = (id: string) => [`/api/devices/devicegroup/${id}/`] as const;

export type DevicesDevicegroupDestroyMutationResult = NonNullable<
    Awaited<ReturnType<typeof devicesDevicegroupDestroy>>
>;
export type DevicesDevicegroupDestroyMutationError = unknown;

export const useDevicesDevicegroupDestroy = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof devicesDevicegroupDestroy>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof devicesDevicegroupDestroy>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof devicesDevicegroupDestroyMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesDevicegroupDestroyMutationKey(id);
    const swrFn = getDevicesDevicegroupDestroyMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesDevicegrouplocationCreateUrl = () => {
    return `/api/devices/devicegrouplocation`;
};

export const devicesDevicegrouplocationCreate = async (options?: RequestInit): Promise<void> => {
    return devicesDevicegrouplocationCreateMutator<void>(getDevicesDevicegrouplocationCreateUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getDevicesDevicegrouplocationCreateMutationFetcher = (
    options?: SecondParameter<typeof devicesDevicegrouplocationCreateMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return devicesDevicegrouplocationCreate(options);
    };
};
export const getDevicesDevicegrouplocationCreateMutationKey = () => [`/api/devices/devicegrouplocation`] as const;

export type DevicesDevicegrouplocationCreateMutationResult = NonNullable<
    Awaited<ReturnType<typeof devicesDevicegrouplocationCreate>>
>;
export type DevicesDevicegrouplocationCreateMutationError = unknown;

export const useDevicesDevicegrouplocationCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof devicesDevicegrouplocationCreate>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof devicesDevicegrouplocationCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof devicesDevicegrouplocationCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesDevicegrouplocationCreateMutationKey();
    const swrFn = getDevicesDevicegrouplocationCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesDeviceonlineRetrieveUrl = (id: string) => {
    return `/api/devices/deviceonline/${id}/`;
};

export const devicesDeviceonlineRetrieve = async (id: string, options?: RequestInit): Promise<DeviceOnline> => {
    return devicesDeviceonlineRetrieveMutator<DeviceOnline>(getDevicesDeviceonlineRetrieveUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getDevicesDeviceonlineRetrieveKey = (id: string) => [`/api/devices/deviceonline/${id}/`] as const;

export type DevicesDeviceonlineRetrieveQueryResult = NonNullable<
    Awaited<ReturnType<typeof devicesDeviceonlineRetrieve>>
>;
export type DevicesDeviceonlineRetrieveQueryError = unknown;

export const useDevicesDeviceonlineRetrieve = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof devicesDeviceonlineRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof devicesDeviceonlineRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getDevicesDeviceonlineRetrieveKey(id) : null));
    const swrFn = () => devicesDeviceonlineRetrieve(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesFirmwareListUrl = () => {
    return `/api/devices/firmware/`;
};

export const devicesFirmwareList = async (options?: RequestInit): Promise<Firmware[]> => {
    return devicesFirmwareListMutator<Firmware[]>(getDevicesFirmwareListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getDevicesFirmwareListKey = () => [`/api/devices/firmware/`] as const;

export type DevicesFirmwareListQueryResult = NonNullable<Awaited<ReturnType<typeof devicesFirmwareList>>>;
export type DevicesFirmwareListQueryError = unknown;

export const useDevicesFirmwareList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof devicesFirmwareList>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof devicesFirmwareListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getDevicesFirmwareListKey() : null));
    const swrFn = () => devicesFirmwareList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesFirmwareCreateUrl = () => {
    return `/api/devices/firmware/`;
};

export const devicesFirmwareCreate = async (
    firmwareRequest: FirmwareRequest,
    options?: RequestInit,
): Promise<Firmware> => {
    const formData = new FormData();
    if (firmwareRequest.type_name !== undefined) {
        formData.append(`type_name`, firmwareRequest.type_name);
    }
    formData.append(`file`, firmwareRequest.file);
    if (firmwareRequest.version !== null) {
        formData.append(`version`, firmwareRequest.version);
    }
    if (firmwareRequest.name !== undefined && firmwareRequest.name !== null) {
        formData.append(`name`, firmwareRequest.name);
    }
    if (firmwareRequest.type !== null) {
        formData.append(`type`, firmwareRequest.type);
    }

    return devicesFirmwareCreateMutator<Firmware>(getDevicesFirmwareCreateUrl(), {
        ...options,
        method: 'POST',
        body: formData,
    });
};

export const getDevicesFirmwareCreateMutationFetcher = (
    options?: SecondParameter<typeof devicesFirmwareCreateMutator>,
) => {
    return (_: Key, { arg }: { arg: FirmwareRequest }) => {
        return devicesFirmwareCreate(arg, options);
    };
};
export const getDevicesFirmwareCreateMutationKey = () => [`/api/devices/firmware/`] as const;

export type DevicesFirmwareCreateMutationResult = NonNullable<Awaited<ReturnType<typeof devicesFirmwareCreate>>>;
export type DevicesFirmwareCreateMutationError = unknown;

export const useDevicesFirmwareCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof devicesFirmwareCreate>>,
        TError,
        Key,
        FirmwareRequest,
        Awaited<ReturnType<typeof devicesFirmwareCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof devicesFirmwareCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesFirmwareCreateMutationKey();
    const swrFn = getDevicesFirmwareCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesFirmwareRetrieveUrl = (id: number) => {
    return `/api/devices/firmware/${id}/`;
};

export const devicesFirmwareRetrieve = async (id: number, options?: RequestInit): Promise<Firmware> => {
    return devicesFirmwareRetrieveMutator<Firmware>(getDevicesFirmwareRetrieveUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getDevicesFirmwareRetrieveKey = (id: number) => [`/api/devices/firmware/${id}/`] as const;

export type DevicesFirmwareRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof devicesFirmwareRetrieve>>>;
export type DevicesFirmwareRetrieveQueryError = unknown;

export const useDevicesFirmwareRetrieve = <TError = unknown>(
    id: number,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof devicesFirmwareRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof devicesFirmwareRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getDevicesFirmwareRetrieveKey(id) : null));
    const swrFn = () => devicesFirmwareRetrieve(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesFirmwareUpdateUrl = (id: number) => {
    return `/api/devices/firmware/${id}/`;
};

export const devicesFirmwareUpdate = async (
    id: number,
    firmwareRequest: FirmwareRequest,
    options?: RequestInit,
): Promise<Firmware> => {
    const formData = new FormData();
    if (firmwareRequest.type_name !== undefined) {
        formData.append(`type_name`, firmwareRequest.type_name);
    }
    formData.append(`file`, firmwareRequest.file);
    if (firmwareRequest.version !== null) {
        formData.append(`version`, firmwareRequest.version);
    }
    if (firmwareRequest.name !== undefined && firmwareRequest.name !== null) {
        formData.append(`name`, firmwareRequest.name);
    }
    if (firmwareRequest.type !== null) {
        formData.append(`type`, firmwareRequest.type);
    }

    return devicesFirmwareUpdateMutator<Firmware>(getDevicesFirmwareUpdateUrl(id), {
        ...options,
        method: 'PUT',
        body: formData,
    });
};

export const getDevicesFirmwareUpdateMutationFetcher = (
    id: number,
    options?: SecondParameter<typeof devicesFirmwareUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: FirmwareRequest }) => {
        return devicesFirmwareUpdate(id, arg, options);
    };
};
export const getDevicesFirmwareUpdateMutationKey = (id: number) => [`/api/devices/firmware/${id}/`] as const;

export type DevicesFirmwareUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof devicesFirmwareUpdate>>>;
export type DevicesFirmwareUpdateMutationError = unknown;

export const useDevicesFirmwareUpdate = <TError = unknown>(
    id: number,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof devicesFirmwareUpdate>>,
            TError,
            Key,
            FirmwareRequest,
            Awaited<ReturnType<typeof devicesFirmwareUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof devicesFirmwareUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesFirmwareUpdateMutationKey(id);
    const swrFn = getDevicesFirmwareUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesFirmwarePartialUpdateUrl = (id: number) => {
    return `/api/devices/firmware/${id}/`;
};

export const devicesFirmwarePartialUpdate = async (
    id: number,
    patchedFirmwareRequest: PatchedFirmwareRequest,
    options?: RequestInit,
): Promise<Firmware> => {
    const formData = new FormData();
    if (patchedFirmwareRequest.type_name !== undefined) {
        formData.append(`type_name`, patchedFirmwareRequest.type_name);
    }
    if (patchedFirmwareRequest.file !== undefined) {
        formData.append(`file`, patchedFirmwareRequest.file);
    }
    if (patchedFirmwareRequest.version !== undefined && patchedFirmwareRequest.version !== null) {
        formData.append(`version`, patchedFirmwareRequest.version);
    }
    if (patchedFirmwareRequest.name !== undefined && patchedFirmwareRequest.name !== null) {
        formData.append(`name`, patchedFirmwareRequest.name);
    }
    if (patchedFirmwareRequest.type !== undefined && patchedFirmwareRequest.type !== null) {
        formData.append(`type`, patchedFirmwareRequest.type);
    }

    return devicesFirmwarePartialUpdateMutator<Firmware>(getDevicesFirmwarePartialUpdateUrl(id), {
        ...options,
        method: 'PATCH',
        body: formData,
    });
};

export const getDevicesFirmwarePartialUpdateMutationFetcher = (
    id: number,
    options?: SecondParameter<typeof devicesFirmwarePartialUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: PatchedFirmwareRequest }) => {
        return devicesFirmwarePartialUpdate(id, arg, options);
    };
};
export const getDevicesFirmwarePartialUpdateMutationKey = (id: number) => [`/api/devices/firmware/${id}/`] as const;

export type DevicesFirmwarePartialUpdateMutationResult = NonNullable<
    Awaited<ReturnType<typeof devicesFirmwarePartialUpdate>>
>;
export type DevicesFirmwarePartialUpdateMutationError = unknown;

export const useDevicesFirmwarePartialUpdate = <TError = unknown>(
    id: number,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof devicesFirmwarePartialUpdate>>,
            TError,
            Key,
            PatchedFirmwareRequest,
            Awaited<ReturnType<typeof devicesFirmwarePartialUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof devicesFirmwarePartialUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesFirmwarePartialUpdateMutationKey(id);
    const swrFn = getDevicesFirmwarePartialUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesFirmwareDestroyUrl = (id: number) => {
    return `/api/devices/firmware/${id}/`;
};

export const devicesFirmwareDestroy = async (id: number, options?: RequestInit): Promise<void> => {
    return devicesFirmwareDestroyMutator<void>(getDevicesFirmwareDestroyUrl(id), {
        ...options,
        method: 'DELETE',
    });
};

export const getDevicesFirmwareDestroyMutationFetcher = (
    id: number,
    options?: SecondParameter<typeof devicesFirmwareDestroyMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return devicesFirmwareDestroy(id, options);
    };
};
export const getDevicesFirmwareDestroyMutationKey = (id: number) => [`/api/devices/firmware/${id}/`] as const;

export type DevicesFirmwareDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof devicesFirmwareDestroy>>>;
export type DevicesFirmwareDestroyMutationError = unknown;

export const useDevicesFirmwareDestroy = <TError = unknown>(
    id: number,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof devicesFirmwareDestroy>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof devicesFirmwareDestroy>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof devicesFirmwareDestroyMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesFirmwareDestroyMutationKey(id);
    const swrFn = getDevicesFirmwareDestroyMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesFwdownloadRetrieveUrl = () => {
    return `/api/devices/fwdownload`;
};

export const devicesFwdownloadRetrieve = async (options?: RequestInit): Promise<void> => {
    return devicesFwdownloadRetrieveMutator<void>(getDevicesFwdownloadRetrieveUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getDevicesFwdownloadRetrieveKey = () => [`/api/devices/fwdownload`] as const;

export type DevicesFwdownloadRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof devicesFwdownloadRetrieve>>>;
export type DevicesFwdownloadRetrieveQueryError = unknown;

export const useDevicesFwdownloadRetrieve = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof devicesFwdownloadRetrieve>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof devicesFwdownloadRetrieveMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getDevicesFwdownloadRetrieveKey() : null));
    const swrFn = () => devicesFwdownloadRetrieve(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesFwupdateRetrieveUrl = () => {
    return `/api/devices/fwupdate`;
};

export const devicesFwupdateRetrieve = async (options?: RequestInit): Promise<void> => {
    return devicesFwupdateRetrieveMutator<void>(getDevicesFwupdateRetrieveUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getDevicesFwupdateRetrieveKey = () => [`/api/devices/fwupdate`] as const;

export type DevicesFwupdateRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof devicesFwupdateRetrieve>>>;
export type DevicesFwupdateRetrieveQueryError = unknown;

export const useDevicesFwupdateRetrieve = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof devicesFwupdateRetrieve>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof devicesFwupdateRetrieveMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getDevicesFwupdateRetrieveKey() : null));
    const swrFn = () => devicesFwupdateRetrieve(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesMaindevicesListUrl = () => {
    return `/api/devices/maindevices/`;
};

export const devicesMaindevicesList = async (options?: RequestInit): Promise<Device[]> => {
    return devicesMaindevicesListMutator<Device[]>(getDevicesMaindevicesListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getDevicesMaindevicesListKey = () => [`/api/devices/maindevices/`] as const;

export type DevicesMaindevicesListQueryResult = NonNullable<Awaited<ReturnType<typeof devicesMaindevicesList>>>;
export type DevicesMaindevicesListQueryError = unknown;

export const useDevicesMaindevicesList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof devicesMaindevicesList>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof devicesMaindevicesListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getDevicesMaindevicesListKey() : null));
    const swrFn = () => devicesMaindevicesList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesMaindevicesCreateUrl = () => {
    return `/api/devices/maindevices/`;
};

export const devicesMaindevicesCreate = async (
    deviceRequest: DeviceRequest,
    options?: RequestInit,
): Promise<Device> => {
    return devicesMaindevicesCreateMutator<Device>(getDevicesMaindevicesCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(deviceRequest),
    });
};

export const getDevicesMaindevicesCreateMutationFetcher = (
    options?: SecondParameter<typeof devicesMaindevicesCreateMutator>,
) => {
    return (_: Key, { arg }: { arg: DeviceRequest }) => {
        return devicesMaindevicesCreate(arg, options);
    };
};
export const getDevicesMaindevicesCreateMutationKey = () => [`/api/devices/maindevices/`] as const;

export type DevicesMaindevicesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof devicesMaindevicesCreate>>>;
export type DevicesMaindevicesCreateMutationError = unknown;

export const useDevicesMaindevicesCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof devicesMaindevicesCreate>>,
        TError,
        Key,
        DeviceRequest,
        Awaited<ReturnType<typeof devicesMaindevicesCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof devicesMaindevicesCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesMaindevicesCreateMutationKey();
    const swrFn = getDevicesMaindevicesCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesMaindevicesRetrieveUrl = (id: string) => {
    return `/api/devices/maindevices/${id}/`;
};

export const devicesMaindevicesRetrieve = async (id: string, options?: RequestInit): Promise<Device> => {
    return devicesMaindevicesRetrieveMutator<Device>(getDevicesMaindevicesRetrieveUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getDevicesMaindevicesRetrieveKey = (id: string) => [`/api/devices/maindevices/${id}/`] as const;

export type DevicesMaindevicesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof devicesMaindevicesRetrieve>>>;
export type DevicesMaindevicesRetrieveQueryError = unknown;

export const useDevicesMaindevicesRetrieve = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof devicesMaindevicesRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof devicesMaindevicesRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getDevicesMaindevicesRetrieveKey(id) : null));
    const swrFn = () => devicesMaindevicesRetrieve(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesMaindevicesUpdateUrl = (id: string) => {
    return `/api/devices/maindevices/${id}/`;
};

export const devicesMaindevicesUpdate = async (
    id: string,
    deviceRequest: DeviceRequest,
    options?: RequestInit,
): Promise<Device> => {
    return devicesMaindevicesUpdateMutator<Device>(getDevicesMaindevicesUpdateUrl(id), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(deviceRequest),
    });
};

export const getDevicesMaindevicesUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof devicesMaindevicesUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: DeviceRequest }) => {
        return devicesMaindevicesUpdate(id, arg, options);
    };
};
export const getDevicesMaindevicesUpdateMutationKey = (id: string) => [`/api/devices/maindevices/${id}/`] as const;

export type DevicesMaindevicesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof devicesMaindevicesUpdate>>>;
export type DevicesMaindevicesUpdateMutationError = unknown;

export const useDevicesMaindevicesUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof devicesMaindevicesUpdate>>,
            TError,
            Key,
            DeviceRequest,
            Awaited<ReturnType<typeof devicesMaindevicesUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof devicesMaindevicesUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesMaindevicesUpdateMutationKey(id);
    const swrFn = getDevicesMaindevicesUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesMaindevicesPartialUpdateUrl = (id: string) => {
    return `/api/devices/maindevices/${id}/`;
};

export const devicesMaindevicesPartialUpdate = async (
    id: string,
    patchedDeviceRequest: PatchedDeviceRequest,
    options?: RequestInit,
): Promise<Device> => {
    return devicesMaindevicesPartialUpdateMutator<Device>(getDevicesMaindevicesPartialUpdateUrl(id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(patchedDeviceRequest),
    });
};

export const getDevicesMaindevicesPartialUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof devicesMaindevicesPartialUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: PatchedDeviceRequest }) => {
        return devicesMaindevicesPartialUpdate(id, arg, options);
    };
};
export const getDevicesMaindevicesPartialUpdateMutationKey = (id: string) =>
    [`/api/devices/maindevices/${id}/`] as const;

export type DevicesMaindevicesPartialUpdateMutationResult = NonNullable<
    Awaited<ReturnType<typeof devicesMaindevicesPartialUpdate>>
>;
export type DevicesMaindevicesPartialUpdateMutationError = unknown;

export const useDevicesMaindevicesPartialUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof devicesMaindevicesPartialUpdate>>,
            TError,
            Key,
            PatchedDeviceRequest,
            Awaited<ReturnType<typeof devicesMaindevicesPartialUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof devicesMaindevicesPartialUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesMaindevicesPartialUpdateMutationKey(id);
    const swrFn = getDevicesMaindevicesPartialUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesMaindevicesDestroyUrl = (id: string) => {
    return `/api/devices/maindevices/${id}/`;
};

export const devicesMaindevicesDestroy = async (id: string, options?: RequestInit): Promise<void> => {
    return devicesMaindevicesDestroyMutator<void>(getDevicesMaindevicesDestroyUrl(id), {
        ...options,
        method: 'DELETE',
    });
};

export const getDevicesMaindevicesDestroyMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof devicesMaindevicesDestroyMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return devicesMaindevicesDestroy(id, options);
    };
};
export const getDevicesMaindevicesDestroyMutationKey = (id: string) => [`/api/devices/maindevices/${id}/`] as const;

export type DevicesMaindevicesDestroyMutationResult = NonNullable<
    Awaited<ReturnType<typeof devicesMaindevicesDestroy>>
>;
export type DevicesMaindevicesDestroyMutationError = unknown;

export const useDevicesMaindevicesDestroy = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof devicesMaindevicesDestroy>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof devicesMaindevicesDestroy>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof devicesMaindevicesDestroyMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesMaindevicesDestroyMutationKey(id);
    const swrFn = getDevicesMaindevicesDestroyMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesNewLayerCreateUrl = () => {
    return `/api/devices/new_layer`;
};

export const devicesNewLayerCreate = async (options?: RequestInit): Promise<void> => {
    return devicesNewLayerCreateMutator<void>(getDevicesNewLayerCreateUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getDevicesNewLayerCreateMutationFetcher = (
    options?: SecondParameter<typeof devicesNewLayerCreateMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return devicesNewLayerCreate(options);
    };
};
export const getDevicesNewLayerCreateMutationKey = () => [`/api/devices/new_layer`] as const;

export type DevicesNewLayerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof devicesNewLayerCreate>>>;
export type DevicesNewLayerCreateMutationError = unknown;

export const useDevicesNewLayerCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof devicesNewLayerCreate>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof devicesNewLayerCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof devicesNewLayerCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesNewLayerCreateMutationKey();
    const swrFn = getDevicesNewLayerCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesRebindAllCreateUrl = () => {
    return `/api/devices/rebind_all`;
};

export const devicesRebindAllCreate = async (options?: RequestInit): Promise<void> => {
    return devicesRebindAllCreateMutator<void>(getDevicesRebindAllCreateUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getDevicesRebindAllCreateMutationFetcher = (
    options?: SecondParameter<typeof devicesRebindAllCreateMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return devicesRebindAllCreate(options);
    };
};
export const getDevicesRebindAllCreateMutationKey = () => [`/api/devices/rebind_all`] as const;

export type DevicesRebindAllCreateMutationResult = NonNullable<Awaited<ReturnType<typeof devicesRebindAllCreate>>>;
export type DevicesRebindAllCreateMutationError = unknown;

export const useDevicesRebindAllCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof devicesRebindAllCreate>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof devicesRebindAllCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof devicesRebindAllCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesRebindAllCreateMutationKey();
    const swrFn = getDevicesRebindAllCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesRemoveaddressDestroyUrl = () => {
    return `/api/devices/removeaddress`;
};

export const devicesRemoveaddressDestroy = async (options?: RequestInit): Promise<void> => {
    return devicesRemoveaddressDestroyMutator<void>(getDevicesRemoveaddressDestroyUrl(), {
        ...options,
        method: 'DELETE',
    });
};

export const getDevicesRemoveaddressDestroyMutationFetcher = (
    options?: SecondParameter<typeof devicesRemoveaddressDestroyMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return devicesRemoveaddressDestroy(options);
    };
};
export const getDevicesRemoveaddressDestroyMutationKey = () => [`/api/devices/removeaddress`] as const;

export type DevicesRemoveaddressDestroyMutationResult = NonNullable<
    Awaited<ReturnType<typeof devicesRemoveaddressDestroy>>
>;
export type DevicesRemoveaddressDestroyMutationError = unknown;

export const useDevicesRemoveaddressDestroy = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof devicesRemoveaddressDestroy>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof devicesRemoveaddressDestroy>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof devicesRemoveaddressDestroyMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesRemoveaddressDestroyMutationKey();
    const swrFn = getDevicesRemoveaddressDestroyMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesRemoveaddressdevgroupDestroyUrl = () => {
    return `/api/devices/removeaddressdevgroup`;
};

export const devicesRemoveaddressdevgroupDestroy = async (options?: RequestInit): Promise<void> => {
    return devicesRemoveaddressdevgroupDestroyMutator<void>(getDevicesRemoveaddressdevgroupDestroyUrl(), {
        ...options,
        method: 'DELETE',
    });
};

export const getDevicesRemoveaddressdevgroupDestroyMutationFetcher = (
    options?: SecondParameter<typeof devicesRemoveaddressdevgroupDestroyMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return devicesRemoveaddressdevgroupDestroy(options);
    };
};
export const getDevicesRemoveaddressdevgroupDestroyMutationKey = () => [`/api/devices/removeaddressdevgroup`] as const;

export type DevicesRemoveaddressdevgroupDestroyMutationResult = NonNullable<
    Awaited<ReturnType<typeof devicesRemoveaddressdevgroupDestroy>>
>;
export type DevicesRemoveaddressdevgroupDestroyMutationError = unknown;

export const useDevicesRemoveaddressdevgroupDestroy = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof devicesRemoveaddressdevgroupDestroy>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof devicesRemoveaddressdevgroupDestroy>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof devicesRemoveaddressdevgroupDestroyMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesRemoveaddressdevgroupDestroyMutationKey();
    const swrFn = getDevicesRemoveaddressdevgroupDestroyMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesScreenListUrl = () => {
    return `/api/devices/screen/`;
};

export const devicesScreenList = async (options?: RequestInit): Promise<Screen[]> => {
    return devicesScreenListMutator<Screen[]>(getDevicesScreenListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getDevicesScreenListKey = () => [`/api/devices/screen/`] as const;

export type DevicesScreenListQueryResult = NonNullable<Awaited<ReturnType<typeof devicesScreenList>>>;
export type DevicesScreenListQueryError = unknown;

export const useDevicesScreenList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof devicesScreenList>>, TError> & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof devicesScreenListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getDevicesScreenListKey() : null));
    const swrFn = () => devicesScreenList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesScreenCreateUrl = () => {
    return `/api/devices/screen/`;
};

export const devicesScreenCreate = async (screenRequest: ScreenRequest, options?: RequestInit): Promise<Screen> => {
    return devicesScreenCreateMutator<Screen>(getDevicesScreenCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(screenRequest),
    });
};

export const getDevicesScreenCreateMutationFetcher = (options?: SecondParameter<typeof devicesScreenCreateMutator>) => {
    return (_: Key, { arg }: { arg: ScreenRequest }) => {
        return devicesScreenCreate(arg, options);
    };
};
export const getDevicesScreenCreateMutationKey = () => [`/api/devices/screen/`] as const;

export type DevicesScreenCreateMutationResult = NonNullable<Awaited<ReturnType<typeof devicesScreenCreate>>>;
export type DevicesScreenCreateMutationError = unknown;

export const useDevicesScreenCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof devicesScreenCreate>>,
        TError,
        Key,
        ScreenRequest,
        Awaited<ReturnType<typeof devicesScreenCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof devicesScreenCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesScreenCreateMutationKey();
    const swrFn = getDevicesScreenCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesScreenRetrieveUrl = (id: string) => {
    return `/api/devices/screen/${id}/`;
};

export const devicesScreenRetrieve = async (id: string, options?: RequestInit): Promise<Screen> => {
    return devicesScreenRetrieveMutator<Screen>(getDevicesScreenRetrieveUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getDevicesScreenRetrieveKey = (id: string) => [`/api/devices/screen/${id}/`] as const;

export type DevicesScreenRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof devicesScreenRetrieve>>>;
export type DevicesScreenRetrieveQueryError = unknown;

export const useDevicesScreenRetrieve = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof devicesScreenRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof devicesScreenRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getDevicesScreenRetrieveKey(id) : null));
    const swrFn = () => devicesScreenRetrieve(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesScreenDestroyUrl = (id: string) => {
    return `/api/devices/screen/${id}/`;
};

export const devicesScreenDestroy = async (id: string, options?: RequestInit): Promise<void> => {
    return devicesScreenDestroyMutator<void>(getDevicesScreenDestroyUrl(id), {
        ...options,
        method: 'DELETE',
    });
};

export const getDevicesScreenDestroyMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof devicesScreenDestroyMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return devicesScreenDestroy(id, options);
    };
};
export const getDevicesScreenDestroyMutationKey = (id: string) => [`/api/devices/screen/${id}/`] as const;

export type DevicesScreenDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof devicesScreenDestroy>>>;
export type DevicesScreenDestroyMutationError = unknown;

export const useDevicesScreenDestroy = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof devicesScreenDestroy>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof devicesScreenDestroy>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof devicesScreenDestroyMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesScreenDestroyMutationKey(id);
    const swrFn = getDevicesScreenDestroyMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesSiteListUrl = () => {
    return `/api/devices/site/`;
};

export const devicesSiteList = async (options?: RequestInit): Promise<Site[]> => {
    return devicesSiteListMutator<Site[]>(getDevicesSiteListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getDevicesSiteListKey = () => [`/api/devices/site/`] as const;

export type DevicesSiteListQueryResult = NonNullable<Awaited<ReturnType<typeof devicesSiteList>>>;
export type DevicesSiteListQueryError = unknown;

export const useDevicesSiteList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof devicesSiteList>>, TError> & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof devicesSiteListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getDevicesSiteListKey() : null));
    const swrFn = () => devicesSiteList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesSiteCreateUrl = () => {
    return `/api/devices/site/`;
};

export const devicesSiteCreate = async (siteRequest: SiteRequest, options?: RequestInit): Promise<Site> => {
    return devicesSiteCreateMutator<Site>(getDevicesSiteCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(siteRequest),
    });
};

export const getDevicesSiteCreateMutationFetcher = (options?: SecondParameter<typeof devicesSiteCreateMutator>) => {
    return (_: Key, { arg }: { arg: SiteRequest }) => {
        return devicesSiteCreate(arg, options);
    };
};
export const getDevicesSiteCreateMutationKey = () => [`/api/devices/site/`] as const;

export type DevicesSiteCreateMutationResult = NonNullable<Awaited<ReturnType<typeof devicesSiteCreate>>>;
export type DevicesSiteCreateMutationError = unknown;

export const useDevicesSiteCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof devicesSiteCreate>>,
        TError,
        Key,
        SiteRequest,
        Awaited<ReturnType<typeof devicesSiteCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof devicesSiteCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesSiteCreateMutationKey();
    const swrFn = getDevicesSiteCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesSiteRetrieveUrl = (id: string) => {
    return `/api/devices/site/${id}/`;
};

export const devicesSiteRetrieve = async (id: string, options?: RequestInit): Promise<Site> => {
    return devicesSiteRetrieveMutator<Site>(getDevicesSiteRetrieveUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getDevicesSiteRetrieveKey = (id: string) => [`/api/devices/site/${id}/`] as const;

export type DevicesSiteRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof devicesSiteRetrieve>>>;
export type DevicesSiteRetrieveQueryError = unknown;

export const useDevicesSiteRetrieve = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof devicesSiteRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof devicesSiteRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getDevicesSiteRetrieveKey(id) : null));
    const swrFn = () => devicesSiteRetrieve(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesSiteUpdateUrl = (id: string) => {
    return `/api/devices/site/${id}/`;
};

export const devicesSiteUpdate = async (id: string, siteRequest: SiteRequest, options?: RequestInit): Promise<Site> => {
    return devicesSiteUpdateMutator<Site>(getDevicesSiteUpdateUrl(id), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(siteRequest),
    });
};

export const getDevicesSiteUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof devicesSiteUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: SiteRequest }) => {
        return devicesSiteUpdate(id, arg, options);
    };
};
export const getDevicesSiteUpdateMutationKey = (id: string) => [`/api/devices/site/${id}/`] as const;

export type DevicesSiteUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof devicesSiteUpdate>>>;
export type DevicesSiteUpdateMutationError = unknown;

export const useDevicesSiteUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof devicesSiteUpdate>>,
            TError,
            Key,
            SiteRequest,
            Awaited<ReturnType<typeof devicesSiteUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof devicesSiteUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesSiteUpdateMutationKey(id);
    const swrFn = getDevicesSiteUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesSitePartialUpdateUrl = (id: string) => {
    return `/api/devices/site/${id}/`;
};

export const devicesSitePartialUpdate = async (
    id: string,
    patchedSiteRequest: PatchedSiteRequest,
    options?: RequestInit,
): Promise<Site> => {
    return devicesSitePartialUpdateMutator<Site>(getDevicesSitePartialUpdateUrl(id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(patchedSiteRequest),
    });
};

export const getDevicesSitePartialUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof devicesSitePartialUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: PatchedSiteRequest }) => {
        return devicesSitePartialUpdate(id, arg, options);
    };
};
export const getDevicesSitePartialUpdateMutationKey = (id: string) => [`/api/devices/site/${id}/`] as const;

export type DevicesSitePartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof devicesSitePartialUpdate>>>;
export type DevicesSitePartialUpdateMutationError = unknown;

export const useDevicesSitePartialUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof devicesSitePartialUpdate>>,
            TError,
            Key,
            PatchedSiteRequest,
            Awaited<ReturnType<typeof devicesSitePartialUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof devicesSitePartialUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesSitePartialUpdateMutationKey(id);
    const swrFn = getDevicesSitePartialUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesSiteDestroyUrl = (id: string) => {
    return `/api/devices/site/${id}/`;
};

export const devicesSiteDestroy = async (id: string, options?: RequestInit): Promise<void> => {
    return devicesSiteDestroyMutator<void>(getDevicesSiteDestroyUrl(id), {
        ...options,
        method: 'DELETE',
    });
};

export const getDevicesSiteDestroyMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof devicesSiteDestroyMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return devicesSiteDestroy(id, options);
    };
};
export const getDevicesSiteDestroyMutationKey = (id: string) => [`/api/devices/site/${id}/`] as const;

export type DevicesSiteDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof devicesSiteDestroy>>>;
export type DevicesSiteDestroyMutationError = unknown;

export const useDevicesSiteDestroy = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof devicesSiteDestroy>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof devicesSiteDestroy>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof devicesSiteDestroyMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesSiteDestroyMutationKey(id);
    const swrFn = getDevicesSiteDestroyMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesSiteselectListUrl = () => {
    return `/api/devices/siteselect/`;
};

export const devicesSiteselectList = async (options?: RequestInit): Promise<SiteSelect[]> => {
    return devicesSiteselectListMutator<SiteSelect[]>(getDevicesSiteselectListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getDevicesSiteselectListKey = () => [`/api/devices/siteselect/`] as const;

export type DevicesSiteselectListQueryResult = NonNullable<Awaited<ReturnType<typeof devicesSiteselectList>>>;
export type DevicesSiteselectListQueryError = unknown;

export const useDevicesSiteselectList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof devicesSiteselectList>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof devicesSiteselectListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getDevicesSiteselectListKey() : null));
    const swrFn = () => devicesSiteselectList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesTypeListUrl = () => {
    return `/api/devices/type/`;
};

export const devicesTypeList = async (options?: RequestInit): Promise<TypeSerialzer[]> => {
    return devicesTypeListMutator<TypeSerialzer[]>(getDevicesTypeListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getDevicesTypeListKey = () => [`/api/devices/type/`] as const;

export type DevicesTypeListQueryResult = NonNullable<Awaited<ReturnType<typeof devicesTypeList>>>;
export type DevicesTypeListQueryError = unknown;

export const useDevicesTypeList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof devicesTypeList>>, TError> & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof devicesTypeListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getDevicesTypeListKey() : null));
    const swrFn = () => devicesTypeList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesTypeCreateUrl = () => {
    return `/api/devices/type/`;
};

export const devicesTypeCreate = async (
    typeSerialzerRequest: TypeSerialzerRequest,
    options?: RequestInit,
): Promise<TypeSerialzer> => {
    return devicesTypeCreateMutator<TypeSerialzer>(getDevicesTypeCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(typeSerialzerRequest),
    });
};

export const getDevicesTypeCreateMutationFetcher = (options?: SecondParameter<typeof devicesTypeCreateMutator>) => {
    return (_: Key, { arg }: { arg: TypeSerialzerRequest }) => {
        return devicesTypeCreate(arg, options);
    };
};
export const getDevicesTypeCreateMutationKey = () => [`/api/devices/type/`] as const;

export type DevicesTypeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof devicesTypeCreate>>>;
export type DevicesTypeCreateMutationError = unknown;

export const useDevicesTypeCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof devicesTypeCreate>>,
        TError,
        Key,
        TypeSerialzerRequest,
        Awaited<ReturnType<typeof devicesTypeCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof devicesTypeCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesTypeCreateMutationKey();
    const swrFn = getDevicesTypeCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesTypeRetrieveUrl = (id: string) => {
    return `/api/devices/type/${id}/`;
};

export const devicesTypeRetrieve = async (id: string, options?: RequestInit): Promise<TypeSerialzer> => {
    return devicesTypeRetrieveMutator<TypeSerialzer>(getDevicesTypeRetrieveUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getDevicesTypeRetrieveKey = (id: string) => [`/api/devices/type/${id}/`] as const;

export type DevicesTypeRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof devicesTypeRetrieve>>>;
export type DevicesTypeRetrieveQueryError = unknown;

export const useDevicesTypeRetrieve = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof devicesTypeRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof devicesTypeRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getDevicesTypeRetrieveKey(id) : null));
    const swrFn = () => devicesTypeRetrieve(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesTypeUpdateUrl = (id: string) => {
    return `/api/devices/type/${id}/`;
};

export const devicesTypeUpdate = async (
    id: string,
    typeSerialzerRequest: TypeSerialzerRequest,
    options?: RequestInit,
): Promise<TypeSerialzer> => {
    return devicesTypeUpdateMutator<TypeSerialzer>(getDevicesTypeUpdateUrl(id), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(typeSerialzerRequest),
    });
};

export const getDevicesTypeUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof devicesTypeUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: TypeSerialzerRequest }) => {
        return devicesTypeUpdate(id, arg, options);
    };
};
export const getDevicesTypeUpdateMutationKey = (id: string) => [`/api/devices/type/${id}/`] as const;

export type DevicesTypeUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof devicesTypeUpdate>>>;
export type DevicesTypeUpdateMutationError = unknown;

export const useDevicesTypeUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof devicesTypeUpdate>>,
            TError,
            Key,
            TypeSerialzerRequest,
            Awaited<ReturnType<typeof devicesTypeUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof devicesTypeUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesTypeUpdateMutationKey(id);
    const swrFn = getDevicesTypeUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesTypePartialUpdateUrl = (id: string) => {
    return `/api/devices/type/${id}/`;
};

export const devicesTypePartialUpdate = async (
    id: string,
    patchedTypeSerialzerRequest: PatchedTypeSerialzerRequest,
    options?: RequestInit,
): Promise<TypeSerialzer> => {
    return devicesTypePartialUpdateMutator<TypeSerialzer>(getDevicesTypePartialUpdateUrl(id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(patchedTypeSerialzerRequest),
    });
};

export const getDevicesTypePartialUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof devicesTypePartialUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: PatchedTypeSerialzerRequest }) => {
        return devicesTypePartialUpdate(id, arg, options);
    };
};
export const getDevicesTypePartialUpdateMutationKey = (id: string) => [`/api/devices/type/${id}/`] as const;

export type DevicesTypePartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof devicesTypePartialUpdate>>>;
export type DevicesTypePartialUpdateMutationError = unknown;

export const useDevicesTypePartialUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof devicesTypePartialUpdate>>,
            TError,
            Key,
            PatchedTypeSerialzerRequest,
            Awaited<ReturnType<typeof devicesTypePartialUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof devicesTypePartialUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesTypePartialUpdateMutationKey(id);
    const swrFn = getDevicesTypePartialUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesTypeDestroyUrl = (id: string) => {
    return `/api/devices/type/${id}/`;
};

export const devicesTypeDestroy = async (id: string, options?: RequestInit): Promise<void> => {
    return devicesTypeDestroyMutator<void>(getDevicesTypeDestroyUrl(id), {
        ...options,
        method: 'DELETE',
    });
};

export const getDevicesTypeDestroyMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof devicesTypeDestroyMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return devicesTypeDestroy(id, options);
    };
};
export const getDevicesTypeDestroyMutationKey = (id: string) => [`/api/devices/type/${id}/`] as const;

export type DevicesTypeDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof devicesTypeDestroy>>>;
export type DevicesTypeDestroyMutationError = unknown;

export const useDevicesTypeDestroy = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof devicesTypeDestroy>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof devicesTypeDestroy>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof devicesTypeDestroyMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesTypeDestroyMutationKey(id);
    const swrFn = getDevicesTypeDestroyMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesUnboundListUrl = () => {
    return `/api/devices/unbound/`;
};

export const devicesUnboundList = async (options?: RequestInit): Promise<Device[]> => {
    return devicesUnboundListMutator<Device[]>(getDevicesUnboundListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getDevicesUnboundListKey = () => [`/api/devices/unbound/`] as const;

export type DevicesUnboundListQueryResult = NonNullable<Awaited<ReturnType<typeof devicesUnboundList>>>;
export type DevicesUnboundListQueryError = unknown;

export const useDevicesUnboundList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof devicesUnboundList>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof devicesUnboundListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getDevicesUnboundListKey() : null));
    const swrFn = () => devicesUnboundList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesUnboundCreateUrl = () => {
    return `/api/devices/unbound/`;
};

export const devicesUnboundCreate = async (deviceRequest: DeviceRequest, options?: RequestInit): Promise<Device> => {
    return devicesUnboundCreateMutator<Device>(getDevicesUnboundCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(deviceRequest),
    });
};

export const getDevicesUnboundCreateMutationFetcher = (
    options?: SecondParameter<typeof devicesUnboundCreateMutator>,
) => {
    return (_: Key, { arg }: { arg: DeviceRequest }) => {
        return devicesUnboundCreate(arg, options);
    };
};
export const getDevicesUnboundCreateMutationKey = () => [`/api/devices/unbound/`] as const;

export type DevicesUnboundCreateMutationResult = NonNullable<Awaited<ReturnType<typeof devicesUnboundCreate>>>;
export type DevicesUnboundCreateMutationError = unknown;

export const useDevicesUnboundCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof devicesUnboundCreate>>,
        TError,
        Key,
        DeviceRequest,
        Awaited<ReturnType<typeof devicesUnboundCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof devicesUnboundCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesUnboundCreateMutationKey();
    const swrFn = getDevicesUnboundCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesUnboundRetrieveUrl = (id: string) => {
    return `/api/devices/unbound/${id}/`;
};

export const devicesUnboundRetrieve = async (id: string, options?: RequestInit): Promise<Device> => {
    return devicesUnboundRetrieveMutator<Device>(getDevicesUnboundRetrieveUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getDevicesUnboundRetrieveKey = (id: string) => [`/api/devices/unbound/${id}/`] as const;

export type DevicesUnboundRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof devicesUnboundRetrieve>>>;
export type DevicesUnboundRetrieveQueryError = unknown;

export const useDevicesUnboundRetrieve = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof devicesUnboundRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof devicesUnboundRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getDevicesUnboundRetrieveKey(id) : null));
    const swrFn = () => devicesUnboundRetrieve(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesUnboundUpdateUrl = (id: string) => {
    return `/api/devices/unbound/${id}/`;
};

export const devicesUnboundUpdate = async (
    id: string,
    deviceRequest: DeviceRequest,
    options?: RequestInit,
): Promise<Device> => {
    return devicesUnboundUpdateMutator<Device>(getDevicesUnboundUpdateUrl(id), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(deviceRequest),
    });
};

export const getDevicesUnboundUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof devicesUnboundUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: DeviceRequest }) => {
        return devicesUnboundUpdate(id, arg, options);
    };
};
export const getDevicesUnboundUpdateMutationKey = (id: string) => [`/api/devices/unbound/${id}/`] as const;

export type DevicesUnboundUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof devicesUnboundUpdate>>>;
export type DevicesUnboundUpdateMutationError = unknown;

export const useDevicesUnboundUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof devicesUnboundUpdate>>,
            TError,
            Key,
            DeviceRequest,
            Awaited<ReturnType<typeof devicesUnboundUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof devicesUnboundUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesUnboundUpdateMutationKey(id);
    const swrFn = getDevicesUnboundUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesUnboundPartialUpdateUrl = (id: string) => {
    return `/api/devices/unbound/${id}/`;
};

export const devicesUnboundPartialUpdate = async (
    id: string,
    patchedDeviceRequest: PatchedDeviceRequest,
    options?: RequestInit,
): Promise<Device> => {
    return devicesUnboundPartialUpdateMutator<Device>(getDevicesUnboundPartialUpdateUrl(id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(patchedDeviceRequest),
    });
};

export const getDevicesUnboundPartialUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof devicesUnboundPartialUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: PatchedDeviceRequest }) => {
        return devicesUnboundPartialUpdate(id, arg, options);
    };
};
export const getDevicesUnboundPartialUpdateMutationKey = (id: string) => [`/api/devices/unbound/${id}/`] as const;

export type DevicesUnboundPartialUpdateMutationResult = NonNullable<
    Awaited<ReturnType<typeof devicesUnboundPartialUpdate>>
>;
export type DevicesUnboundPartialUpdateMutationError = unknown;

export const useDevicesUnboundPartialUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof devicesUnboundPartialUpdate>>,
            TError,
            Key,
            PatchedDeviceRequest,
            Awaited<ReturnType<typeof devicesUnboundPartialUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof devicesUnboundPartialUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesUnboundPartialUpdateMutationKey(id);
    const swrFn = getDevicesUnboundPartialUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesUnboundDestroyUrl = (id: string) => {
    return `/api/devices/unbound/${id}/`;
};

export const devicesUnboundDestroy = async (id: string, options?: RequestInit): Promise<void> => {
    return devicesUnboundDestroyMutator<void>(getDevicesUnboundDestroyUrl(id), {
        ...options,
        method: 'DELETE',
    });
};

export const getDevicesUnboundDestroyMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof devicesUnboundDestroyMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return devicesUnboundDestroy(id, options);
    };
};
export const getDevicesUnboundDestroyMutationKey = (id: string) => [`/api/devices/unbound/${id}/`] as const;

export type DevicesUnboundDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof devicesUnboundDestroy>>>;
export type DevicesUnboundDestroyMutationError = unknown;

export const useDevicesUnboundDestroy = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof devicesUnboundDestroy>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof devicesUnboundDestroy>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof devicesUnboundDestroyMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesUnboundDestroyMutationKey(id);
    const swrFn = getDevicesUnboundDestroyMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesUpdateLayerPartialUpdateUrl = () => {
    return `/api/devices/update_layer`;
};

export const devicesUpdateLayerPartialUpdate = async (options?: RequestInit): Promise<void> => {
    return devicesUpdateLayerPartialUpdateMutator<void>(getDevicesUpdateLayerPartialUpdateUrl(), {
        ...options,
        method: 'PATCH',
    });
};

export const getDevicesUpdateLayerPartialUpdateMutationFetcher = (
    options?: SecondParameter<typeof devicesUpdateLayerPartialUpdateMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return devicesUpdateLayerPartialUpdate(options);
    };
};
export const getDevicesUpdateLayerPartialUpdateMutationKey = () => [`/api/devices/update_layer`] as const;

export type DevicesUpdateLayerPartialUpdateMutationResult = NonNullable<
    Awaited<ReturnType<typeof devicesUpdateLayerPartialUpdate>>
>;
export type DevicesUpdateLayerPartialUpdateMutationError = unknown;

export const useDevicesUpdateLayerPartialUpdate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof devicesUpdateLayerPartialUpdate>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof devicesUpdateLayerPartialUpdate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof devicesUpdateLayerPartialUpdateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getDevicesUpdateLayerPartialUpdateMutationKey();
    const swrFn = getDevicesUpdateLayerPartialUpdateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getDevicesValidScreenRetrieveUrl = () => {
    return `/api/devices/valid_screen`;
};

export const devicesValidScreenRetrieve = async (options?: RequestInit): Promise<void> => {
    return devicesValidScreenRetrieveMutator<void>(getDevicesValidScreenRetrieveUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getDevicesValidScreenRetrieveKey = () => [`/api/devices/valid_screen`] as const;

export type DevicesValidScreenRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof devicesValidScreenRetrieve>>>;
export type DevicesValidScreenRetrieveQueryError = unknown;

export const useDevicesValidScreenRetrieve = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof devicesValidScreenRetrieve>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof devicesValidScreenRetrieveMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getDevicesValidScreenRetrieveKey() : null));
    const swrFn = () => devicesValidScreenRetrieve(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getMapsAreaListUrl = () => {
    return `/api/maps/area/`;
};

export const mapsAreaList = async (options?: RequestInit): Promise<Area[]> => {
    return mapsAreaListMutator<Area[]>(getMapsAreaListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getMapsAreaListKey = () => [`/api/maps/area/`] as const;

export type MapsAreaListQueryResult = NonNullable<Awaited<ReturnType<typeof mapsAreaList>>>;
export type MapsAreaListQueryError = unknown;

export const useMapsAreaList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof mapsAreaList>>, TError> & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof mapsAreaListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getMapsAreaListKey() : null));
    const swrFn = () => mapsAreaList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getMapsAreaCreateUrl = () => {
    return `/api/maps/area/`;
};

export const mapsAreaCreate = async (areaRequest: AreaRequest, options?: RequestInit): Promise<Area> => {
    return mapsAreaCreateMutator<Area>(getMapsAreaCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(areaRequest),
    });
};

export const getMapsAreaCreateMutationFetcher = (options?: SecondParameter<typeof mapsAreaCreateMutator>) => {
    return (_: Key, { arg }: { arg: AreaRequest }) => {
        return mapsAreaCreate(arg, options);
    };
};
export const getMapsAreaCreateMutationKey = () => [`/api/maps/area/`] as const;

export type MapsAreaCreateMutationResult = NonNullable<Awaited<ReturnType<typeof mapsAreaCreate>>>;
export type MapsAreaCreateMutationError = unknown;

export const useMapsAreaCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof mapsAreaCreate>>,
        TError,
        Key,
        AreaRequest,
        Awaited<ReturnType<typeof mapsAreaCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof mapsAreaCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getMapsAreaCreateMutationKey();
    const swrFn = getMapsAreaCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getMapsAreaRetrieveUrl = (id: string) => {
    return `/api/maps/area/${id}/`;
};

export const mapsAreaRetrieve = async (id: string, options?: RequestInit): Promise<Area> => {
    return mapsAreaRetrieveMutator<Area>(getMapsAreaRetrieveUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getMapsAreaRetrieveKey = (id: string) => [`/api/maps/area/${id}/`] as const;

export type MapsAreaRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof mapsAreaRetrieve>>>;
export type MapsAreaRetrieveQueryError = unknown;

export const useMapsAreaRetrieve = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof mapsAreaRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof mapsAreaRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getMapsAreaRetrieveKey(id) : null));
    const swrFn = () => mapsAreaRetrieve(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getMapsAreaUpdateUrl = (id: string) => {
    return `/api/maps/area/${id}/`;
};

export const mapsAreaUpdate = async (id: string, areaRequest: AreaRequest, options?: RequestInit): Promise<Area> => {
    return mapsAreaUpdateMutator<Area>(getMapsAreaUpdateUrl(id), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(areaRequest),
    });
};

export const getMapsAreaUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof mapsAreaUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: AreaRequest }) => {
        return mapsAreaUpdate(id, arg, options);
    };
};
export const getMapsAreaUpdateMutationKey = (id: string) => [`/api/maps/area/${id}/`] as const;

export type MapsAreaUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof mapsAreaUpdate>>>;
export type MapsAreaUpdateMutationError = unknown;

export const useMapsAreaUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof mapsAreaUpdate>>,
            TError,
            Key,
            AreaRequest,
            Awaited<ReturnType<typeof mapsAreaUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof mapsAreaUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getMapsAreaUpdateMutationKey(id);
    const swrFn = getMapsAreaUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getMapsAreaPartialUpdateUrl = (id: string) => {
    return `/api/maps/area/${id}/`;
};

export const mapsAreaPartialUpdate = async (
    id: string,
    patchedAreaRequest: PatchedAreaRequest,
    options?: RequestInit,
): Promise<Area> => {
    return mapsAreaPartialUpdateMutator<Area>(getMapsAreaPartialUpdateUrl(id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(patchedAreaRequest),
    });
};

export const getMapsAreaPartialUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof mapsAreaPartialUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: PatchedAreaRequest }) => {
        return mapsAreaPartialUpdate(id, arg, options);
    };
};
export const getMapsAreaPartialUpdateMutationKey = (id: string) => [`/api/maps/area/${id}/`] as const;

export type MapsAreaPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof mapsAreaPartialUpdate>>>;
export type MapsAreaPartialUpdateMutationError = unknown;

export const useMapsAreaPartialUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof mapsAreaPartialUpdate>>,
            TError,
            Key,
            PatchedAreaRequest,
            Awaited<ReturnType<typeof mapsAreaPartialUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof mapsAreaPartialUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getMapsAreaPartialUpdateMutationKey(id);
    const swrFn = getMapsAreaPartialUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getMapsAreaDestroyUrl = (id: string) => {
    return `/api/maps/area/${id}/`;
};

export const mapsAreaDestroy = async (id: string, options?: RequestInit): Promise<void> => {
    return mapsAreaDestroyMutator<void>(getMapsAreaDestroyUrl(id), {
        ...options,
        method: 'DELETE',
    });
};

export const getMapsAreaDestroyMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof mapsAreaDestroyMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return mapsAreaDestroy(id, options);
    };
};
export const getMapsAreaDestroyMutationKey = (id: string) => [`/api/maps/area/${id}/`] as const;

export type MapsAreaDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof mapsAreaDestroy>>>;
export type MapsAreaDestroyMutationError = unknown;

export const useMapsAreaDestroy = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof mapsAreaDestroy>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof mapsAreaDestroy>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof mapsAreaDestroyMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getMapsAreaDestroyMutationKey(id);
    const swrFn = getMapsAreaDestroyMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getMapsAreasForDeviceRetrieveUrl = () => {
    return `/api/maps/areas_for_device`;
};

export const mapsAreasForDeviceRetrieve = async (options?: RequestInit): Promise<void> => {
    return mapsAreasForDeviceRetrieveMutator<void>(getMapsAreasForDeviceRetrieveUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getMapsAreasForDeviceRetrieveKey = () => [`/api/maps/areas_for_device`] as const;

export type MapsAreasForDeviceRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof mapsAreasForDeviceRetrieve>>>;
export type MapsAreasForDeviceRetrieveQueryError = unknown;

export const useMapsAreasForDeviceRetrieve = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof mapsAreasForDeviceRetrieve>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof mapsAreasForDeviceRetrieveMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getMapsAreasForDeviceRetrieveKey() : null));
    const swrFn = () => mapsAreasForDeviceRetrieve(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getMapsLayerListUrl = () => {
    return `/api/maps/layer/`;
};

export const mapsLayerList = async (options?: RequestInit): Promise<Layer[]> => {
    return mapsLayerListMutator<Layer[]>(getMapsLayerListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getMapsLayerListKey = () => [`/api/maps/layer/`] as const;

export type MapsLayerListQueryResult = NonNullable<Awaited<ReturnType<typeof mapsLayerList>>>;
export type MapsLayerListQueryError = unknown;

export const useMapsLayerList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof mapsLayerList>>, TError> & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof mapsLayerListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getMapsLayerListKey() : null));
    const swrFn = () => mapsLayerList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getMapsLayerCreateUrl = () => {
    return `/api/maps/layer/`;
};

export const mapsLayerCreate = async (layerRequest: LayerRequest, options?: RequestInit): Promise<Layer> => {
    return mapsLayerCreateMutator<Layer>(getMapsLayerCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(layerRequest),
    });
};

export const getMapsLayerCreateMutationFetcher = (options?: SecondParameter<typeof mapsLayerCreateMutator>) => {
    return (_: Key, { arg }: { arg: LayerRequest }) => {
        return mapsLayerCreate(arg, options);
    };
};
export const getMapsLayerCreateMutationKey = () => [`/api/maps/layer/`] as const;

export type MapsLayerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof mapsLayerCreate>>>;
export type MapsLayerCreateMutationError = unknown;

export const useMapsLayerCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof mapsLayerCreate>>,
        TError,
        Key,
        LayerRequest,
        Awaited<ReturnType<typeof mapsLayerCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof mapsLayerCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getMapsLayerCreateMutationKey();
    const swrFn = getMapsLayerCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getMapsLayerRetrieveUrl = (id: string) => {
    return `/api/maps/layer/${id}/`;
};

export const mapsLayerRetrieve = async (id: string, options?: RequestInit): Promise<Layer> => {
    return mapsLayerRetrieveMutator<Layer>(getMapsLayerRetrieveUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getMapsLayerRetrieveKey = (id: string) => [`/api/maps/layer/${id}/`] as const;

export type MapsLayerRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof mapsLayerRetrieve>>>;
export type MapsLayerRetrieveQueryError = unknown;

export const useMapsLayerRetrieve = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof mapsLayerRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof mapsLayerRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getMapsLayerRetrieveKey(id) : null));
    const swrFn = () => mapsLayerRetrieve(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getMapsLayerUpdateUrl = (id: string) => {
    return `/api/maps/layer/${id}/`;
};

export const mapsLayerUpdate = async (
    id: string,
    layerRequest: LayerRequest,
    options?: RequestInit,
): Promise<Layer> => {
    return mapsLayerUpdateMutator<Layer>(getMapsLayerUpdateUrl(id), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(layerRequest),
    });
};

export const getMapsLayerUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof mapsLayerUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: LayerRequest }) => {
        return mapsLayerUpdate(id, arg, options);
    };
};
export const getMapsLayerUpdateMutationKey = (id: string) => [`/api/maps/layer/${id}/`] as const;

export type MapsLayerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof mapsLayerUpdate>>>;
export type MapsLayerUpdateMutationError = unknown;

export const useMapsLayerUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof mapsLayerUpdate>>,
            TError,
            Key,
            LayerRequest,
            Awaited<ReturnType<typeof mapsLayerUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof mapsLayerUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getMapsLayerUpdateMutationKey(id);
    const swrFn = getMapsLayerUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getMapsLayerPartialUpdateUrl = (id: string) => {
    return `/api/maps/layer/${id}/`;
};

export const mapsLayerPartialUpdate = async (
    id: string,
    patchedLayerRequest: PatchedLayerRequest,
    options?: RequestInit,
): Promise<Layer> => {
    return mapsLayerPartialUpdateMutator<Layer>(getMapsLayerPartialUpdateUrl(id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(patchedLayerRequest),
    });
};

export const getMapsLayerPartialUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof mapsLayerPartialUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: PatchedLayerRequest }) => {
        return mapsLayerPartialUpdate(id, arg, options);
    };
};
export const getMapsLayerPartialUpdateMutationKey = (id: string) => [`/api/maps/layer/${id}/`] as const;

export type MapsLayerPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof mapsLayerPartialUpdate>>>;
export type MapsLayerPartialUpdateMutationError = unknown;

export const useMapsLayerPartialUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof mapsLayerPartialUpdate>>,
            TError,
            Key,
            PatchedLayerRequest,
            Awaited<ReturnType<typeof mapsLayerPartialUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof mapsLayerPartialUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getMapsLayerPartialUpdateMutationKey(id);
    const swrFn = getMapsLayerPartialUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getMapsLayerDestroyUrl = (id: string) => {
    return `/api/maps/layer/${id}/`;
};

export const mapsLayerDestroy = async (id: string, options?: RequestInit): Promise<void> => {
    return mapsLayerDestroyMutator<void>(getMapsLayerDestroyUrl(id), {
        ...options,
        method: 'DELETE',
    });
};

export const getMapsLayerDestroyMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof mapsLayerDestroyMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return mapsLayerDestroy(id, options);
    };
};
export const getMapsLayerDestroyMutationKey = (id: string) => [`/api/maps/layer/${id}/`] as const;

export type MapsLayerDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof mapsLayerDestroy>>>;
export type MapsLayerDestroyMutationError = unknown;

export const useMapsLayerDestroy = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof mapsLayerDestroy>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof mapsLayerDestroy>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof mapsLayerDestroyMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getMapsLayerDestroyMutationKey(id);
    const swrFn = getMapsLayerDestroyMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getMapsPointListUrl = () => {
    return `/api/maps/point/`;
};

export const mapsPointList = async (options?: RequestInit): Promise<Point[]> => {
    return mapsPointListMutator<Point[]>(getMapsPointListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getMapsPointListKey = () => [`/api/maps/point/`] as const;

export type MapsPointListQueryResult = NonNullable<Awaited<ReturnType<typeof mapsPointList>>>;
export type MapsPointListQueryError = unknown;

export const useMapsPointList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof mapsPointList>>, TError> & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof mapsPointListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getMapsPointListKey() : null));
    const swrFn = () => mapsPointList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getMapsPointCreateUrl = () => {
    return `/api/maps/point/`;
};

export const mapsPointCreate = async (pointRequest: PointRequest, options?: RequestInit): Promise<Point> => {
    return mapsPointCreateMutator<Point>(getMapsPointCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(pointRequest),
    });
};

export const getMapsPointCreateMutationFetcher = (options?: SecondParameter<typeof mapsPointCreateMutator>) => {
    return (_: Key, { arg }: { arg: PointRequest }) => {
        return mapsPointCreate(arg, options);
    };
};
export const getMapsPointCreateMutationKey = () => [`/api/maps/point/`] as const;

export type MapsPointCreateMutationResult = NonNullable<Awaited<ReturnType<typeof mapsPointCreate>>>;
export type MapsPointCreateMutationError = unknown;

export const useMapsPointCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof mapsPointCreate>>,
        TError,
        Key,
        PointRequest,
        Awaited<ReturnType<typeof mapsPointCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof mapsPointCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getMapsPointCreateMutationKey();
    const swrFn = getMapsPointCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getMapsPointRetrieveUrl = (id: string) => {
    return `/api/maps/point/${id}/`;
};

export const mapsPointRetrieve = async (id: string, options?: RequestInit): Promise<Point> => {
    return mapsPointRetrieveMutator<Point>(getMapsPointRetrieveUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getMapsPointRetrieveKey = (id: string) => [`/api/maps/point/${id}/`] as const;

export type MapsPointRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof mapsPointRetrieve>>>;
export type MapsPointRetrieveQueryError = unknown;

export const useMapsPointRetrieve = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof mapsPointRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof mapsPointRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getMapsPointRetrieveKey(id) : null));
    const swrFn = () => mapsPointRetrieve(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getMapsPointUpdateUrl = (id: string) => {
    return `/api/maps/point/${id}/`;
};

export const mapsPointUpdate = async (
    id: string,
    pointRequest: PointRequest,
    options?: RequestInit,
): Promise<Point> => {
    return mapsPointUpdateMutator<Point>(getMapsPointUpdateUrl(id), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(pointRequest),
    });
};

export const getMapsPointUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof mapsPointUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: PointRequest }) => {
        return mapsPointUpdate(id, arg, options);
    };
};
export const getMapsPointUpdateMutationKey = (id: string) => [`/api/maps/point/${id}/`] as const;

export type MapsPointUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof mapsPointUpdate>>>;
export type MapsPointUpdateMutationError = unknown;

export const useMapsPointUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof mapsPointUpdate>>,
            TError,
            Key,
            PointRequest,
            Awaited<ReturnType<typeof mapsPointUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof mapsPointUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getMapsPointUpdateMutationKey(id);
    const swrFn = getMapsPointUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getMapsPointPartialUpdateUrl = (id: string) => {
    return `/api/maps/point/${id}/`;
};

export const mapsPointPartialUpdate = async (
    id: string,
    patchedPointRequest: PatchedPointRequest,
    options?: RequestInit,
): Promise<Point> => {
    return mapsPointPartialUpdateMutator<Point>(getMapsPointPartialUpdateUrl(id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(patchedPointRequest),
    });
};

export const getMapsPointPartialUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof mapsPointPartialUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: PatchedPointRequest }) => {
        return mapsPointPartialUpdate(id, arg, options);
    };
};
export const getMapsPointPartialUpdateMutationKey = (id: string) => [`/api/maps/point/${id}/`] as const;

export type MapsPointPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof mapsPointPartialUpdate>>>;
export type MapsPointPartialUpdateMutationError = unknown;

export const useMapsPointPartialUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof mapsPointPartialUpdate>>,
            TError,
            Key,
            PatchedPointRequest,
            Awaited<ReturnType<typeof mapsPointPartialUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof mapsPointPartialUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getMapsPointPartialUpdateMutationKey(id);
    const swrFn = getMapsPointPartialUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getMapsPointDestroyUrl = (id: string) => {
    return `/api/maps/point/${id}/`;
};

export const mapsPointDestroy = async (id: string, options?: RequestInit): Promise<void> => {
    return mapsPointDestroyMutator<void>(getMapsPointDestroyUrl(id), {
        ...options,
        method: 'DELETE',
    });
};

export const getMapsPointDestroyMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof mapsPointDestroyMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return mapsPointDestroy(id, options);
    };
};
export const getMapsPointDestroyMutationKey = (id: string) => [`/api/maps/point/${id}/`] as const;

export type MapsPointDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof mapsPointDestroy>>>;
export type MapsPointDestroyMutationError = unknown;

export const useMapsPointDestroy = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof mapsPointDestroy>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof mapsPointDestroy>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof mapsPointDestroyMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getMapsPointDestroyMutationKey(id);
    const swrFn = getMapsPointDestroyMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getMapsRemoveAreaForDeviceCreateUrl = () => {
    return `/api/maps/remove_area_for_device`;
};

export const mapsRemoveAreaForDeviceCreate = async (options?: RequestInit): Promise<void> => {
    return mapsRemoveAreaForDeviceCreateMutator<void>(getMapsRemoveAreaForDeviceCreateUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getMapsRemoveAreaForDeviceCreateMutationFetcher = (
    options?: SecondParameter<typeof mapsRemoveAreaForDeviceCreateMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return mapsRemoveAreaForDeviceCreate(options);
    };
};
export const getMapsRemoveAreaForDeviceCreateMutationKey = () => [`/api/maps/remove_area_for_device`] as const;

export type MapsRemoveAreaForDeviceCreateMutationResult = NonNullable<
    Awaited<ReturnType<typeof mapsRemoveAreaForDeviceCreate>>
>;
export type MapsRemoveAreaForDeviceCreateMutationError = unknown;

export const useMapsRemoveAreaForDeviceCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof mapsRemoveAreaForDeviceCreate>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof mapsRemoveAreaForDeviceCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof mapsRemoveAreaForDeviceCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getMapsRemoveAreaForDeviceCreateMutationKey();
    const swrFn = getMapsRemoveAreaForDeviceCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getTasksApiInstanceDescriptionRetrieveUrl = () => {
    return `/api/tasks/api_instance_description`;
};

export const tasksApiInstanceDescriptionRetrieve = async (options?: RequestInit): Promise<void> => {
    return tasksApiInstanceDescriptionRetrieveMutator<void>(getTasksApiInstanceDescriptionRetrieveUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getTasksApiInstanceDescriptionRetrieveKey = () => [`/api/tasks/api_instance_description`] as const;

export type TasksApiInstanceDescriptionRetrieveQueryResult = NonNullable<
    Awaited<ReturnType<typeof tasksApiInstanceDescriptionRetrieve>>
>;
export type TasksApiInstanceDescriptionRetrieveQueryError = unknown;

export const useTasksApiInstanceDescriptionRetrieve = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof tasksApiInstanceDescriptionRetrieve>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof tasksApiInstanceDescriptionRetrieveMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getTasksApiInstanceDescriptionRetrieveKey() : null));
    const swrFn = () => tasksApiInstanceDescriptionRetrieve(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getTasksInstanceDescriptionRetrieveUrl = () => {
    return `/api/tasks/instance_description`;
};

export const tasksInstanceDescriptionRetrieve = async (options?: RequestInit): Promise<void> => {
    return tasksInstanceDescriptionRetrieveMutator<void>(getTasksInstanceDescriptionRetrieveUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getTasksInstanceDescriptionRetrieveKey = () => [`/api/tasks/instance_description`] as const;

export type TasksInstanceDescriptionRetrieveQueryResult = NonNullable<
    Awaited<ReturnType<typeof tasksInstanceDescriptionRetrieve>>
>;
export type TasksInstanceDescriptionRetrieveQueryError = unknown;

export const useTasksInstanceDescriptionRetrieve = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof tasksInstanceDescriptionRetrieve>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof tasksInstanceDescriptionRetrieveMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getTasksInstanceDescriptionRetrieveKey() : null));
    const swrFn = () => tasksInstanceDescriptionRetrieve(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getTasksInstanceInfoRetrieveUrl = () => {
    return `/api/tasks/instance_info`;
};

export const tasksInstanceInfoRetrieve = async (options?: RequestInit): Promise<void> => {
    return tasksInstanceInfoRetrieveMutator<void>(getTasksInstanceInfoRetrieveUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getTasksInstanceInfoRetrieveKey = () => [`/api/tasks/instance_info`] as const;

export type TasksInstanceInfoRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof tasksInstanceInfoRetrieve>>>;
export type TasksInstanceInfoRetrieveQueryError = unknown;

export const useTasksInstanceInfoRetrieve = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof tasksInstanceInfoRetrieve>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof tasksInstanceInfoRetrieveMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getTasksInstanceInfoRetrieveKey() : null));
    const swrFn = () => tasksInstanceInfoRetrieve(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getTasksInstancePublicRetrieveUrl = () => {
    return `/api/tasks/instance_public`;
};

export const tasksInstancePublicRetrieve = async (options?: RequestInit): Promise<void> => {
    return tasksInstancePublicRetrieveMutator<void>(getTasksInstancePublicRetrieveUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getTasksInstancePublicRetrieveKey = () => [`/api/tasks/instance_public`] as const;

export type TasksInstancePublicRetrieveQueryResult = NonNullable<
    Awaited<ReturnType<typeof tasksInstancePublicRetrieve>>
>;
export type TasksInstancePublicRetrieveQueryError = unknown;

export const useTasksInstancePublicRetrieve = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof tasksInstancePublicRetrieve>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof tasksInstancePublicRetrieveMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getTasksInstancePublicRetrieveKey() : null));
    const swrFn = () => tasksInstancePublicRetrieve(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getTasksRestartServerCreateUrl = () => {
    return `/api/tasks/restart_server`;
};

export const tasksRestartServerCreate = async (options?: RequestInit): Promise<void> => {
    return tasksRestartServerCreateMutator<void>(getTasksRestartServerCreateUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getTasksRestartServerCreateMutationFetcher = (
    options?: SecondParameter<typeof tasksRestartServerCreateMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return tasksRestartServerCreate(options);
    };
};
export const getTasksRestartServerCreateMutationKey = () => [`/api/tasks/restart_server`] as const;

export type TasksRestartServerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof tasksRestartServerCreate>>>;
export type TasksRestartServerCreateMutationError = unknown;

export const useTasksRestartServerCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof tasksRestartServerCreate>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof tasksRestartServerCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof tasksRestartServerCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getTasksRestartServerCreateMutationKey();
    const swrFn = getTasksRestartServerCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getTasksSyncallRetrieveUrl = () => {
    return `/api/tasks/syncall`;
};

export const tasksSyncallRetrieve = async (options?: RequestInit): Promise<void> => {
    return tasksSyncallRetrieveMutator<void>(getTasksSyncallRetrieveUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getTasksSyncallRetrieveKey = () => [`/api/tasks/syncall`] as const;

export type TasksSyncallRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof tasksSyncallRetrieve>>>;
export type TasksSyncallRetrieveQueryError = unknown;

export const useTasksSyncallRetrieve = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof tasksSyncallRetrieve>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof tasksSyncallRetrieveMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getTasksSyncallRetrieveKey() : null));
    const swrFn = () => tasksSyncallRetrieve(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getTasksTaskListUrl = () => {
    return `/api/tasks/task/`;
};

export const tasksTaskList = async (options?: RequestInit): Promise<Task[]> => {
    return tasksTaskListMutator<Task[]>(getTasksTaskListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getTasksTaskListKey = () => [`/api/tasks/task/`] as const;

export type TasksTaskListQueryResult = NonNullable<Awaited<ReturnType<typeof tasksTaskList>>>;
export type TasksTaskListQueryError = unknown;

export const useTasksTaskList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof tasksTaskList>>, TError> & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof tasksTaskListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getTasksTaskListKey() : null));
    const swrFn = () => tasksTaskList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getTasksTaskCreateUrl = () => {
    return `/api/tasks/task/`;
};

export const tasksTaskCreate = async (taskRequest: TaskRequest, options?: RequestInit): Promise<Task> => {
    return tasksTaskCreateMutator<Task>(getTasksTaskCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(taskRequest),
    });
};

export const getTasksTaskCreateMutationFetcher = (options?: SecondParameter<typeof tasksTaskCreateMutator>) => {
    return (_: Key, { arg }: { arg: TaskRequest }) => {
        return tasksTaskCreate(arg, options);
    };
};
export const getTasksTaskCreateMutationKey = () => [`/api/tasks/task/`] as const;

export type TasksTaskCreateMutationResult = NonNullable<Awaited<ReturnType<typeof tasksTaskCreate>>>;
export type TasksTaskCreateMutationError = unknown;

export const useTasksTaskCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof tasksTaskCreate>>,
        TError,
        Key,
        TaskRequest,
        Awaited<ReturnType<typeof tasksTaskCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof tasksTaskCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getTasksTaskCreateMutationKey();
    const swrFn = getTasksTaskCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getTasksTaskRetrieveUrl = (id: string) => {
    return `/api/tasks/task/${id}/`;
};

export const tasksTaskRetrieve = async (id: string, options?: RequestInit): Promise<Task> => {
    return tasksTaskRetrieveMutator<Task>(getTasksTaskRetrieveUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getTasksTaskRetrieveKey = (id: string) => [`/api/tasks/task/${id}/`] as const;

export type TasksTaskRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof tasksTaskRetrieve>>>;
export type TasksTaskRetrieveQueryError = unknown;

export const useTasksTaskRetrieve = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof tasksTaskRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof tasksTaskRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getTasksTaskRetrieveKey(id) : null));
    const swrFn = () => tasksTaskRetrieve(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getTasksTaskUpdateUrl = (id: string) => {
    return `/api/tasks/task/${id}/`;
};

export const tasksTaskUpdate = async (id: string, taskRequest: TaskRequest, options?: RequestInit): Promise<Task> => {
    return tasksTaskUpdateMutator<Task>(getTasksTaskUpdateUrl(id), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(taskRequest),
    });
};

export const getTasksTaskUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof tasksTaskUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: TaskRequest }) => {
        return tasksTaskUpdate(id, arg, options);
    };
};
export const getTasksTaskUpdateMutationKey = (id: string) => [`/api/tasks/task/${id}/`] as const;

export type TasksTaskUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof tasksTaskUpdate>>>;
export type TasksTaskUpdateMutationError = unknown;

export const useTasksTaskUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof tasksTaskUpdate>>,
            TError,
            Key,
            TaskRequest,
            Awaited<ReturnType<typeof tasksTaskUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof tasksTaskUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getTasksTaskUpdateMutationKey(id);
    const swrFn = getTasksTaskUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getTasksTaskPartialUpdateUrl = (id: string) => {
    return `/api/tasks/task/${id}/`;
};

export const tasksTaskPartialUpdate = async (
    id: string,
    patchedTaskRequest: PatchedTaskRequest,
    options?: RequestInit,
): Promise<Task> => {
    return tasksTaskPartialUpdateMutator<Task>(getTasksTaskPartialUpdateUrl(id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(patchedTaskRequest),
    });
};

export const getTasksTaskPartialUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof tasksTaskPartialUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: PatchedTaskRequest }) => {
        return tasksTaskPartialUpdate(id, arg, options);
    };
};
export const getTasksTaskPartialUpdateMutationKey = (id: string) => [`/api/tasks/task/${id}/`] as const;

export type TasksTaskPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof tasksTaskPartialUpdate>>>;
export type TasksTaskPartialUpdateMutationError = unknown;

export const useTasksTaskPartialUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof tasksTaskPartialUpdate>>,
            TError,
            Key,
            PatchedTaskRequest,
            Awaited<ReturnType<typeof tasksTaskPartialUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof tasksTaskPartialUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getTasksTaskPartialUpdateMutationKey(id);
    const swrFn = getTasksTaskPartialUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getTasksTaskDestroyUrl = (id: string) => {
    return `/api/tasks/task/${id}/`;
};

export const tasksTaskDestroy = async (id: string, options?: RequestInit): Promise<void> => {
    return tasksTaskDestroyMutator<void>(getTasksTaskDestroyUrl(id), {
        ...options,
        method: 'DELETE',
    });
};

export const getTasksTaskDestroyMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof tasksTaskDestroyMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return tasksTaskDestroy(id, options);
    };
};
export const getTasksTaskDestroyMutationKey = (id: string) => [`/api/tasks/task/${id}/`] as const;

export type TasksTaskDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof tasksTaskDestroy>>>;
export type TasksTaskDestroyMutationError = unknown;

export const useTasksTaskDestroy = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof tasksTaskDestroy>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof tasksTaskDestroy>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof tasksTaskDestroyMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getTasksTaskDestroyMutationKey(id);
    const swrFn = getTasksTaskDestroyMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getTasksTokenPermissionSelfRetrieveUrl = () => {
    return `/api/tasks/token_permission_self`;
};

export const tasksTokenPermissionSelfRetrieve = async (options?: RequestInit): Promise<void> => {
    return tasksTokenPermissionSelfRetrieveMutator<void>(getTasksTokenPermissionSelfRetrieveUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getTasksTokenPermissionSelfRetrieveKey = () => [`/api/tasks/token_permission_self`] as const;

export type TasksTokenPermissionSelfRetrieveQueryResult = NonNullable<
    Awaited<ReturnType<typeof tasksTokenPermissionSelfRetrieve>>
>;
export type TasksTokenPermissionSelfRetrieveQueryError = unknown;

export const useTasksTokenPermissionSelfRetrieve = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof tasksTokenPermissionSelfRetrieve>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof tasksTokenPermissionSelfRetrieveMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getTasksTokenPermissionSelfRetrieveKey() : null));
    const swrFn = () => tasksTokenPermissionSelfRetrieve(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getTasksTokenPermissionSettingsRetrieveUrl = () => {
    return `/api/tasks/token_permission_settings`;
};

export const tasksTokenPermissionSettingsRetrieve = async (options?: RequestInit): Promise<void> => {
    return tasksTokenPermissionSettingsRetrieveMutator<void>(getTasksTokenPermissionSettingsRetrieveUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getTasksTokenPermissionSettingsRetrieveKey = () => [`/api/tasks/token_permission_settings`] as const;

export type TasksTokenPermissionSettingsRetrieveQueryResult = NonNullable<
    Awaited<ReturnType<typeof tasksTokenPermissionSettingsRetrieve>>
>;
export type TasksTokenPermissionSettingsRetrieveQueryError = unknown;

export const useTasksTokenPermissionSettingsRetrieve = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof tasksTokenPermissionSettingsRetrieve>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof tasksTokenPermissionSettingsRetrieveMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getTasksTokenPermissionSettingsRetrieveKey() : null));
    const swrFn = () => tasksTokenPermissionSettingsRetrieve(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getTasksUpdateInstanceDescriptionUpdateUrl = () => {
    return `/api/tasks/update_instance_description`;
};

export const tasksUpdateInstanceDescriptionUpdate = async (options?: RequestInit): Promise<void> => {
    return tasksUpdateInstanceDescriptionUpdateMutator<void>(getTasksUpdateInstanceDescriptionUpdateUrl(), {
        ...options,
        method: 'PUT',
    });
};

export const getTasksUpdateInstanceDescriptionUpdateMutationFetcher = (
    options?: SecondParameter<typeof tasksUpdateInstanceDescriptionUpdateMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return tasksUpdateInstanceDescriptionUpdate(options);
    };
};
export const getTasksUpdateInstanceDescriptionUpdateMutationKey = () =>
    [`/api/tasks/update_instance_description`] as const;

export type TasksUpdateInstanceDescriptionUpdateMutationResult = NonNullable<
    Awaited<ReturnType<typeof tasksUpdateInstanceDescriptionUpdate>>
>;
export type TasksUpdateInstanceDescriptionUpdateMutationError = unknown;

export const useTasksUpdateInstanceDescriptionUpdate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof tasksUpdateInstanceDescriptionUpdate>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof tasksUpdateInstanceDescriptionUpdate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof tasksUpdateInstanceDescriptionUpdateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getTasksUpdateInstanceDescriptionUpdateMutationKey();
    const swrFn = getTasksUpdateInstanceDescriptionUpdateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getTasksUpdateInstanceDescriptionPartialUpdateUrl = () => {
    return `/api/tasks/update_instance_description`;
};

export const tasksUpdateInstanceDescriptionPartialUpdate = async (options?: RequestInit): Promise<void> => {
    return tasksUpdateInstanceDescriptionPartialUpdateMutator<void>(
        getTasksUpdateInstanceDescriptionPartialUpdateUrl(),
        {
            ...options,
            method: 'PATCH',
        },
    );
};

export const getTasksUpdateInstanceDescriptionPartialUpdateMutationFetcher = (
    options?: SecondParameter<typeof tasksUpdateInstanceDescriptionPartialUpdateMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return tasksUpdateInstanceDescriptionPartialUpdate(options);
    };
};
export const getTasksUpdateInstanceDescriptionPartialUpdateMutationKey = () =>
    [`/api/tasks/update_instance_description`] as const;

export type TasksUpdateInstanceDescriptionPartialUpdateMutationResult = NonNullable<
    Awaited<ReturnType<typeof tasksUpdateInstanceDescriptionPartialUpdate>>
>;
export type TasksUpdateInstanceDescriptionPartialUpdateMutationError = unknown;

export const useTasksUpdateInstanceDescriptionPartialUpdate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof tasksUpdateInstanceDescriptionPartialUpdate>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof tasksUpdateInstanceDescriptionPartialUpdate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof tasksUpdateInstanceDescriptionPartialUpdateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getTasksUpdateInstanceDescriptionPartialUpdateMutationKey();
    const swrFn = getTasksUpdateInstanceDescriptionPartialUpdateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getTasksUpdateInstanceInfoUpdateUrl = () => {
    return `/api/tasks/update_instance_info`;
};

export const tasksUpdateInstanceInfoUpdate = async (options?: RequestInit): Promise<void> => {
    return tasksUpdateInstanceInfoUpdateMutator<void>(getTasksUpdateInstanceInfoUpdateUrl(), {
        ...options,
        method: 'PUT',
    });
};

export const getTasksUpdateInstanceInfoUpdateMutationFetcher = (
    options?: SecondParameter<typeof tasksUpdateInstanceInfoUpdateMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return tasksUpdateInstanceInfoUpdate(options);
    };
};
export const getTasksUpdateInstanceInfoUpdateMutationKey = () => [`/api/tasks/update_instance_info`] as const;

export type TasksUpdateInstanceInfoUpdateMutationResult = NonNullable<
    Awaited<ReturnType<typeof tasksUpdateInstanceInfoUpdate>>
>;
export type TasksUpdateInstanceInfoUpdateMutationError = unknown;

export const useTasksUpdateInstanceInfoUpdate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof tasksUpdateInstanceInfoUpdate>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof tasksUpdateInstanceInfoUpdate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof tasksUpdateInstanceInfoUpdateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getTasksUpdateInstanceInfoUpdateMutationKey();
    const swrFn = getTasksUpdateInstanceInfoUpdateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getTasksUpdateInstanceInfoPartialUpdateUrl = () => {
    return `/api/tasks/update_instance_info`;
};

export const tasksUpdateInstanceInfoPartialUpdate = async (options?: RequestInit): Promise<void> => {
    return tasksUpdateInstanceInfoPartialUpdateMutator<void>(getTasksUpdateInstanceInfoPartialUpdateUrl(), {
        ...options,
        method: 'PATCH',
    });
};

export const getTasksUpdateInstanceInfoPartialUpdateMutationFetcher = (
    options?: SecondParameter<typeof tasksUpdateInstanceInfoPartialUpdateMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return tasksUpdateInstanceInfoPartialUpdate(options);
    };
};
export const getTasksUpdateInstanceInfoPartialUpdateMutationKey = () => [`/api/tasks/update_instance_info`] as const;

export type TasksUpdateInstanceInfoPartialUpdateMutationResult = NonNullable<
    Awaited<ReturnType<typeof tasksUpdateInstanceInfoPartialUpdate>>
>;
export type TasksUpdateInstanceInfoPartialUpdateMutationError = unknown;

export const useTasksUpdateInstanceInfoPartialUpdate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof tasksUpdateInstanceInfoPartialUpdate>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof tasksUpdateInstanceInfoPartialUpdate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof tasksUpdateInstanceInfoPartialUpdateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getTasksUpdateInstanceInfoPartialUpdateMutationKey();
    const swrFn = getTasksUpdateInstanceInfoPartialUpdateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getTasksUpdateTokenPermissionSettingsUpdateUrl = () => {
    return `/api/tasks/update_token_permission_settings`;
};

export const tasksUpdateTokenPermissionSettingsUpdate = async (options?: RequestInit): Promise<void> => {
    return tasksUpdateTokenPermissionSettingsUpdateMutator<void>(getTasksUpdateTokenPermissionSettingsUpdateUrl(), {
        ...options,
        method: 'PUT',
    });
};

export const getTasksUpdateTokenPermissionSettingsUpdateMutationFetcher = (
    options?: SecondParameter<typeof tasksUpdateTokenPermissionSettingsUpdateMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return tasksUpdateTokenPermissionSettingsUpdate(options);
    };
};
export const getTasksUpdateTokenPermissionSettingsUpdateMutationKey = () =>
    [`/api/tasks/update_token_permission_settings`] as const;

export type TasksUpdateTokenPermissionSettingsUpdateMutationResult = NonNullable<
    Awaited<ReturnType<typeof tasksUpdateTokenPermissionSettingsUpdate>>
>;
export type TasksUpdateTokenPermissionSettingsUpdateMutationError = unknown;

export const useTasksUpdateTokenPermissionSettingsUpdate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof tasksUpdateTokenPermissionSettingsUpdate>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof tasksUpdateTokenPermissionSettingsUpdate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof tasksUpdateTokenPermissionSettingsUpdateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getTasksUpdateTokenPermissionSettingsUpdateMutationKey();
    const swrFn = getTasksUpdateTokenPermissionSettingsUpdateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getTasksUpdateTokenPermissionSettingsPartialUpdateUrl = () => {
    return `/api/tasks/update_token_permission_settings`;
};

export const tasksUpdateTokenPermissionSettingsPartialUpdate = async (options?: RequestInit): Promise<void> => {
    return tasksUpdateTokenPermissionSettingsPartialUpdateMutator<void>(
        getTasksUpdateTokenPermissionSettingsPartialUpdateUrl(),
        {
            ...options,
            method: 'PATCH',
        },
    );
};

export const getTasksUpdateTokenPermissionSettingsPartialUpdateMutationFetcher = (
    options?: SecondParameter<typeof tasksUpdateTokenPermissionSettingsPartialUpdateMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return tasksUpdateTokenPermissionSettingsPartialUpdate(options);
    };
};
export const getTasksUpdateTokenPermissionSettingsPartialUpdateMutationKey = () =>
    [`/api/tasks/update_token_permission_settings`] as const;

export type TasksUpdateTokenPermissionSettingsPartialUpdateMutationResult = NonNullable<
    Awaited<ReturnType<typeof tasksUpdateTokenPermissionSettingsPartialUpdate>>
>;
export type TasksUpdateTokenPermissionSettingsPartialUpdateMutationError = unknown;

export const useTasksUpdateTokenPermissionSettingsPartialUpdate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof tasksUpdateTokenPermissionSettingsPartialUpdate>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof tasksUpdateTokenPermissionSettingsPartialUpdate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof tasksUpdateTokenPermissionSettingsPartialUpdateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getTasksUpdateTokenPermissionSettingsPartialUpdateMutationKey();
    const swrFn = getTasksUpdateTokenPermissionSettingsPartialUpdateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersActivityprofileRetrieveUrl = (id: string) => {
    return `/api/users/activityprofile/${id}/`;
};

export const usersActivityprofileRetrieve = async (id: string, options?: RequestInit): Promise<ActivityProfile> => {
    return usersActivityprofileRetrieveMutator<ActivityProfile>(getUsersActivityprofileRetrieveUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getUsersActivityprofileRetrieveKey = (id: string) => [`/api/users/activityprofile/${id}/`] as const;

export type UsersActivityprofileRetrieveQueryResult = NonNullable<
    Awaited<ReturnType<typeof usersActivityprofileRetrieve>>
>;
export type UsersActivityprofileRetrieveQueryError = unknown;

export const useUsersActivityprofileRetrieve = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof usersActivityprofileRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof usersActivityprofileRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersActivityprofileRetrieveKey(id) : null));
    const swrFn = () => usersActivityprofileRetrieve(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersAdvertisedRetrieveUrl = () => {
    return `/api/users/advertised`;
};

export const usersAdvertisedRetrieve = async (options?: RequestInit): Promise<void> => {
    return usersAdvertisedRetrieveMutator<void>(getUsersAdvertisedRetrieveUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getUsersAdvertisedRetrieveKey = () => [`/api/users/advertised`] as const;

export type UsersAdvertisedRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof usersAdvertisedRetrieve>>>;
export type UsersAdvertisedRetrieveQueryError = unknown;

export const useUsersAdvertisedRetrieve = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof usersAdvertisedRetrieve>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof usersAdvertisedRetrieveMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersAdvertisedRetrieveKey() : null));
    const swrFn = () => usersAdvertisedRetrieve(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersApiBulkMessageserverCreateUrl = () => {
    return `/api/users/api_bulk_messageserver`;
};

export const usersApiBulkMessageserverCreate = async (options?: RequestInit): Promise<void> => {
    return usersApiBulkMessageserverCreateMutator<void>(getUsersApiBulkMessageserverCreateUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getUsersApiBulkMessageserverCreateMutationFetcher = (
    options?: SecondParameter<typeof usersApiBulkMessageserverCreateMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return usersApiBulkMessageserverCreate(options);
    };
};
export const getUsersApiBulkMessageserverCreateMutationKey = () => [`/api/users/api_bulk_messageserver`] as const;

export type UsersApiBulkMessageserverCreateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersApiBulkMessageserverCreate>>
>;
export type UsersApiBulkMessageserverCreateMutationError = unknown;

export const useUsersApiBulkMessageserverCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof usersApiBulkMessageserverCreate>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof usersApiBulkMessageserverCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof usersApiBulkMessageserverCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersApiBulkMessageserverCreateMutationKey();
    const swrFn = getUsersApiBulkMessageserverCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersApiCompanyInfoRetrieveUrl = (companyId: string) => {
    return `/api/users/api_company_info/${companyId}`;
};

export const usersApiCompanyInfoRetrieve = async (companyId: string, options?: RequestInit): Promise<void> => {
    return usersApiCompanyInfoRetrieveMutator<void>(getUsersApiCompanyInfoRetrieveUrl(companyId), {
        ...options,
        method: 'GET',
    });
};

export const getUsersApiCompanyInfoRetrieveKey = (companyId: string) =>
    [`/api/users/api_company_info/${companyId}`] as const;

export type UsersApiCompanyInfoRetrieveQueryResult = NonNullable<
    Awaited<ReturnType<typeof usersApiCompanyInfoRetrieve>>
>;
export type UsersApiCompanyInfoRetrieveQueryError = unknown;

export const useUsersApiCompanyInfoRetrieve = <TError = unknown>(
    companyId: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof usersApiCompanyInfoRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof usersApiCompanyInfoRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!companyId;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersApiCompanyInfoRetrieveKey(companyId) : null));
    const swrFn = () => usersApiCompanyInfoRetrieve(companyId, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersApiMessagePermsRetrieveUrl = () => {
    return `/api/users/api_message_perms`;
};

export const usersApiMessagePermsRetrieve = async (options?: RequestInit): Promise<void> => {
    return usersApiMessagePermsRetrieveMutator<void>(getUsersApiMessagePermsRetrieveUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getUsersApiMessagePermsRetrieveKey = () => [`/api/users/api_message_perms`] as const;

export type UsersApiMessagePermsRetrieveQueryResult = NonNullable<
    Awaited<ReturnType<typeof usersApiMessagePermsRetrieve>>
>;
export type UsersApiMessagePermsRetrieveQueryError = unknown;

export const useUsersApiMessagePermsRetrieve = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof usersApiMessagePermsRetrieve>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof usersApiMessagePermsRetrieveMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersApiMessagePermsRetrieveKey() : null));
    const swrFn = () => usersApiMessagePermsRetrieve(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersApiRenkiApiPermsRetrieveUrl = () => {
    return `/api/users/api_renki_api_perms`;
};

export const usersApiRenkiApiPermsRetrieve = async (options?: RequestInit): Promise<void> => {
    return usersApiRenkiApiPermsRetrieveMutator<void>(getUsersApiRenkiApiPermsRetrieveUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getUsersApiRenkiApiPermsRetrieveKey = () => [`/api/users/api_renki_api_perms`] as const;

export type UsersApiRenkiApiPermsRetrieveQueryResult = NonNullable<
    Awaited<ReturnType<typeof usersApiRenkiApiPermsRetrieve>>
>;
export type UsersApiRenkiApiPermsRetrieveQueryError = unknown;

export const useUsersApiRenkiApiPermsRetrieve = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof usersApiRenkiApiPermsRetrieve>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof usersApiRenkiApiPermsRetrieveMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersApiRenkiApiPermsRetrieveKey() : null));
    const swrFn = () => usersApiRenkiApiPermsRetrieve(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersApiSocialInfoRetrieveUrl = (socialId: string) => {
    return `/api/users/api_social_info/${socialId}`;
};

export const usersApiSocialInfoRetrieve = async (socialId: string, options?: RequestInit): Promise<void> => {
    return usersApiSocialInfoRetrieveMutator<void>(getUsersApiSocialInfoRetrieveUrl(socialId), {
        ...options,
        method: 'GET',
    });
};

export const getUsersApiSocialInfoRetrieveKey = (socialId: string) =>
    [`/api/users/api_social_info/${socialId}`] as const;

export type UsersApiSocialInfoRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof usersApiSocialInfoRetrieve>>>;
export type UsersApiSocialInfoRetrieveQueryError = unknown;

export const useUsersApiSocialInfoRetrieve = <TError = unknown>(
    socialId: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof usersApiSocialInfoRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof usersApiSocialInfoRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!socialId;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersApiSocialInfoRetrieveKey(socialId) : null));
    const swrFn = () => usersApiSocialInfoRetrieve(socialId, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersApiUserSitesRetrieveUrl = (uid: string) => {
    return `/api/users/api_user_sites/${uid}/`;
};

export const usersApiUserSitesRetrieve = async (uid: string, options?: RequestInit): Promise<void> => {
    return usersApiUserSitesRetrieveMutator<void>(getUsersApiUserSitesRetrieveUrl(uid), {
        ...options,
        method: 'GET',
    });
};

export const getUsersApiUserSitesRetrieveKey = (uid: string) => [`/api/users/api_user_sites/${uid}/`] as const;

export type UsersApiUserSitesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof usersApiUserSitesRetrieve>>>;
export type UsersApiUserSitesRetrieveQueryError = unknown;

export const useUsersApiUserSitesRetrieve = <TError = unknown>(
    uid: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof usersApiUserSitesRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof usersApiUserSitesRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!uid;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersApiUserSitesRetrieveKey(uid) : null));
    const swrFn = () => usersApiUserSitesRetrieve(uid, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersApigroupedaddressesRetrieveUrl = () => {
    return `/api/users/apigroupedaddresses`;
};

export const usersApigroupedaddressesRetrieve = async (options?: RequestInit): Promise<void> => {
    return usersApigroupedaddressesRetrieveMutator<void>(getUsersApigroupedaddressesRetrieveUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getUsersApigroupedaddressesRetrieveKey = () => [`/api/users/apigroupedaddresses`] as const;

export type UsersApigroupedaddressesRetrieveQueryResult = NonNullable<
    Awaited<ReturnType<typeof usersApigroupedaddressesRetrieve>>
>;
export type UsersApigroupedaddressesRetrieveQueryError = unknown;

export const useUsersApigroupedaddressesRetrieve = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof usersApigroupedaddressesRetrieve>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof usersApigroupedaddressesRetrieveMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersApigroupedaddressesRetrieveKey() : null));
    const swrFn = () => usersApigroupedaddressesRetrieve(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersApihiddenListUrl = () => {
    return `/api/users/apihidden/`;
};

export const usersApihiddenList = async (options?: RequestInit): Promise<ApiHiddenTime[]> => {
    return usersApihiddenListMutator<ApiHiddenTime[]>(getUsersApihiddenListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getUsersApihiddenListKey = () => [`/api/users/apihidden/`] as const;

export type UsersApihiddenListQueryResult = NonNullable<Awaited<ReturnType<typeof usersApihiddenList>>>;
export type UsersApihiddenListQueryError = unknown;

export const useUsersApihiddenList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof usersApihiddenList>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof usersApihiddenListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersApihiddenListKey() : null));
    const swrFn = () => usersApihiddenList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersCalendarListUrl = () => {
    return `/api/users/calendar/`;
};

export const usersCalendarList = async (options?: RequestInit): Promise<Calendar[]> => {
    return usersCalendarListMutator<Calendar[]>(getUsersCalendarListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getUsersCalendarListKey = () => [`/api/users/calendar/`] as const;

export type UsersCalendarListQueryResult = NonNullable<Awaited<ReturnType<typeof usersCalendarList>>>;
export type UsersCalendarListQueryError = unknown;

export const useUsersCalendarList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof usersCalendarList>>, TError> & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof usersCalendarListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersCalendarListKey() : null));
    const swrFn = () => usersCalendarList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Returns events for a calendar within the inclusive start and end range. All three query parameters (calendar, start, end) must be supplied; otherwise an empty list is returned.
 * @summary List calendar events by date range
 */
export const getUsersCalendarEventsListUrl = (params: UsersCalendarEventsListParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `/api/users/calendar-events/?${stringifiedParams}`
        : `/api/users/calendar-events/`;
};

export const usersCalendarEventsList = async (
    params: UsersCalendarEventsListParams,
    options?: RequestInit,
): Promise<CalendarEventList[]> => {
    return usersCalendarEventsListMutator<CalendarEventList[]>(getUsersCalendarEventsListUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getUsersCalendarEventsListKey = (params: UsersCalendarEventsListParams) =>
    [`/api/users/calendar-events/`, ...(params ? [params] : [])] as const;

export type UsersCalendarEventsListQueryResult = NonNullable<Awaited<ReturnType<typeof usersCalendarEventsList>>>;
export type UsersCalendarEventsListQueryError = unknown;

/**
 * @summary List calendar events by date range
 */
export const useUsersCalendarEventsList = <TError = unknown>(
    params: UsersCalendarEventsListParams,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof usersCalendarEventsList>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof usersCalendarEventsListMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersCalendarEventsListKey(params) : null));
    const swrFn = () => usersCalendarEventsList(params, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Range queries:
  GET /calendar-events/?calendar=<uuid>&start=ISO&end=ISO
 */
export const getUsersCalendarEventsCreateUrl = () => {
    return `/api/users/calendar-events/`;
};

export const usersCalendarEventsCreate = async (
    calendarEventCreateRequest: CalendarEventCreateRequest,
    options?: RequestInit,
): Promise<CalendarEventCreate> => {
    return usersCalendarEventsCreateMutator<CalendarEventCreate>(getUsersCalendarEventsCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(calendarEventCreateRequest),
    });
};

export const getUsersCalendarEventsCreateMutationFetcher = (
    options?: SecondParameter<typeof usersCalendarEventsCreateMutator>,
) => {
    return (_: Key, { arg }: { arg: CalendarEventCreateRequest }) => {
        return usersCalendarEventsCreate(arg, options);
    };
};
export const getUsersCalendarEventsCreateMutationKey = () => [`/api/users/calendar-events/`] as const;

export type UsersCalendarEventsCreateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersCalendarEventsCreate>>
>;
export type UsersCalendarEventsCreateMutationError = unknown;

export const useUsersCalendarEventsCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof usersCalendarEventsCreate>>,
        TError,
        Key,
        CalendarEventCreateRequest,
        Awaited<ReturnType<typeof usersCalendarEventsCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof usersCalendarEventsCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersCalendarEventsCreateMutationKey();
    const swrFn = getUsersCalendarEventsCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Range queries:
  GET /calendar-events/?calendar=<uuid>&start=ISO&end=ISO
 */
export const getUsersCalendarEventsRetrieveUrl = (id: string) => {
    return `/api/users/calendar-events/${id}/`;
};

export const usersCalendarEventsRetrieve = async (id: string, options?: RequestInit): Promise<CalendarEventDetail> => {
    return usersCalendarEventsRetrieveMutator<CalendarEventDetail>(getUsersCalendarEventsRetrieveUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getUsersCalendarEventsRetrieveKey = (id: string) => [`/api/users/calendar-events/${id}/`] as const;

export type UsersCalendarEventsRetrieveQueryResult = NonNullable<
    Awaited<ReturnType<typeof usersCalendarEventsRetrieve>>
>;
export type UsersCalendarEventsRetrieveQueryError = unknown;

export const useUsersCalendarEventsRetrieve = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof usersCalendarEventsRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof usersCalendarEventsRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersCalendarEventsRetrieveKey(id) : null));
    const swrFn = () => usersCalendarEventsRetrieve(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Range queries:
  GET /calendar-events/?calendar=<uuid>&start=ISO&end=ISO
 */
export const getUsersCalendarEventsUpdateUrl = (id: string) => {
    return `/api/users/calendar-events/${id}/`;
};

export const usersCalendarEventsUpdate = async (
    id: string,
    calendarEventListRequest: CalendarEventListRequest,
    options?: RequestInit,
): Promise<CalendarEventList> => {
    return usersCalendarEventsUpdateMutator<CalendarEventList>(getUsersCalendarEventsUpdateUrl(id), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(calendarEventListRequest),
    });
};

export const getUsersCalendarEventsUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof usersCalendarEventsUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: CalendarEventListRequest }) => {
        return usersCalendarEventsUpdate(id, arg, options);
    };
};
export const getUsersCalendarEventsUpdateMutationKey = (id: string) => [`/api/users/calendar-events/${id}/`] as const;

export type UsersCalendarEventsUpdateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersCalendarEventsUpdate>>
>;
export type UsersCalendarEventsUpdateMutationError = unknown;

export const useUsersCalendarEventsUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof usersCalendarEventsUpdate>>,
            TError,
            Key,
            CalendarEventListRequest,
            Awaited<ReturnType<typeof usersCalendarEventsUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof usersCalendarEventsUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersCalendarEventsUpdateMutationKey(id);
    const swrFn = getUsersCalendarEventsUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Range queries:
  GET /calendar-events/?calendar=<uuid>&start=ISO&end=ISO
 */
export const getUsersCalendarEventsPartialUpdateUrl = (id: string) => {
    return `/api/users/calendar-events/${id}/`;
};

export const usersCalendarEventsPartialUpdate = async (
    id: string,
    patchedCalendarEventListRequest: PatchedCalendarEventListRequest,
    options?: RequestInit,
): Promise<CalendarEventList> => {
    return usersCalendarEventsPartialUpdateMutator<CalendarEventList>(getUsersCalendarEventsPartialUpdateUrl(id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(patchedCalendarEventListRequest),
    });
};

export const getUsersCalendarEventsPartialUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof usersCalendarEventsPartialUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: PatchedCalendarEventListRequest }) => {
        return usersCalendarEventsPartialUpdate(id, arg, options);
    };
};
export const getUsersCalendarEventsPartialUpdateMutationKey = (id: string) =>
    [`/api/users/calendar-events/${id}/`] as const;

export type UsersCalendarEventsPartialUpdateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersCalendarEventsPartialUpdate>>
>;
export type UsersCalendarEventsPartialUpdateMutationError = unknown;

export const useUsersCalendarEventsPartialUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof usersCalendarEventsPartialUpdate>>,
            TError,
            Key,
            PatchedCalendarEventListRequest,
            Awaited<ReturnType<typeof usersCalendarEventsPartialUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof usersCalendarEventsPartialUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersCalendarEventsPartialUpdateMutationKey(id);
    const swrFn = getUsersCalendarEventsPartialUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Range queries:
  GET /calendar-events/?calendar=<uuid>&start=ISO&end=ISO
 */
export const getUsersCalendarEventsDestroyUrl = (id: string) => {
    return `/api/users/calendar-events/${id}/`;
};

export const usersCalendarEventsDestroy = async (id: string, options?: RequestInit): Promise<void> => {
    return usersCalendarEventsDestroyMutator<void>(getUsersCalendarEventsDestroyUrl(id), {
        ...options,
        method: 'DELETE',
    });
};

export const getUsersCalendarEventsDestroyMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof usersCalendarEventsDestroyMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return usersCalendarEventsDestroy(id, options);
    };
};
export const getUsersCalendarEventsDestroyMutationKey = (id: string) => [`/api/users/calendar-events/${id}/`] as const;

export type UsersCalendarEventsDestroyMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersCalendarEventsDestroy>>
>;
export type UsersCalendarEventsDestroyMutationError = unknown;

export const useUsersCalendarEventsDestroy = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof usersCalendarEventsDestroy>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof usersCalendarEventsDestroy>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof usersCalendarEventsDestroyMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersCalendarEventsDestroyMutationKey(id);
    const swrFn = getUsersCalendarEventsDestroyMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersCalendarRetrieveUrl = (id: string) => {
    return `/api/users/calendar/${id}/`;
};

export const usersCalendarRetrieve = async (id: string, options?: RequestInit): Promise<Calendar> => {
    return usersCalendarRetrieveMutator<Calendar>(getUsersCalendarRetrieveUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getUsersCalendarRetrieveKey = (id: string) => [`/api/users/calendar/${id}/`] as const;

export type UsersCalendarRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof usersCalendarRetrieve>>>;
export type UsersCalendarRetrieveQueryError = unknown;

export const useUsersCalendarRetrieve = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof usersCalendarRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof usersCalendarRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersCalendarRetrieveKey(id) : null));
    const swrFn = () => usersCalendarRetrieve(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Provide owner type and UUID. Owner types: user | company | group. If the calendar does not exist it will be created. Requires the requesting user to have access to that owner.
 * @summary Get (and lazily create) a calendar for an owner
 */
export const getCalendarByOwnerUrl = (params: CalendarByOwnerParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `/api/users/calendar/owner/?${stringifiedParams}`
        : `/api/users/calendar/owner/`;
};

export const calendarByOwner = async (params: CalendarByOwnerParams, options?: RequestInit): Promise<Calendar> => {
    return calendarByOwnerMutator<Calendar>(getCalendarByOwnerUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getCalendarByOwnerKey = (params: CalendarByOwnerParams) =>
    [`/api/users/calendar/owner/`, ...(params ? [params] : [])] as const;

export type CalendarByOwnerQueryResult = NonNullable<Awaited<ReturnType<typeof calendarByOwner>>>;
export type CalendarByOwnerQueryError = unknown;

/**
 * @summary Get (and lazily create) a calendar for an owner
 */
export const useCalendarByOwner = <TError = unknown>(
    params: CalendarByOwnerParams,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof calendarByOwner>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof calendarByOwnerMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getCalendarByOwnerKey(params) : null));
    const swrFn = () => calendarByOwner(params, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersCancelhideCreateUrl = () => {
    return `/api/users/cancelhide`;
};

export const usersCancelhideCreate = async (options?: RequestInit): Promise<void> => {
    return usersCancelhideCreateMutator<void>(getUsersCancelhideCreateUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getUsersCancelhideCreateMutationFetcher = (
    options?: SecondParameter<typeof usersCancelhideCreateMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return usersCancelhideCreate(options);
    };
};
export const getUsersCancelhideCreateMutationKey = () => [`/api/users/cancelhide`] as const;

export type UsersCancelhideCreateMutationResult = NonNullable<Awaited<ReturnType<typeof usersCancelhideCreate>>>;
export type UsersCancelhideCreateMutationError = unknown;

export const useUsersCancelhideCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof usersCancelhideCreate>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof usersCancelhideCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof usersCancelhideCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersCancelhideCreateMutationKey();
    const swrFn = getUsersCancelhideCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersCompanyListUrl = () => {
    return `/api/users/company/`;
};

export const usersCompanyList = async (options?: RequestInit): Promise<Company[]> => {
    return usersCompanyListMutator<Company[]>(getUsersCompanyListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getUsersCompanyListKey = () => [`/api/users/company/`] as const;

export type UsersCompanyListQueryResult = NonNullable<Awaited<ReturnType<typeof usersCompanyList>>>;
export type UsersCompanyListQueryError = unknown;

export const useUsersCompanyList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof usersCompanyList>>, TError> & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof usersCompanyListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersCompanyListKey() : null));
    const swrFn = () => usersCompanyList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersCompanyCreateUrl = () => {
    return `/api/users/company/`;
};

export const usersCompanyCreate = async (companyRequest: CompanyRequest, options?: RequestInit): Promise<Company> => {
    return usersCompanyCreateMutator<Company>(getUsersCompanyCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(companyRequest),
    });
};

export const getUsersCompanyCreateMutationFetcher = (options?: SecondParameter<typeof usersCompanyCreateMutator>) => {
    return (_: Key, { arg }: { arg: CompanyRequest }) => {
        return usersCompanyCreate(arg, options);
    };
};
export const getUsersCompanyCreateMutationKey = () => [`/api/users/company/`] as const;

export type UsersCompanyCreateMutationResult = NonNullable<Awaited<ReturnType<typeof usersCompanyCreate>>>;
export type UsersCompanyCreateMutationError = unknown;

export const useUsersCompanyCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof usersCompanyCreate>>,
        TError,
        Key,
        CompanyRequest,
        Awaited<ReturnType<typeof usersCompanyCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof usersCompanyCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersCompanyCreateMutationKey();
    const swrFn = getUsersCompanyCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersCompanyRetrieveUrl = (id: string) => {
    return `/api/users/company/${id}/`;
};

export const usersCompanyRetrieve = async (id: string, options?: RequestInit): Promise<Company> => {
    return usersCompanyRetrieveMutator<Company>(getUsersCompanyRetrieveUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getUsersCompanyRetrieveKey = (id: string) => [`/api/users/company/${id}/`] as const;

export type UsersCompanyRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof usersCompanyRetrieve>>>;
export type UsersCompanyRetrieveQueryError = unknown;

export const useUsersCompanyRetrieve = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof usersCompanyRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof usersCompanyRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersCompanyRetrieveKey(id) : null));
    const swrFn = () => usersCompanyRetrieve(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersCompanyUpdateUrl = (id: string) => {
    return `/api/users/company/${id}/`;
};

export const usersCompanyUpdate = async (
    id: string,
    companyRequest: CompanyRequest,
    options?: RequestInit,
): Promise<Company> => {
    return usersCompanyUpdateMutator<Company>(getUsersCompanyUpdateUrl(id), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(companyRequest),
    });
};

export const getUsersCompanyUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof usersCompanyUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: CompanyRequest }) => {
        return usersCompanyUpdate(id, arg, options);
    };
};
export const getUsersCompanyUpdateMutationKey = (id: string) => [`/api/users/company/${id}/`] as const;

export type UsersCompanyUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof usersCompanyUpdate>>>;
export type UsersCompanyUpdateMutationError = unknown;

export const useUsersCompanyUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof usersCompanyUpdate>>,
            TError,
            Key,
            CompanyRequest,
            Awaited<ReturnType<typeof usersCompanyUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof usersCompanyUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersCompanyUpdateMutationKey(id);
    const swrFn = getUsersCompanyUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersCompanyPartialUpdateUrl = (id: string) => {
    return `/api/users/company/${id}/`;
};

export const usersCompanyPartialUpdate = async (
    id: string,
    patchedCompanyRequest: PatchedCompanyRequest,
    options?: RequestInit,
): Promise<Company> => {
    return usersCompanyPartialUpdateMutator<Company>(getUsersCompanyPartialUpdateUrl(id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(patchedCompanyRequest),
    });
};

export const getUsersCompanyPartialUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof usersCompanyPartialUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: PatchedCompanyRequest }) => {
        return usersCompanyPartialUpdate(id, arg, options);
    };
};
export const getUsersCompanyPartialUpdateMutationKey = (id: string) => [`/api/users/company/${id}/`] as const;

export type UsersCompanyPartialUpdateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersCompanyPartialUpdate>>
>;
export type UsersCompanyPartialUpdateMutationError = unknown;

export const useUsersCompanyPartialUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof usersCompanyPartialUpdate>>,
            TError,
            Key,
            PatchedCompanyRequest,
            Awaited<ReturnType<typeof usersCompanyPartialUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof usersCompanyPartialUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersCompanyPartialUpdateMutationKey(id);
    const swrFn = getUsersCompanyPartialUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersCompanycreationrequestListUrl = () => {
    return `/api/users/companycreationrequest/`;
};

export const usersCompanycreationrequestList = async (options?: RequestInit): Promise<CompanyCreationRequest[]> => {
    return usersCompanycreationrequestListMutator<CompanyCreationRequest[]>(getUsersCompanycreationrequestListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getUsersCompanycreationrequestListKey = () => [`/api/users/companycreationrequest/`] as const;

export type UsersCompanycreationrequestListQueryResult = NonNullable<
    Awaited<ReturnType<typeof usersCompanycreationrequestList>>
>;
export type UsersCompanycreationrequestListQueryError = unknown;

export const useUsersCompanycreationrequestList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof usersCompanycreationrequestList>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof usersCompanycreationrequestListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersCompanycreationrequestListKey() : null));
    const swrFn = () => usersCompanycreationrequestList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersCompanycreationrequestCreateUrl = () => {
    return `/api/users/companycreationrequest/`;
};

export const usersCompanycreationrequestCreate = async (
    companyCreationRequestRequest: CompanyCreationRequestRequest,
    options?: RequestInit,
): Promise<CompanyCreationRequest> => {
    return usersCompanycreationrequestCreateMutator<CompanyCreationRequest>(getUsersCompanycreationrequestCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(companyCreationRequestRequest),
    });
};

export const getUsersCompanycreationrequestCreateMutationFetcher = (
    options?: SecondParameter<typeof usersCompanycreationrequestCreateMutator>,
) => {
    return (_: Key, { arg }: { arg: CompanyCreationRequestRequest }) => {
        return usersCompanycreationrequestCreate(arg, options);
    };
};
export const getUsersCompanycreationrequestCreateMutationKey = () => [`/api/users/companycreationrequest/`] as const;

export type UsersCompanycreationrequestCreateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersCompanycreationrequestCreate>>
>;
export type UsersCompanycreationrequestCreateMutationError = unknown;

export const useUsersCompanycreationrequestCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof usersCompanycreationrequestCreate>>,
        TError,
        Key,
        CompanyCreationRequestRequest,
        Awaited<ReturnType<typeof usersCompanycreationrequestCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof usersCompanycreationrequestCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersCompanycreationrequestCreateMutationKey();
    const swrFn = getUsersCompanycreationrequestCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersCompanycreationrequestRetrieveUrl = (id: number) => {
    return `/api/users/companycreationrequest/${id}/`;
};

export const usersCompanycreationrequestRetrieve = async (
    id: number,
    options?: RequestInit,
): Promise<CompanyCreationRequest> => {
    return usersCompanycreationrequestRetrieveMutator<CompanyCreationRequest>(
        getUsersCompanycreationrequestRetrieveUrl(id),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getUsersCompanycreationrequestRetrieveKey = (id: number) =>
    [`/api/users/companycreationrequest/${id}/`] as const;

export type UsersCompanycreationrequestRetrieveQueryResult = NonNullable<
    Awaited<ReturnType<typeof usersCompanycreationrequestRetrieve>>
>;
export type UsersCompanycreationrequestRetrieveQueryError = unknown;

export const useUsersCompanycreationrequestRetrieve = <TError = unknown>(
    id: number,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof usersCompanycreationrequestRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof usersCompanycreationrequestRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersCompanycreationrequestRetrieveKey(id) : null));
    const swrFn = () => usersCompanycreationrequestRetrieve(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersCompanycreationrequestUpdateUrl = (id: number) => {
    return `/api/users/companycreationrequest/${id}/`;
};

export const usersCompanycreationrequestUpdate = async (
    id: number,
    companyCreationRequestRequest: CompanyCreationRequestRequest,
    options?: RequestInit,
): Promise<CompanyCreationRequest> => {
    return usersCompanycreationrequestUpdateMutator<CompanyCreationRequest>(
        getUsersCompanycreationrequestUpdateUrl(id),
        {
            ...options,
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', ...options?.headers },
            body: JSON.stringify(companyCreationRequestRequest),
        },
    );
};

export const getUsersCompanycreationrequestUpdateMutationFetcher = (
    id: number,
    options?: SecondParameter<typeof usersCompanycreationrequestUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: CompanyCreationRequestRequest }) => {
        return usersCompanycreationrequestUpdate(id, arg, options);
    };
};
export const getUsersCompanycreationrequestUpdateMutationKey = (id: number) =>
    [`/api/users/companycreationrequest/${id}/`] as const;

export type UsersCompanycreationrequestUpdateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersCompanycreationrequestUpdate>>
>;
export type UsersCompanycreationrequestUpdateMutationError = unknown;

export const useUsersCompanycreationrequestUpdate = <TError = unknown>(
    id: number,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof usersCompanycreationrequestUpdate>>,
            TError,
            Key,
            CompanyCreationRequestRequest,
            Awaited<ReturnType<typeof usersCompanycreationrequestUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof usersCompanycreationrequestUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersCompanycreationrequestUpdateMutationKey(id);
    const swrFn = getUsersCompanycreationrequestUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersCompanycreationrequestPartialUpdateUrl = (id: number) => {
    return `/api/users/companycreationrequest/${id}/`;
};

export const usersCompanycreationrequestPartialUpdate = async (
    id: number,
    patchedCompanyCreationRequestRequest: PatchedCompanyCreationRequestRequest,
    options?: RequestInit,
): Promise<CompanyCreationRequest> => {
    return usersCompanycreationrequestPartialUpdateMutator<CompanyCreationRequest>(
        getUsersCompanycreationrequestPartialUpdateUrl(id),
        {
            ...options,
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', ...options?.headers },
            body: JSON.stringify(patchedCompanyCreationRequestRequest),
        },
    );
};

export const getUsersCompanycreationrequestPartialUpdateMutationFetcher = (
    id: number,
    options?: SecondParameter<typeof usersCompanycreationrequestPartialUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: PatchedCompanyCreationRequestRequest }) => {
        return usersCompanycreationrequestPartialUpdate(id, arg, options);
    };
};
export const getUsersCompanycreationrequestPartialUpdateMutationKey = (id: number) =>
    [`/api/users/companycreationrequest/${id}/`] as const;

export type UsersCompanycreationrequestPartialUpdateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersCompanycreationrequestPartialUpdate>>
>;
export type UsersCompanycreationrequestPartialUpdateMutationError = unknown;

export const useUsersCompanycreationrequestPartialUpdate = <TError = unknown>(
    id: number,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof usersCompanycreationrequestPartialUpdate>>,
            TError,
            Key,
            PatchedCompanyCreationRequestRequest,
            Awaited<ReturnType<typeof usersCompanycreationrequestPartialUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof usersCompanycreationrequestPartialUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersCompanycreationrequestPartialUpdateMutationKey(id);
    const swrFn = getUsersCompanycreationrequestPartialUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersCompanycreationrequestDestroyUrl = (id: number) => {
    return `/api/users/companycreationrequest/${id}/`;
};

export const usersCompanycreationrequestDestroy = async (id: number, options?: RequestInit): Promise<void> => {
    return usersCompanycreationrequestDestroyMutator<void>(getUsersCompanycreationrequestDestroyUrl(id), {
        ...options,
        method: 'DELETE',
    });
};

export const getUsersCompanycreationrequestDestroyMutationFetcher = (
    id: number,
    options?: SecondParameter<typeof usersCompanycreationrequestDestroyMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return usersCompanycreationrequestDestroy(id, options);
    };
};
export const getUsersCompanycreationrequestDestroyMutationKey = (id: number) =>
    [`/api/users/companycreationrequest/${id}/`] as const;

export type UsersCompanycreationrequestDestroyMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersCompanycreationrequestDestroy>>
>;
export type UsersCompanycreationrequestDestroyMutationError = unknown;

export const useUsersCompanycreationrequestDestroy = <TError = unknown>(
    id: number,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof usersCompanycreationrequestDestroy>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof usersCompanycreationrequestDestroy>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof usersCompanycreationrequestDestroyMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersCompanycreationrequestDestroyMutationKey(id);
    const swrFn = getUsersCompanycreationrequestDestroyMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersCompanydashboardselectListUrl = () => {
    return `/api/users/companydashboardselect/`;
};

export const usersCompanydashboardselectList = async (options?: RequestInit): Promise<CompanyDashboardSelect[]> => {
    return usersCompanydashboardselectListMutator<CompanyDashboardSelect[]>(getUsersCompanydashboardselectListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getUsersCompanydashboardselectListKey = () => [`/api/users/companydashboardselect/`] as const;

export type UsersCompanydashboardselectListQueryResult = NonNullable<
    Awaited<ReturnType<typeof usersCompanydashboardselectList>>
>;
export type UsersCompanydashboardselectListQueryError = unknown;

export const useUsersCompanydashboardselectList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof usersCompanydashboardselectList>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof usersCompanydashboardselectListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersCompanydashboardselectListKey() : null));
    const swrFn = () => usersCompanydashboardselectList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersCompanydashboardselectRetrieveUrl = (id: string) => {
    return `/api/users/companydashboardselect/${id}/`;
};

export const usersCompanydashboardselectRetrieve = async (
    id: string,
    options?: RequestInit,
): Promise<CompanyDashboardSelect> => {
    return usersCompanydashboardselectRetrieveMutator<CompanyDashboardSelect>(
        getUsersCompanydashboardselectRetrieveUrl(id),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getUsersCompanydashboardselectRetrieveKey = (id: string) =>
    [`/api/users/companydashboardselect/${id}/`] as const;

export type UsersCompanydashboardselectRetrieveQueryResult = NonNullable<
    Awaited<ReturnType<typeof usersCompanydashboardselectRetrieve>>
>;
export type UsersCompanydashboardselectRetrieveQueryError = unknown;

export const useUsersCompanydashboardselectRetrieve = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof usersCompanydashboardselectRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof usersCompanydashboardselectRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersCompanydashboardselectRetrieveKey(id) : null));
    const swrFn = () => usersCompanydashboardselectRetrieve(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersCompanydashboardselectUpdateUrl = (id: string) => {
    return `/api/users/companydashboardselect/${id}/`;
};

export const usersCompanydashboardselectUpdate = async (
    id: string,
    companyDashboardSelectRequest: CompanyDashboardSelectRequest,
    options?: RequestInit,
): Promise<CompanyDashboardSelect> => {
    return usersCompanydashboardselectUpdateMutator<CompanyDashboardSelect>(
        getUsersCompanydashboardselectUpdateUrl(id),
        {
            ...options,
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', ...options?.headers },
            body: JSON.stringify(companyDashboardSelectRequest),
        },
    );
};

export const getUsersCompanydashboardselectUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof usersCompanydashboardselectUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: CompanyDashboardSelectRequest }) => {
        return usersCompanydashboardselectUpdate(id, arg, options);
    };
};
export const getUsersCompanydashboardselectUpdateMutationKey = (id: string) =>
    [`/api/users/companydashboardselect/${id}/`] as const;

export type UsersCompanydashboardselectUpdateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersCompanydashboardselectUpdate>>
>;
export type UsersCompanydashboardselectUpdateMutationError = unknown;

export const useUsersCompanydashboardselectUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof usersCompanydashboardselectUpdate>>,
            TError,
            Key,
            CompanyDashboardSelectRequest,
            Awaited<ReturnType<typeof usersCompanydashboardselectUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof usersCompanydashboardselectUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersCompanydashboardselectUpdateMutationKey(id);
    const swrFn = getUsersCompanydashboardselectUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersCompanydashboardselectPartialUpdateUrl = (id: string) => {
    return `/api/users/companydashboardselect/${id}/`;
};

export const usersCompanydashboardselectPartialUpdate = async (
    id: string,
    patchedCompanyDashboardSelectRequest: PatchedCompanyDashboardSelectRequest,
    options?: RequestInit,
): Promise<CompanyDashboardSelect> => {
    return usersCompanydashboardselectPartialUpdateMutator<CompanyDashboardSelect>(
        getUsersCompanydashboardselectPartialUpdateUrl(id),
        {
            ...options,
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', ...options?.headers },
            body: JSON.stringify(patchedCompanyDashboardSelectRequest),
        },
    );
};

export const getUsersCompanydashboardselectPartialUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof usersCompanydashboardselectPartialUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: PatchedCompanyDashboardSelectRequest }) => {
        return usersCompanydashboardselectPartialUpdate(id, arg, options);
    };
};
export const getUsersCompanydashboardselectPartialUpdateMutationKey = (id: string) =>
    [`/api/users/companydashboardselect/${id}/`] as const;

export type UsersCompanydashboardselectPartialUpdateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersCompanydashboardselectPartialUpdate>>
>;
export type UsersCompanydashboardselectPartialUpdateMutationError = unknown;

export const useUsersCompanydashboardselectPartialUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof usersCompanydashboardselectPartialUpdate>>,
            TError,
            Key,
            PatchedCompanyDashboardSelectRequest,
            Awaited<ReturnType<typeof usersCompanydashboardselectPartialUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof usersCompanydashboardselectPartialUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersCompanydashboardselectPartialUpdateMutationKey(id);
    const swrFn = getUsersCompanydashboardselectPartialUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersCompanylistsocialListUrl = () => {
    return `/api/users/companylistsocial/`;
};

export const usersCompanylistsocialList = async (options?: RequestInit): Promise<CompanyUser[]> => {
    return usersCompanylistsocialListMutator<CompanyUser[]>(getUsersCompanylistsocialListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getUsersCompanylistsocialListKey = () => [`/api/users/companylistsocial/`] as const;

export type UsersCompanylistsocialListQueryResult = NonNullable<Awaited<ReturnType<typeof usersCompanylistsocialList>>>;
export type UsersCompanylistsocialListQueryError = unknown;

export const useUsersCompanylistsocialList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof usersCompanylistsocialList>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof usersCompanylistsocialListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersCompanylistsocialListKey() : null));
    const swrFn = () => usersCompanylistsocialList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersCompanylistsocialRetrieveUrl = (id: string) => {
    return `/api/users/companylistsocial/${id}/`;
};

export const usersCompanylistsocialRetrieve = async (id: string, options?: RequestInit): Promise<CompanyUser> => {
    return usersCompanylistsocialRetrieveMutator<CompanyUser>(getUsersCompanylistsocialRetrieveUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getUsersCompanylistsocialRetrieveKey = (id: string) => [`/api/users/companylistsocial/${id}/`] as const;

export type UsersCompanylistsocialRetrieveQueryResult = NonNullable<
    Awaited<ReturnType<typeof usersCompanylistsocialRetrieve>>
>;
export type UsersCompanylistsocialRetrieveQueryError = unknown;

export const useUsersCompanylistsocialRetrieve = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof usersCompanylistsocialRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof usersCompanylistsocialRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersCompanylistsocialRetrieveKey(id) : null));
    const swrFn = () => usersCompanylistsocialRetrieve(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersCompanyselectListUrl = () => {
    return `/api/users/companyselect/`;
};

export const usersCompanyselectList = async (options?: RequestInit): Promise<Company[]> => {
    return usersCompanyselectListMutator<Company[]>(getUsersCompanyselectListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getUsersCompanyselectListKey = () => [`/api/users/companyselect/`] as const;

export type UsersCompanyselectListQueryResult = NonNullable<Awaited<ReturnType<typeof usersCompanyselectList>>>;
export type UsersCompanyselectListQueryError = unknown;

export const useUsersCompanyselectList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof usersCompanyselectList>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof usersCompanyselectListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersCompanyselectListKey() : null));
    const swrFn = () => usersCompanyselectList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersConferenceRoomListUrl = () => {
    return `/api/users/conference-room/`;
};

export const usersConferenceRoomList = async (options?: RequestInit): Promise<ConferenceRoom[]> => {
    return usersConferenceRoomListMutator<ConferenceRoom[]>(getUsersConferenceRoomListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getUsersConferenceRoomListKey = () => [`/api/users/conference-room/`] as const;

export type UsersConferenceRoomListQueryResult = NonNullable<Awaited<ReturnType<typeof usersConferenceRoomList>>>;
export type UsersConferenceRoomListQueryError = unknown;

export const useUsersConferenceRoomList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof usersConferenceRoomList>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof usersConferenceRoomListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersConferenceRoomListKey() : null));
    const swrFn = () => usersConferenceRoomList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Only superusers may create conference rooms. Creator becomes admin member automatically.
 * @summary Create a conference room (superuser only)
 */
export const getUsersConferenceRoomCreateUrl = () => {
    return `/api/users/conference-room/`;
};

export const usersConferenceRoomCreate = async (
    conferenceRoomRequest: ConferenceRoomRequest,
    options?: RequestInit,
): Promise<ConferenceRoom> => {
    return usersConferenceRoomCreateMutator<ConferenceRoom>(getUsersConferenceRoomCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(conferenceRoomRequest),
    });
};

export const getUsersConferenceRoomCreateMutationFetcher = (
    options?: SecondParameter<typeof usersConferenceRoomCreateMutator>,
) => {
    return (_: Key, { arg }: { arg: ConferenceRoomRequest }) => {
        return usersConferenceRoomCreate(arg, options);
    };
};
export const getUsersConferenceRoomCreateMutationKey = () => [`/api/users/conference-room/`] as const;

export type UsersConferenceRoomCreateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersConferenceRoomCreate>>
>;
export type UsersConferenceRoomCreateMutationError = unknown;

/**
 * @summary Create a conference room (superuser only)
 */
export const useUsersConferenceRoomCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof usersConferenceRoomCreate>>,
        TError,
        Key,
        ConferenceRoomRequest,
        Awaited<ReturnType<typeof usersConferenceRoomCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof usersConferenceRoomCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersConferenceRoomCreateMutationKey();
    const swrFn = getUsersConferenceRoomCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersConferenceRoomRetrieveUrl = (id: string) => {
    return `/api/users/conference-room/${id}/`;
};

export const usersConferenceRoomRetrieve = async (id: string, options?: RequestInit): Promise<ConferenceRoom> => {
    return usersConferenceRoomRetrieveMutator<ConferenceRoom>(getUsersConferenceRoomRetrieveUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getUsersConferenceRoomRetrieveKey = (id: string) => [`/api/users/conference-room/${id}/`] as const;

export type UsersConferenceRoomRetrieveQueryResult = NonNullable<
    Awaited<ReturnType<typeof usersConferenceRoomRetrieve>>
>;
export type UsersConferenceRoomRetrieveQueryError = unknown;

export const useUsersConferenceRoomRetrieve = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof usersConferenceRoomRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof usersConferenceRoomRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersConferenceRoomRetrieveKey(id) : null));
    const swrFn = () => usersConferenceRoomRetrieve(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Superuser or room admin can delete.
 * @summary Delete a conference room
 */
export const getUsersConferenceRoomDestroyUrl = (id: string) => {
    return `/api/users/conference-room/${id}/`;
};

export const usersConferenceRoomDestroy = async (id: string, options?: RequestInit): Promise<unknown> => {
    return usersConferenceRoomDestroyMutator<unknown>(getUsersConferenceRoomDestroyUrl(id), {
        ...options,
        method: 'DELETE',
    });
};

export const getUsersConferenceRoomDestroyMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof usersConferenceRoomDestroyMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return usersConferenceRoomDestroy(id, options);
    };
};
export const getUsersConferenceRoomDestroyMutationKey = (id: string) => [`/api/users/conference-room/${id}/`] as const;

export type UsersConferenceRoomDestroyMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersConferenceRoomDestroy>>
>;
export type UsersConferenceRoomDestroyMutationError = unknown;

/**
 * @summary Delete a conference room
 */
export const useUsersConferenceRoomDestroy = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof usersConferenceRoomDestroy>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof usersConferenceRoomDestroy>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof usersConferenceRoomDestroyMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersConferenceRoomDestroyMutationKey(id);
    const swrFn = getUsersConferenceRoomDestroyMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Admin or superuser can invite users (stores short-lived invite token in cache).
 * @summary Invite users to a conference room
 */
export const getUsersConferenceRoomInviteCreateUrl = (id: string, params: UsersConferenceRoomInviteCreateParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `/api/users/conference-room/${id}/invite/?${stringifiedParams}`
        : `/api/users/conference-room/${id}/invite/`;
};

export const usersConferenceRoomInviteCreate = async (
    id: string,
    usersConferenceRoomInviteCreateBody:
        | UsersConferenceRoomInviteCreateBodyOne
        | UsersConferenceRoomInviteCreateBodyTwo
        | UsersConferenceRoomInviteCreateBodyThree,
    params: UsersConferenceRoomInviteCreateParams,
    options?: RequestInit,
): Promise<unknown> => {
    return usersConferenceRoomInviteCreateMutator<unknown>(getUsersConferenceRoomInviteCreateUrl(id, params), {
        ...options,
        method: 'POST',
        body: JSON.stringify(usersConferenceRoomInviteCreateBody),
    });
};

export const getUsersConferenceRoomInviteCreateMutationFetcher = (
    id: string,
    params: UsersConferenceRoomInviteCreateParams,
    options?: SecondParameter<typeof usersConferenceRoomInviteCreateMutator>,
) => {
    return (
        _: Key,
        {
            arg,
        }: {
            arg:
                | UsersConferenceRoomInviteCreateBodyOne
                | UsersConferenceRoomInviteCreateBodyTwo
                | UsersConferenceRoomInviteCreateBodyThree;
        },
    ) => {
        return usersConferenceRoomInviteCreate(id, arg, params, options);
    };
};
export const getUsersConferenceRoomInviteCreateMutationKey = (
    id: string,
    params: UsersConferenceRoomInviteCreateParams,
) => [`/api/users/conference-room/${id}/invite/`, ...(params ? [params] : [])] as const;

export type UsersConferenceRoomInviteCreateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersConferenceRoomInviteCreate>>
>;
export type UsersConferenceRoomInviteCreateMutationError = unknown;

/**
 * @summary Invite users to a conference room
 */
export const useUsersConferenceRoomInviteCreate = <TError = unknown>(
    id: string,
    params: UsersConferenceRoomInviteCreateParams,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof usersConferenceRoomInviteCreate>>,
            TError,
            Key,
            | UsersConferenceRoomInviteCreateBodyOne
            | UsersConferenceRoomInviteCreateBodyTwo
            | UsersConferenceRoomInviteCreateBodyThree,
            Awaited<ReturnType<typeof usersConferenceRoomInviteCreate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof usersConferenceRoomInviteCreateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersConferenceRoomInviteCreateMutationKey(id, params);
    const swrFn = getUsersConferenceRoomInviteCreateMutationFetcher(id, params, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Join a public conference room directly. If not public, user_invite must be true and the user must be invited by an admin via the invite action.
 * @summary Join a conference room
 */
export const getUsersConferenceRoomJoinCreateUrl = (id: string) => {
    return `/api/users/conference-room/${id}/join/`;
};

export const usersConferenceRoomJoinCreate = async (
    id: string,
    conferenceRoomRequest: ConferenceRoomRequest,
    options?: RequestInit,
): Promise<ConferenceRoom> => {
    return usersConferenceRoomJoinCreateMutator<ConferenceRoom>(getUsersConferenceRoomJoinCreateUrl(id), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(conferenceRoomRequest),
    });
};

export const getUsersConferenceRoomJoinCreateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof usersConferenceRoomJoinCreateMutator>,
) => {
    return (_: Key, { arg }: { arg: ConferenceRoomRequest }) => {
        return usersConferenceRoomJoinCreate(id, arg, options);
    };
};
export const getUsersConferenceRoomJoinCreateMutationKey = (id: string) =>
    [`/api/users/conference-room/${id}/join/`] as const;

export type UsersConferenceRoomJoinCreateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersConferenceRoomJoinCreate>>
>;
export type UsersConferenceRoomJoinCreateMutationError = unknown;

/**
 * @summary Join a conference room
 */
export const useUsersConferenceRoomJoinCreate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof usersConferenceRoomJoinCreate>>,
            TError,
            Key,
            ConferenceRoomRequest,
            Awaited<ReturnType<typeof usersConferenceRoomJoinCreate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof usersConferenceRoomJoinCreateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersConferenceRoomJoinCreateMutationKey(id);
    const swrFn = getUsersConferenceRoomJoinCreateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Remove current user membership. Admins can leave; if they are last admin and room has others, promote first member.
 * @summary Leave a conference room
 */
export const getUsersConferenceRoomLeaveCreateUrl = (id: string) => {
    return `/api/users/conference-room/${id}/leave/`;
};

export const usersConferenceRoomLeaveCreate = async (
    id: string,
    conferenceRoomRequest: ConferenceRoomRequest,
    options?: RequestInit,
): Promise<unknown> => {
    return usersConferenceRoomLeaveCreateMutator<unknown>(getUsersConferenceRoomLeaveCreateUrl(id), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(conferenceRoomRequest),
    });
};

export const getUsersConferenceRoomLeaveCreateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof usersConferenceRoomLeaveCreateMutator>,
) => {
    return (_: Key, { arg }: { arg: ConferenceRoomRequest }) => {
        return usersConferenceRoomLeaveCreate(id, arg, options);
    };
};
export const getUsersConferenceRoomLeaveCreateMutationKey = (id: string) =>
    [`/api/users/conference-room/${id}/leave/`] as const;

export type UsersConferenceRoomLeaveCreateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersConferenceRoomLeaveCreate>>
>;
export type UsersConferenceRoomLeaveCreateMutationError = unknown;

/**
 * @summary Leave a conference room
 */
export const useUsersConferenceRoomLeaveCreate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof usersConferenceRoomLeaveCreate>>,
            TError,
            Key,
            ConferenceRoomRequest,
            Awaited<ReturnType<typeof usersConferenceRoomLeaveCreate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof usersConferenceRoomLeaveCreateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersConferenceRoomLeaveCreateMutationKey(id);
    const swrFn = getUsersConferenceRoomLeaveCreateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersCreateInviteCreateUrl = () => {
    return `/api/users/create_invite`;
};

export const usersCreateInviteCreate = async (options?: RequestInit): Promise<void> => {
    return usersCreateInviteCreateMutator<void>(getUsersCreateInviteCreateUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getUsersCreateInviteCreateMutationFetcher = (
    options?: SecondParameter<typeof usersCreateInviteCreateMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return usersCreateInviteCreate(options);
    };
};
export const getUsersCreateInviteCreateMutationKey = () => [`/api/users/create_invite`] as const;

export type UsersCreateInviteCreateMutationResult = NonNullable<Awaited<ReturnType<typeof usersCreateInviteCreate>>>;
export type UsersCreateInviteCreateMutationError = unknown;

export const useUsersCreateInviteCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof usersCreateInviteCreate>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof usersCreateInviteCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof usersCreateInviteCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersCreateInviteCreateMutationKey();
    const swrFn = getUsersCreateInviteCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersCreateSocialInviteCreateUrl = () => {
    return `/api/users/create_social_invite`;
};

export const usersCreateSocialInviteCreate = async (options?: RequestInit): Promise<void> => {
    return usersCreateSocialInviteCreateMutator<void>(getUsersCreateSocialInviteCreateUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getUsersCreateSocialInviteCreateMutationFetcher = (
    options?: SecondParameter<typeof usersCreateSocialInviteCreateMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return usersCreateSocialInviteCreate(options);
    };
};
export const getUsersCreateSocialInviteCreateMutationKey = () => [`/api/users/create_social_invite`] as const;

export type UsersCreateSocialInviteCreateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersCreateSocialInviteCreate>>
>;
export type UsersCreateSocialInviteCreateMutationError = unknown;

export const useUsersCreateSocialInviteCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof usersCreateSocialInviteCreate>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof usersCreateSocialInviteCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof usersCreateSocialInviteCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersCreateSocialInviteCreateMutationKey();
    const swrFn = getUsersCreateSocialInviteCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersDashboardListUrl = () => {
    return `/api/users/dashboard/`;
};

export const usersDashboardList = async (options?: RequestInit): Promise<Dashboard[]> => {
    return usersDashboardListMutator<Dashboard[]>(getUsersDashboardListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getUsersDashboardListKey = () => [`/api/users/dashboard/`] as const;

export type UsersDashboardListQueryResult = NonNullable<Awaited<ReturnType<typeof usersDashboardList>>>;
export type UsersDashboardListQueryError = unknown;

export const useUsersDashboardList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof usersDashboardList>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof usersDashboardListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersDashboardListKey() : null));
    const swrFn = () => usersDashboardList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersDashboardCreateUrl = () => {
    return `/api/users/dashboard/`;
};

export const usersDashboardCreate = async (
    dashboardRequest: DashboardRequest,
    options?: RequestInit,
): Promise<Dashboard> => {
    return usersDashboardCreateMutator<Dashboard>(getUsersDashboardCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(dashboardRequest),
    });
};

export const getUsersDashboardCreateMutationFetcher = (
    options?: SecondParameter<typeof usersDashboardCreateMutator>,
) => {
    return (_: Key, { arg }: { arg: DashboardRequest }) => {
        return usersDashboardCreate(arg, options);
    };
};
export const getUsersDashboardCreateMutationKey = () => [`/api/users/dashboard/`] as const;

export type UsersDashboardCreateMutationResult = NonNullable<Awaited<ReturnType<typeof usersDashboardCreate>>>;
export type UsersDashboardCreateMutationError = unknown;

export const useUsersDashboardCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof usersDashboardCreate>>,
        TError,
        Key,
        DashboardRequest,
        Awaited<ReturnType<typeof usersDashboardCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof usersDashboardCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersDashboardCreateMutationKey();
    const swrFn = getUsersDashboardCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersDashboardRetrieveUrl = (id: string) => {
    return `/api/users/dashboard/${id}/`;
};

export const usersDashboardRetrieve = async (id: string, options?: RequestInit): Promise<Dashboard> => {
    return usersDashboardRetrieveMutator<Dashboard>(getUsersDashboardRetrieveUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getUsersDashboardRetrieveKey = (id: string) => [`/api/users/dashboard/${id}/`] as const;

export type UsersDashboardRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof usersDashboardRetrieve>>>;
export type UsersDashboardRetrieveQueryError = unknown;

export const useUsersDashboardRetrieve = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof usersDashboardRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof usersDashboardRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersDashboardRetrieveKey(id) : null));
    const swrFn = () => usersDashboardRetrieve(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersDashboardUpdateUrl = (id: string) => {
    return `/api/users/dashboard/${id}/`;
};

export const usersDashboardUpdate = async (
    id: string,
    dashboardRequest: DashboardRequest,
    options?: RequestInit,
): Promise<Dashboard> => {
    return usersDashboardUpdateMutator<Dashboard>(getUsersDashboardUpdateUrl(id), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(dashboardRequest),
    });
};

export const getUsersDashboardUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof usersDashboardUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: DashboardRequest }) => {
        return usersDashboardUpdate(id, arg, options);
    };
};
export const getUsersDashboardUpdateMutationKey = (id: string) => [`/api/users/dashboard/${id}/`] as const;

export type UsersDashboardUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof usersDashboardUpdate>>>;
export type UsersDashboardUpdateMutationError = unknown;

export const useUsersDashboardUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof usersDashboardUpdate>>,
            TError,
            Key,
            DashboardRequest,
            Awaited<ReturnType<typeof usersDashboardUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof usersDashboardUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersDashboardUpdateMutationKey(id);
    const swrFn = getUsersDashboardUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersDashboardPartialUpdateUrl = (id: string) => {
    return `/api/users/dashboard/${id}/`;
};

export const usersDashboardPartialUpdate = async (
    id: string,
    patchedDashboardRequest: PatchedDashboardRequest,
    options?: RequestInit,
): Promise<Dashboard> => {
    return usersDashboardPartialUpdateMutator<Dashboard>(getUsersDashboardPartialUpdateUrl(id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(patchedDashboardRequest),
    });
};

export const getUsersDashboardPartialUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof usersDashboardPartialUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: PatchedDashboardRequest }) => {
        return usersDashboardPartialUpdate(id, arg, options);
    };
};
export const getUsersDashboardPartialUpdateMutationKey = (id: string) => [`/api/users/dashboard/${id}/`] as const;

export type UsersDashboardPartialUpdateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersDashboardPartialUpdate>>
>;
export type UsersDashboardPartialUpdateMutationError = unknown;

export const useUsersDashboardPartialUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof usersDashboardPartialUpdate>>,
            TError,
            Key,
            PatchedDashboardRequest,
            Awaited<ReturnType<typeof usersDashboardPartialUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof usersDashboardPartialUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersDashboardPartialUpdateMutationKey(id);
    const swrFn = getUsersDashboardPartialUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersDashboardDestroyUrl = (id: string) => {
    return `/api/users/dashboard/${id}/`;
};

export const usersDashboardDestroy = async (id: string, options?: RequestInit): Promise<void> => {
    return usersDashboardDestroyMutator<void>(getUsersDashboardDestroyUrl(id), {
        ...options,
        method: 'DELETE',
    });
};

export const getUsersDashboardDestroyMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof usersDashboardDestroyMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return usersDashboardDestroy(id, options);
    };
};
export const getUsersDashboardDestroyMutationKey = (id: string) => [`/api/users/dashboard/${id}/`] as const;

export type UsersDashboardDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof usersDashboardDestroy>>>;
export type UsersDashboardDestroyMutationError = unknown;

export const useUsersDashboardDestroy = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof usersDashboardDestroy>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof usersDashboardDestroy>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof usersDashboardDestroyMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersDashboardDestroyMutationKey(id);
    const swrFn = getUsersDashboardDestroyMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersDashboardWithTokenRetrieveUrl = () => {
    return `/api/users/dashboard_with_token`;
};

export const usersDashboardWithTokenRetrieve = async (options?: RequestInit): Promise<void> => {
    return usersDashboardWithTokenRetrieveMutator<void>(getUsersDashboardWithTokenRetrieveUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getUsersDashboardWithTokenRetrieveKey = () => [`/api/users/dashboard_with_token`] as const;

export type UsersDashboardWithTokenRetrieveQueryResult = NonNullable<
    Awaited<ReturnType<typeof usersDashboardWithTokenRetrieve>>
>;
export type UsersDashboardWithTokenRetrieveQueryError = unknown;

export const useUsersDashboardWithTokenRetrieve = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof usersDashboardWithTokenRetrieve>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof usersDashboardWithTokenRetrieveMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersDashboardWithTokenRetrieveKey() : null));
    const swrFn = () => usersDashboardWithTokenRetrieve(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersDashboardcompanyRetrieveUrl = (id: string) => {
    return `/api/users/dashboardcompany/${id}/`;
};

export const usersDashboardcompanyRetrieve = async (
    id: string,
    options?: RequestInit,
): Promise<DashboardCompanyUser> => {
    return usersDashboardcompanyRetrieveMutator<DashboardCompanyUser>(getUsersDashboardcompanyRetrieveUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getUsersDashboardcompanyRetrieveKey = (id: string) => [`/api/users/dashboardcompany/${id}/`] as const;

export type UsersDashboardcompanyRetrieveQueryResult = NonNullable<
    Awaited<ReturnType<typeof usersDashboardcompanyRetrieve>>
>;
export type UsersDashboardcompanyRetrieveQueryError = unknown;

export const useUsersDashboardcompanyRetrieve = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof usersDashboardcompanyRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof usersDashboardcompanyRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersDashboardcompanyRetrieveKey(id) : null));
    const swrFn = () => usersDashboardcompanyRetrieve(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersDashboardsocialgroupRetrieveUrl = (id: string) => {
    return `/api/users/dashboardsocialgroup/${id}/`;
};

export const usersDashboardsocialgroupRetrieve = async (
    id: string,
    options?: RequestInit,
): Promise<DashboardSocialGroup> => {
    return usersDashboardsocialgroupRetrieveMutator<DashboardSocialGroup>(getUsersDashboardsocialgroupRetrieveUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getUsersDashboardsocialgroupRetrieveKey = (id: string) =>
    [`/api/users/dashboardsocialgroup/${id}/`] as const;

export type UsersDashboardsocialgroupRetrieveQueryResult = NonNullable<
    Awaited<ReturnType<typeof usersDashboardsocialgroupRetrieve>>
>;
export type UsersDashboardsocialgroupRetrieveQueryError = unknown;

export const useUsersDashboardsocialgroupRetrieve = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof usersDashboardsocialgroupRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof usersDashboardsocialgroupRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersDashboardsocialgroupRetrieveKey(id) : null));
    const swrFn = () => usersDashboardsocialgroupRetrieve(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersDashboardtokenListUrl = () => {
    return `/api/users/dashboardtoken/`;
};

export const usersDashboardtokenList = async (options?: RequestInit): Promise<DashboardTokenNew[]> => {
    return usersDashboardtokenListMutator<DashboardTokenNew[]>(getUsersDashboardtokenListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getUsersDashboardtokenListKey = () => [`/api/users/dashboardtoken/`] as const;

export type UsersDashboardtokenListQueryResult = NonNullable<Awaited<ReturnType<typeof usersDashboardtokenList>>>;
export type UsersDashboardtokenListQueryError = unknown;

export const useUsersDashboardtokenList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof usersDashboardtokenList>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof usersDashboardtokenListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersDashboardtokenListKey() : null));
    const swrFn = () => usersDashboardtokenList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersDashboardtokenCreateUrl = () => {
    return `/api/users/dashboardtoken/`;
};

export const usersDashboardtokenCreate = async (
    dashboardTokenNewRequest: DashboardTokenNewRequest,
    options?: RequestInit,
): Promise<DashboardTokenNew> => {
    return usersDashboardtokenCreateMutator<DashboardTokenNew>(getUsersDashboardtokenCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(dashboardTokenNewRequest),
    });
};

export const getUsersDashboardtokenCreateMutationFetcher = (
    options?: SecondParameter<typeof usersDashboardtokenCreateMutator>,
) => {
    return (_: Key, { arg }: { arg: DashboardTokenNewRequest }) => {
        return usersDashboardtokenCreate(arg, options);
    };
};
export const getUsersDashboardtokenCreateMutationKey = () => [`/api/users/dashboardtoken/`] as const;

export type UsersDashboardtokenCreateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersDashboardtokenCreate>>
>;
export type UsersDashboardtokenCreateMutationError = unknown;

export const useUsersDashboardtokenCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof usersDashboardtokenCreate>>,
        TError,
        Key,
        DashboardTokenNewRequest,
        Awaited<ReturnType<typeof usersDashboardtokenCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof usersDashboardtokenCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersDashboardtokenCreateMutationKey();
    const swrFn = getUsersDashboardtokenCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersDashboardtokenRetrieveUrl = (id: string) => {
    return `/api/users/dashboardtoken/${id}/`;
};

export const usersDashboardtokenRetrieve = async (id: string, options?: RequestInit): Promise<DashboardTokenNew> => {
    return usersDashboardtokenRetrieveMutator<DashboardTokenNew>(getUsersDashboardtokenRetrieveUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getUsersDashboardtokenRetrieveKey = (id: string) => [`/api/users/dashboardtoken/${id}/`] as const;

export type UsersDashboardtokenRetrieveQueryResult = NonNullable<
    Awaited<ReturnType<typeof usersDashboardtokenRetrieve>>
>;
export type UsersDashboardtokenRetrieveQueryError = unknown;

export const useUsersDashboardtokenRetrieve = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof usersDashboardtokenRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof usersDashboardtokenRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersDashboardtokenRetrieveKey(id) : null));
    const swrFn = () => usersDashboardtokenRetrieve(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersDashboardtokenDestroyUrl = (id: string) => {
    return `/api/users/dashboardtoken/${id}/`;
};

export const usersDashboardtokenDestroy = async (id: string, options?: RequestInit): Promise<void> => {
    return usersDashboardtokenDestroyMutator<void>(getUsersDashboardtokenDestroyUrl(id), {
        ...options,
        method: 'DELETE',
    });
};

export const getUsersDashboardtokenDestroyMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof usersDashboardtokenDestroyMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return usersDashboardtokenDestroy(id, options);
    };
};
export const getUsersDashboardtokenDestroyMutationKey = (id: string) => [`/api/users/dashboardtoken/${id}/`] as const;

export type UsersDashboardtokenDestroyMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersDashboardtokenDestroy>>
>;
export type UsersDashboardtokenDestroyMutationError = unknown;

export const useUsersDashboardtokenDestroy = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof usersDashboardtokenDestroy>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof usersDashboardtokenDestroy>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof usersDashboardtokenDestroyMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersDashboardtokenDestroyMutationKey(id);
    const swrFn = getUsersDashboardtokenDestroyMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersDeleteCompanyDestroyUrl = () => {
    return `/api/users/delete_company`;
};

export const usersDeleteCompanyDestroy = async (options?: RequestInit): Promise<void> => {
    return usersDeleteCompanyDestroyMutator<void>(getUsersDeleteCompanyDestroyUrl(), {
        ...options,
        method: 'DELETE',
    });
};

export const getUsersDeleteCompanyDestroyMutationFetcher = (
    options?: SecondParameter<typeof usersDeleteCompanyDestroyMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return usersDeleteCompanyDestroy(options);
    };
};
export const getUsersDeleteCompanyDestroyMutationKey = () => [`/api/users/delete_company`] as const;

export type UsersDeleteCompanyDestroyMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersDeleteCompanyDestroy>>
>;
export type UsersDeleteCompanyDestroyMutationError = unknown;

export const useUsersDeleteCompanyDestroy = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof usersDeleteCompanyDestroy>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof usersDeleteCompanyDestroy>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof usersDeleteCompanyDestroyMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersDeleteCompanyDestroyMutationKey();
    const swrFn = getUsersDeleteCompanyDestroyMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersDeleteGroupDestroyUrl = () => {
    return `/api/users/delete_group`;
};

export const usersDeleteGroupDestroy = async (options?: RequestInit): Promise<void> => {
    return usersDeleteGroupDestroyMutator<void>(getUsersDeleteGroupDestroyUrl(), {
        ...options,
        method: 'DELETE',
    });
};

export const getUsersDeleteGroupDestroyMutationFetcher = (
    options?: SecondParameter<typeof usersDeleteGroupDestroyMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return usersDeleteGroupDestroy(options);
    };
};
export const getUsersDeleteGroupDestroyMutationKey = () => [`/api/users/delete_group`] as const;

export type UsersDeleteGroupDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof usersDeleteGroupDestroy>>>;
export type UsersDeleteGroupDestroyMutationError = unknown;

export const useUsersDeleteGroupDestroy = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof usersDeleteGroupDestroy>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof usersDeleteGroupDestroy>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof usersDeleteGroupDestroyMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersDeleteGroupDestroyMutationKey();
    const swrFn = getUsersDeleteGroupDestroyMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersEventapiusersListUrl = () => {
    return `/api/users/eventapiusers/`;
};

export const usersEventapiusersList = async (options?: RequestInit): Promise<EventApiUsers[]> => {
    return usersEventapiusersListMutator<EventApiUsers[]>(getUsersEventapiusersListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getUsersEventapiusersListKey = () => [`/api/users/eventapiusers/`] as const;

export type UsersEventapiusersListQueryResult = NonNullable<Awaited<ReturnType<typeof usersEventapiusersList>>>;
export type UsersEventapiusersListQueryError = unknown;

export const useUsersEventapiusersList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof usersEventapiusersList>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof usersEventapiusersListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersEventapiusersListKey() : null));
    const swrFn = () => usersEventapiusersList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersExtendDashboardTokenPartialUpdateUrl = () => {
    return `/api/users/extend_dashboard_token`;
};

export const usersExtendDashboardTokenPartialUpdate = async (options?: RequestInit): Promise<void> => {
    return usersExtendDashboardTokenPartialUpdateMutator<void>(getUsersExtendDashboardTokenPartialUpdateUrl(), {
        ...options,
        method: 'PATCH',
    });
};

export const getUsersExtendDashboardTokenPartialUpdateMutationFetcher = (
    options?: SecondParameter<typeof usersExtendDashboardTokenPartialUpdateMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return usersExtendDashboardTokenPartialUpdate(options);
    };
};
export const getUsersExtendDashboardTokenPartialUpdateMutationKey = () =>
    [`/api/users/extend_dashboard_token`] as const;

export type UsersExtendDashboardTokenPartialUpdateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersExtendDashboardTokenPartialUpdate>>
>;
export type UsersExtendDashboardTokenPartialUpdateMutationError = unknown;

export const useUsersExtendDashboardTokenPartialUpdate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof usersExtendDashboardTokenPartialUpdate>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof usersExtendDashboardTokenPartialUpdate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof usersExtendDashboardTokenPartialUpdateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersExtendDashboardTokenPartialUpdateMutationKey();
    const swrFn = getUsersExtendDashboardTokenPartialUpdateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersGrouprequestsListUrl = () => {
    return `/api/users/grouprequests/`;
};

export const usersGrouprequestsList = async (options?: RequestInit): Promise<GroupRequests[]> => {
    return usersGrouprequestsListMutator<GroupRequests[]>(getUsersGrouprequestsListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getUsersGrouprequestsListKey = () => [`/api/users/grouprequests/`] as const;

export type UsersGrouprequestsListQueryResult = NonNullable<Awaited<ReturnType<typeof usersGrouprequestsList>>>;
export type UsersGrouprequestsListQueryError = unknown;

export const useUsersGrouprequestsList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof usersGrouprequestsList>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof usersGrouprequestsListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersGrouprequestsListKey() : null));
    const swrFn = () => usersGrouprequestsList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersHandleCompanyCreationRequestCreateUrl = () => {
    return `/api/users/handle_company_creation_request`;
};

export const usersHandleCompanyCreationRequestCreate = async (options?: RequestInit): Promise<void> => {
    return usersHandleCompanyCreationRequestCreateMutator<void>(getUsersHandleCompanyCreationRequestCreateUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getUsersHandleCompanyCreationRequestCreateMutationFetcher = (
    options?: SecondParameter<typeof usersHandleCompanyCreationRequestCreateMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return usersHandleCompanyCreationRequestCreate(options);
    };
};
export const getUsersHandleCompanyCreationRequestCreateMutationKey = () =>
    [`/api/users/handle_company_creation_request`] as const;

export type UsersHandleCompanyCreationRequestCreateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersHandleCompanyCreationRequestCreate>>
>;
export type UsersHandleCompanyCreationRequestCreateMutationError = unknown;

export const useUsersHandleCompanyCreationRequestCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof usersHandleCompanyCreationRequestCreate>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof usersHandleCompanyCreationRequestCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof usersHandleCompanyCreationRequestCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersHandleCompanyCreationRequestCreateMutationKey();
    const swrFn = getUsersHandleCompanyCreationRequestCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersHandleGroupRequestCreateUrl = () => {
    return `/api/users/handle_group_request`;
};

export const usersHandleGroupRequestCreate = async (options?: RequestInit): Promise<void> => {
    return usersHandleGroupRequestCreateMutator<void>(getUsersHandleGroupRequestCreateUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getUsersHandleGroupRequestCreateMutationFetcher = (
    options?: SecondParameter<typeof usersHandleGroupRequestCreateMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return usersHandleGroupRequestCreate(options);
    };
};
export const getUsersHandleGroupRequestCreateMutationKey = () => [`/api/users/handle_group_request`] as const;

export type UsersHandleGroupRequestCreateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersHandleGroupRequestCreate>>
>;
export type UsersHandleGroupRequestCreateMutationError = unknown;

export const useUsersHandleGroupRequestCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof usersHandleGroupRequestCreate>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof usersHandleGroupRequestCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof usersHandleGroupRequestCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersHandleGroupRequestCreateMutationKey();
    const swrFn = getUsersHandleGroupRequestCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersHandleRegisterRequestCreateUrl = () => {
    return `/api/users/handle_register_request`;
};

export const usersHandleRegisterRequestCreate = async (options?: RequestInit): Promise<void> => {
    return usersHandleRegisterRequestCreateMutator<void>(getUsersHandleRegisterRequestCreateUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getUsersHandleRegisterRequestCreateMutationFetcher = (
    options?: SecondParameter<typeof usersHandleRegisterRequestCreateMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return usersHandleRegisterRequestCreate(options);
    };
};
export const getUsersHandleRegisterRequestCreateMutationKey = () => [`/api/users/handle_register_request`] as const;

export type UsersHandleRegisterRequestCreateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersHandleRegisterRequestCreate>>
>;
export type UsersHandleRegisterRequestCreateMutationError = unknown;

export const useUsersHandleRegisterRequestCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof usersHandleRegisterRequestCreate>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof usersHandleRegisterRequestCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof usersHandleRegisterRequestCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersHandleRegisterRequestCreateMutationKey();
    const swrFn = getUsersHandleRegisterRequestCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersHasAccountRetrieveUrl = () => {
    return `/api/users/has_account`;
};

export const usersHasAccountRetrieve = async (options?: RequestInit): Promise<void> => {
    return usersHasAccountRetrieveMutator<void>(getUsersHasAccountRetrieveUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getUsersHasAccountRetrieveKey = () => [`/api/users/has_account`] as const;

export type UsersHasAccountRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof usersHasAccountRetrieve>>>;
export type UsersHasAccountRetrieveQueryError = unknown;

export const useUsersHasAccountRetrieve = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof usersHasAccountRetrieve>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof usersHasAccountRetrieveMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersHasAccountRetrieveKey() : null));
    const swrFn = () => usersHasAccountRetrieve(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersHiddentimeCreateUrl = () => {
    return `/api/users/hiddentime/`;
};

export const usersHiddentimeCreate = async (
    hiddenTimeRequest: HiddenTimeRequest,
    options?: RequestInit,
): Promise<HiddenTime> => {
    return usersHiddentimeCreateMutator<HiddenTime>(getUsersHiddentimeCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(hiddenTimeRequest),
    });
};

export const getUsersHiddentimeCreateMutationFetcher = (
    options?: SecondParameter<typeof usersHiddentimeCreateMutator>,
) => {
    return (_: Key, { arg }: { arg: HiddenTimeRequest }) => {
        return usersHiddentimeCreate(arg, options);
    };
};
export const getUsersHiddentimeCreateMutationKey = () => [`/api/users/hiddentime/`] as const;

export type UsersHiddentimeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof usersHiddentimeCreate>>>;
export type UsersHiddentimeCreateMutationError = unknown;

export const useUsersHiddentimeCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof usersHiddentimeCreate>>,
        TError,
        Key,
        HiddenTimeRequest,
        Awaited<ReturnType<typeof usersHiddentimeCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof usersHiddentimeCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersHiddentimeCreateMutationKey();
    const swrFn = getUsersHiddentimeCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersJoinSocialDirectCreateUrl = () => {
    return `/api/users/join_social_direct`;
};

export const usersJoinSocialDirectCreate = async (options?: RequestInit): Promise<void> => {
    return usersJoinSocialDirectCreateMutator<void>(getUsersJoinSocialDirectCreateUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getUsersJoinSocialDirectCreateMutationFetcher = (
    options?: SecondParameter<typeof usersJoinSocialDirectCreateMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return usersJoinSocialDirectCreate(options);
    };
};
export const getUsersJoinSocialDirectCreateMutationKey = () => [`/api/users/join_social_direct`] as const;

export type UsersJoinSocialDirectCreateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersJoinSocialDirectCreate>>
>;
export type UsersJoinSocialDirectCreateMutationError = unknown;

export const useUsersJoinSocialDirectCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof usersJoinSocialDirectCreate>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof usersJoinSocialDirectCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof usersJoinSocialDirectCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersJoinSocialDirectCreateMutationKey();
    const swrFn = getUsersJoinSocialDirectCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersJwtuserListUrl = () => {
    return `/api/users/jwtuser/`;
};

export const usersJwtuserList = async (options?: RequestInit): Promise<JwtUser[]> => {
    return usersJwtuserListMutator<JwtUser[]>(getUsersJwtuserListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getUsersJwtuserListKey = () => [`/api/users/jwtuser/`] as const;

export type UsersJwtuserListQueryResult = NonNullable<Awaited<ReturnType<typeof usersJwtuserList>>>;
export type UsersJwtuserListQueryError = unknown;

export const useUsersJwtuserList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof usersJwtuserList>>, TError> & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof usersJwtuserListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersJwtuserListKey() : null));
    const swrFn = () => usersJwtuserList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersKickFromCompanyCreateUrl = () => {
    return `/api/users/kick_from_company`;
};

export const usersKickFromCompanyCreate = async (options?: RequestInit): Promise<void> => {
    return usersKickFromCompanyCreateMutator<void>(getUsersKickFromCompanyCreateUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getUsersKickFromCompanyCreateMutationFetcher = (
    options?: SecondParameter<typeof usersKickFromCompanyCreateMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return usersKickFromCompanyCreate(options);
    };
};
export const getUsersKickFromCompanyCreateMutationKey = () => [`/api/users/kick_from_company`] as const;

export type UsersKickFromCompanyCreateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersKickFromCompanyCreate>>
>;
export type UsersKickFromCompanyCreateMutationError = unknown;

export const useUsersKickFromCompanyCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof usersKickFromCompanyCreate>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof usersKickFromCompanyCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof usersKickFromCompanyCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersKickFromCompanyCreateMutationKey();
    const swrFn = getUsersKickFromCompanyCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersKickFromSocialCreateUrl = () => {
    return `/api/users/kick_from_social`;
};

export const usersKickFromSocialCreate = async (options?: RequestInit): Promise<void> => {
    return usersKickFromSocialCreateMutator<void>(getUsersKickFromSocialCreateUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getUsersKickFromSocialCreateMutationFetcher = (
    options?: SecondParameter<typeof usersKickFromSocialCreateMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return usersKickFromSocialCreate(options);
    };
};
export const getUsersKickFromSocialCreateMutationKey = () => [`/api/users/kick_from_social`] as const;

export type UsersKickFromSocialCreateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersKickFromSocialCreate>>
>;
export type UsersKickFromSocialCreateMutationError = unknown;

export const useUsersKickFromSocialCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof usersKickFromSocialCreate>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof usersKickFromSocialCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof usersKickFromSocialCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersKickFromSocialCreateMutationKey();
    const swrFn = getUsersKickFromSocialCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersLeaveCompanyCreateUrl = () => {
    return `/api/users/leave_company`;
};

export const usersLeaveCompanyCreate = async (options?: RequestInit): Promise<void> => {
    return usersLeaveCompanyCreateMutator<void>(getUsersLeaveCompanyCreateUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getUsersLeaveCompanyCreateMutationFetcher = (
    options?: SecondParameter<typeof usersLeaveCompanyCreateMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return usersLeaveCompanyCreate(options);
    };
};
export const getUsersLeaveCompanyCreateMutationKey = () => [`/api/users/leave_company`] as const;

export type UsersLeaveCompanyCreateMutationResult = NonNullable<Awaited<ReturnType<typeof usersLeaveCompanyCreate>>>;
export type UsersLeaveCompanyCreateMutationError = unknown;

export const useUsersLeaveCompanyCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof usersLeaveCompanyCreate>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof usersLeaveCompanyCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof usersLeaveCompanyCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersLeaveCompanyCreateMutationKey();
    const swrFn = getUsersLeaveCompanyCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersLeaveInstanceDestroyUrl = () => {
    return `/api/users/leave_instance`;
};

export const usersLeaveInstanceDestroy = async (options?: RequestInit): Promise<void> => {
    return usersLeaveInstanceDestroyMutator<void>(getUsersLeaveInstanceDestroyUrl(), {
        ...options,
        method: 'DELETE',
    });
};

export const getUsersLeaveInstanceDestroyMutationFetcher = (
    options?: SecondParameter<typeof usersLeaveInstanceDestroyMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return usersLeaveInstanceDestroy(options);
    };
};
export const getUsersLeaveInstanceDestroyMutationKey = () => [`/api/users/leave_instance`] as const;

export type UsersLeaveInstanceDestroyMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersLeaveInstanceDestroy>>
>;
export type UsersLeaveInstanceDestroyMutationError = unknown;

export const useUsersLeaveInstanceDestroy = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof usersLeaveInstanceDestroy>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof usersLeaveInstanceDestroy>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof usersLeaveInstanceDestroyMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersLeaveInstanceDestroyMutationKey();
    const swrFn = getUsersLeaveInstanceDestroyMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersLeaveSocialCreateUrl = () => {
    return `/api/users/leave_social`;
};

export const usersLeaveSocialCreate = async (options?: RequestInit): Promise<void> => {
    return usersLeaveSocialCreateMutator<void>(getUsersLeaveSocialCreateUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getUsersLeaveSocialCreateMutationFetcher = (
    options?: SecondParameter<typeof usersLeaveSocialCreateMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return usersLeaveSocialCreate(options);
    };
};
export const getUsersLeaveSocialCreateMutationKey = () => [`/api/users/leave_social`] as const;

export type UsersLeaveSocialCreateMutationResult = NonNullable<Awaited<ReturnType<typeof usersLeaveSocialCreate>>>;
export type UsersLeaveSocialCreateMutationError = unknown;

export const useUsersLeaveSocialCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof usersLeaveSocialCreate>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof usersLeaveSocialCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof usersLeaveSocialCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersLeaveSocialCreateMutationKey();
    const swrFn = getUsersLeaveSocialCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersNewUserCreateUrl = () => {
    return `/api/users/new_user`;
};

export const usersNewUserCreate = async (options?: RequestInit): Promise<void> => {
    return usersNewUserCreateMutator<void>(getUsersNewUserCreateUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getUsersNewUserCreateMutationFetcher = (options?: SecondParameter<typeof usersNewUserCreateMutator>) => {
    return (_: Key, __: { arg: Arguments }) => {
        return usersNewUserCreate(options);
    };
};
export const getUsersNewUserCreateMutationKey = () => [`/api/users/new_user`] as const;

export type UsersNewUserCreateMutationResult = NonNullable<Awaited<ReturnType<typeof usersNewUserCreate>>>;
export type UsersNewUserCreateMutationError = unknown;

export const useUsersNewUserCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof usersNewUserCreate>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof usersNewUserCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof usersNewUserCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersNewUserCreateMutationKey();
    const swrFn = getUsersNewUserCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersPreloadWithEmailsCreateUrl = () => {
    return `/api/users/preload_with_emails`;
};

export const usersPreloadWithEmailsCreate = async (options?: RequestInit): Promise<void> => {
    return usersPreloadWithEmailsCreateMutator<void>(getUsersPreloadWithEmailsCreateUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getUsersPreloadWithEmailsCreateMutationFetcher = (
    options?: SecondParameter<typeof usersPreloadWithEmailsCreateMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return usersPreloadWithEmailsCreate(options);
    };
};
export const getUsersPreloadWithEmailsCreateMutationKey = () => [`/api/users/preload_with_emails`] as const;

export type UsersPreloadWithEmailsCreateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersPreloadWithEmailsCreate>>
>;
export type UsersPreloadWithEmailsCreateMutationError = unknown;

export const useUsersPreloadWithEmailsCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof usersPreloadWithEmailsCreate>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof usersPreloadWithEmailsCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof usersPreloadWithEmailsCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersPreloadWithEmailsCreateMutationKey();
    const swrFn = getUsersPreloadWithEmailsCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersProfilelistsocialListUrl = () => {
    return `/api/users/profilelistsocial/`;
};

export const usersProfilelistsocialList = async (options?: RequestInit): Promise<ProfileList[]> => {
    return usersProfilelistsocialListMutator<ProfileList[]>(getUsersProfilelistsocialListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getUsersProfilelistsocialListKey = () => [`/api/users/profilelistsocial/`] as const;

export type UsersProfilelistsocialListQueryResult = NonNullable<Awaited<ReturnType<typeof usersProfilelistsocialList>>>;
export type UsersProfilelistsocialListQueryError = unknown;

export const useUsersProfilelistsocialList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof usersProfilelistsocialList>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof usersProfilelistsocialListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersProfilelistsocialListKey() : null));
    const swrFn = () => usersProfilelistsocialList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersRegisterrequestListUrl = () => {
    return `/api/users/registerrequest/`;
};

export const usersRegisterrequestList = async (options?: RequestInit): Promise<RegisterRequest[]> => {
    return usersRegisterrequestListMutator<RegisterRequest[]>(getUsersRegisterrequestListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getUsersRegisterrequestListKey = () => [`/api/users/registerrequest/`] as const;

export type UsersRegisterrequestListQueryResult = NonNullable<Awaited<ReturnType<typeof usersRegisterrequestList>>>;
export type UsersRegisterrequestListQueryError = unknown;

export const useUsersRegisterrequestList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof usersRegisterrequestList>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof usersRegisterrequestListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersRegisterrequestListKey() : null));
    const swrFn = () => usersRegisterrequestList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersRegisterrequestRetrieveUrl = (id: number) => {
    return `/api/users/registerrequest/${id}/`;
};

export const usersRegisterrequestRetrieve = async (id: number, options?: RequestInit): Promise<RegisterRequest> => {
    return usersRegisterrequestRetrieveMutator<RegisterRequest>(getUsersRegisterrequestRetrieveUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getUsersRegisterrequestRetrieveKey = (id: number) => [`/api/users/registerrequest/${id}/`] as const;

export type UsersRegisterrequestRetrieveQueryResult = NonNullable<
    Awaited<ReturnType<typeof usersRegisterrequestRetrieve>>
>;
export type UsersRegisterrequestRetrieveQueryError = unknown;

export const useUsersRegisterrequestRetrieve = <TError = unknown>(
    id: number,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof usersRegisterrequestRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof usersRegisterrequestRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersRegisterrequestRetrieveKey(id) : null));
    const swrFn = () => usersRegisterrequestRetrieve(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersRoleUsersRetrieveUrl = () => {
    return `/api/users/role_users`;
};

export const usersRoleUsersRetrieve = async (options?: RequestInit): Promise<void> => {
    return usersRoleUsersRetrieveMutator<void>(getUsersRoleUsersRetrieveUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getUsersRoleUsersRetrieveKey = () => [`/api/users/role_users`] as const;

export type UsersRoleUsersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof usersRoleUsersRetrieve>>>;
export type UsersRoleUsersRetrieveQueryError = unknown;

export const useUsersRoleUsersRetrieve = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof usersRoleUsersRetrieve>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof usersRoleUsersRetrieveMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersRoleUsersRetrieveKey() : null));
    const swrFn = () => usersRoleUsersRetrieve(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Self-service auto-join token for a room's social group.

The room's tag QR (a permanent link owned by the tag/redirect system, not this
endpoint) lands an authenticated-but-unauthorized user on the room calendar,
which calls this to get-or-create the group's reusable, non-expiring join
token and complete the join via /new_user/<id>.
 */
export const getUsersRoomQrTokenRetrieveUrl = (groupId: string) => {
    return `/api/users/room_qr_token/${groupId}`;
};

export const usersRoomQrTokenRetrieve = async (groupId: string, options?: RequestInit): Promise<void> => {
    return usersRoomQrTokenRetrieveMutator<void>(getUsersRoomQrTokenRetrieveUrl(groupId), {
        ...options,
        method: 'GET',
    });
};

export const getUsersRoomQrTokenRetrieveKey = (groupId: string) => [`/api/users/room_qr_token/${groupId}`] as const;

export type UsersRoomQrTokenRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof usersRoomQrTokenRetrieve>>>;
export type UsersRoomQrTokenRetrieveQueryError = unknown;

export const useUsersRoomQrTokenRetrieve = <TError = unknown>(
    groupId: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof usersRoomQrTokenRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof usersRoomQrTokenRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!groupId;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersRoomQrTokenRetrieveKey(groupId) : null));
    const swrFn = () => usersRoomQrTokenRetrieve(groupId, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersScreenDashboardRetrieveUrl = () => {
    return `/api/users/screen_dashboard`;
};

export const usersScreenDashboardRetrieve = async (options?: RequestInit): Promise<void> => {
    return usersScreenDashboardRetrieveMutator<void>(getUsersScreenDashboardRetrieveUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getUsersScreenDashboardRetrieveKey = () => [`/api/users/screen_dashboard`] as const;

export type UsersScreenDashboardRetrieveQueryResult = NonNullable<
    Awaited<ReturnType<typeof usersScreenDashboardRetrieve>>
>;
export type UsersScreenDashboardRetrieveQueryError = unknown;

export const useUsersScreenDashboardRetrieve = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof usersScreenDashboardRetrieve>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof usersScreenDashboardRetrieveMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersScreenDashboardRetrieveKey() : null));
    const swrFn = () => usersScreenDashboardRetrieve(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersSendGroupRequestCreateUrl = () => {
    return `/api/users/send_group_request`;
};

export const usersSendGroupRequestCreate = async (options?: RequestInit): Promise<void> => {
    return usersSendGroupRequestCreateMutator<void>(getUsersSendGroupRequestCreateUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getUsersSendGroupRequestCreateMutationFetcher = (
    options?: SecondParameter<typeof usersSendGroupRequestCreateMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return usersSendGroupRequestCreate(options);
    };
};
export const getUsersSendGroupRequestCreateMutationKey = () => [`/api/users/send_group_request`] as const;

export type UsersSendGroupRequestCreateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersSendGroupRequestCreate>>
>;
export type UsersSendGroupRequestCreateMutationError = unknown;

export const useUsersSendGroupRequestCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof usersSendGroupRequestCreate>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof usersSendGroupRequestCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof usersSendGroupRequestCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersSendGroupRequestCreateMutationKey();
    const swrFn = getUsersSendGroupRequestCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersSocialgroupdashboardselectListUrl = () => {
    return `/api/users/socialgroupdashboardselect/`;
};

export const usersSocialgroupdashboardselectList = async (
    options?: RequestInit,
): Promise<SocialGroupDashboardSelect[]> => {
    return usersSocialgroupdashboardselectListMutator<SocialGroupDashboardSelect[]>(
        getUsersSocialgroupdashboardselectListUrl(),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getUsersSocialgroupdashboardselectListKey = () => [`/api/users/socialgroupdashboardselect/`] as const;

export type UsersSocialgroupdashboardselectListQueryResult = NonNullable<
    Awaited<ReturnType<typeof usersSocialgroupdashboardselectList>>
>;
export type UsersSocialgroupdashboardselectListQueryError = unknown;

export const useUsersSocialgroupdashboardselectList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof usersSocialgroupdashboardselectList>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof usersSocialgroupdashboardselectListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersSocialgroupdashboardselectListKey() : null));
    const swrFn = () => usersSocialgroupdashboardselectList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersSocialgroupdashboardselectRetrieveUrl = (id: string) => {
    return `/api/users/socialgroupdashboardselect/${id}/`;
};

export const usersSocialgroupdashboardselectRetrieve = async (
    id: string,
    options?: RequestInit,
): Promise<SocialGroupDashboardSelect> => {
    return usersSocialgroupdashboardselectRetrieveMutator<SocialGroupDashboardSelect>(
        getUsersSocialgroupdashboardselectRetrieveUrl(id),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getUsersSocialgroupdashboardselectRetrieveKey = (id: string) =>
    [`/api/users/socialgroupdashboardselect/${id}/`] as const;

export type UsersSocialgroupdashboardselectRetrieveQueryResult = NonNullable<
    Awaited<ReturnType<typeof usersSocialgroupdashboardselectRetrieve>>
>;
export type UsersSocialgroupdashboardselectRetrieveQueryError = unknown;

export const useUsersSocialgroupdashboardselectRetrieve = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof usersSocialgroupdashboardselectRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof usersSocialgroupdashboardselectRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersSocialgroupdashboardselectRetrieveKey(id) : null));
    const swrFn = () => usersSocialgroupdashboardselectRetrieve(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersSocialgroupdashboardselectUpdateUrl = (id: string) => {
    return `/api/users/socialgroupdashboardselect/${id}/`;
};

export const usersSocialgroupdashboardselectUpdate = async (
    id: string,
    socialGroupDashboardSelectRequest: SocialGroupDashboardSelectRequest,
    options?: RequestInit,
): Promise<SocialGroupDashboardSelect> => {
    return usersSocialgroupdashboardselectUpdateMutator<SocialGroupDashboardSelect>(
        getUsersSocialgroupdashboardselectUpdateUrl(id),
        {
            ...options,
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', ...options?.headers },
            body: JSON.stringify(socialGroupDashboardSelectRequest),
        },
    );
};

export const getUsersSocialgroupdashboardselectUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof usersSocialgroupdashboardselectUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: SocialGroupDashboardSelectRequest }) => {
        return usersSocialgroupdashboardselectUpdate(id, arg, options);
    };
};
export const getUsersSocialgroupdashboardselectUpdateMutationKey = (id: string) =>
    [`/api/users/socialgroupdashboardselect/${id}/`] as const;

export type UsersSocialgroupdashboardselectUpdateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersSocialgroupdashboardselectUpdate>>
>;
export type UsersSocialgroupdashboardselectUpdateMutationError = unknown;

export const useUsersSocialgroupdashboardselectUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof usersSocialgroupdashboardselectUpdate>>,
            TError,
            Key,
            SocialGroupDashboardSelectRequest,
            Awaited<ReturnType<typeof usersSocialgroupdashboardselectUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof usersSocialgroupdashboardselectUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersSocialgroupdashboardselectUpdateMutationKey(id);
    const swrFn = getUsersSocialgroupdashboardselectUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersSocialgroupdashboardselectPartialUpdateUrl = (id: string) => {
    return `/api/users/socialgroupdashboardselect/${id}/`;
};

export const usersSocialgroupdashboardselectPartialUpdate = async (
    id: string,
    patchedSocialGroupDashboardSelectRequest: PatchedSocialGroupDashboardSelectRequest,
    options?: RequestInit,
): Promise<SocialGroupDashboardSelect> => {
    return usersSocialgroupdashboardselectPartialUpdateMutator<SocialGroupDashboardSelect>(
        getUsersSocialgroupdashboardselectPartialUpdateUrl(id),
        {
            ...options,
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', ...options?.headers },
            body: JSON.stringify(patchedSocialGroupDashboardSelectRequest),
        },
    );
};

export const getUsersSocialgroupdashboardselectPartialUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof usersSocialgroupdashboardselectPartialUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: PatchedSocialGroupDashboardSelectRequest }) => {
        return usersSocialgroupdashboardselectPartialUpdate(id, arg, options);
    };
};
export const getUsersSocialgroupdashboardselectPartialUpdateMutationKey = (id: string) =>
    [`/api/users/socialgroupdashboardselect/${id}/`] as const;

export type UsersSocialgroupdashboardselectPartialUpdateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersSocialgroupdashboardselectPartialUpdate>>
>;
export type UsersSocialgroupdashboardselectPartialUpdateMutationError = unknown;

export const useUsersSocialgroupdashboardselectPartialUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof usersSocialgroupdashboardselectPartialUpdate>>,
            TError,
            Key,
            PatchedSocialGroupDashboardSelectRequest,
            Awaited<ReturnType<typeof usersSocialgroupdashboardselectPartialUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof usersSocialgroupdashboardselectPartialUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersSocialgroupdashboardselectPartialUpdateMutationKey(id);
    const swrFn = getUsersSocialgroupdashboardselectPartialUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersSocialgroupinfoRetrieveUrl = (id: string) => {
    return `/api/users/socialgroupinfo/${id}/`;
};

export const usersSocialgroupinfoRetrieve = async (id: string, options?: RequestInit): Promise<SocialGroupInfo> => {
    return usersSocialgroupinfoRetrieveMutator<SocialGroupInfo>(getUsersSocialgroupinfoRetrieveUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getUsersSocialgroupinfoRetrieveKey = (id: string) => [`/api/users/socialgroupinfo/${id}/`] as const;

export type UsersSocialgroupinfoRetrieveQueryResult = NonNullable<
    Awaited<ReturnType<typeof usersSocialgroupinfoRetrieve>>
>;
export type UsersSocialgroupinfoRetrieveQueryError = unknown;

export const useUsersSocialgroupinfoRetrieve = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof usersSocialgroupinfoRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof usersSocialgroupinfoRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersSocialgroupinfoRetrieveKey(id) : null));
    const swrFn = () => usersSocialgroupinfoRetrieve(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersSocialgrouplistListUrl = () => {
    return `/api/users/socialgrouplist/`;
};

export const usersSocialgrouplistList = async (options?: RequestInit): Promise<SocialGroup[]> => {
    return usersSocialgrouplistListMutator<SocialGroup[]>(getUsersSocialgrouplistListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getUsersSocialgrouplistListKey = () => [`/api/users/socialgrouplist/`] as const;

export type UsersSocialgrouplistListQueryResult = NonNullable<Awaited<ReturnType<typeof usersSocialgrouplistList>>>;
export type UsersSocialgrouplistListQueryError = unknown;

export const useUsersSocialgrouplistList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof usersSocialgrouplistList>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof usersSocialgrouplistListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersSocialgrouplistListKey() : null));
    const swrFn = () => usersSocialgrouplistList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersSocialgrouplistRetrieveUrl = (id: string) => {
    return `/api/users/socialgrouplist/${id}/`;
};

export const usersSocialgrouplistRetrieve = async (id: string, options?: RequestInit): Promise<SocialGroup> => {
    return usersSocialgrouplistRetrieveMutator<SocialGroup>(getUsersSocialgrouplistRetrieveUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getUsersSocialgrouplistRetrieveKey = (id: string) => [`/api/users/socialgrouplist/${id}/`] as const;

export type UsersSocialgrouplistRetrieveQueryResult = NonNullable<
    Awaited<ReturnType<typeof usersSocialgrouplistRetrieve>>
>;
export type UsersSocialgrouplistRetrieveQueryError = unknown;

export const useUsersSocialgrouplistRetrieve = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof usersSocialgrouplistRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof usersSocialgrouplistRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersSocialgrouplistRetrieveKey(id) : null));
    const swrFn = () => usersSocialgrouplistRetrieve(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersSocialgrouppublicListUrl = () => {
    return `/api/users/socialgrouppublic/`;
};

export const usersSocialgrouppublicList = async (options?: RequestInit): Promise<SocialGroupInfo[]> => {
    return usersSocialgrouppublicListMutator<SocialGroupInfo[]>(getUsersSocialgrouppublicListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getUsersSocialgrouppublicListKey = () => [`/api/users/socialgrouppublic/`] as const;

export type UsersSocialgrouppublicListQueryResult = NonNullable<Awaited<ReturnType<typeof usersSocialgrouppublicList>>>;
export type UsersSocialgrouppublicListQueryError = unknown;

export const useUsersSocialgrouppublicList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof usersSocialgrouppublicList>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof usersSocialgrouppublicListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersSocialgrouppublicListKey() : null));
    const swrFn = () => usersSocialgrouppublicList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersSocialgroupselectListUrl = () => {
    return `/api/users/socialgroupselect/`;
};

export const usersSocialgroupselectList = async (options?: RequestInit): Promise<SocialGroup[]> => {
    return usersSocialgroupselectListMutator<SocialGroup[]>(getUsersSocialgroupselectListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getUsersSocialgroupselectListKey = () => [`/api/users/socialgroupselect/`] as const;

export type UsersSocialgroupselectListQueryResult = NonNullable<Awaited<ReturnType<typeof usersSocialgroupselectList>>>;
export type UsersSocialgroupselectListQueryError = unknown;

export const useUsersSocialgroupselectList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof usersSocialgroupselectList>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof usersSocialgroupselectListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersSocialgroupselectListKey() : null));
    const swrFn = () => usersSocialgroupselectList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersSocialgroupselectCreateUrl = () => {
    return `/api/users/socialgroupselect/`;
};

export const usersSocialgroupselectCreate = async (
    socialGroupRequest: SocialGroupRequest,
    options?: RequestInit,
): Promise<SocialGroup> => {
    return usersSocialgroupselectCreateMutator<SocialGroup>(getUsersSocialgroupselectCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(socialGroupRequest),
    });
};

export const getUsersSocialgroupselectCreateMutationFetcher = (
    options?: SecondParameter<typeof usersSocialgroupselectCreateMutator>,
) => {
    return (_: Key, { arg }: { arg: SocialGroupRequest }) => {
        return usersSocialgroupselectCreate(arg, options);
    };
};
export const getUsersSocialgroupselectCreateMutationKey = () => [`/api/users/socialgroupselect/`] as const;

export type UsersSocialgroupselectCreateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersSocialgroupselectCreate>>
>;
export type UsersSocialgroupselectCreateMutationError = unknown;

export const useUsersSocialgroupselectCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof usersSocialgroupselectCreate>>,
        TError,
        Key,
        SocialGroupRequest,
        Awaited<ReturnType<typeof usersSocialgroupselectCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof usersSocialgroupselectCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersSocialgroupselectCreateMutationKey();
    const swrFn = getUsersSocialgroupselectCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersSocialgroupselectUpdateUrl = (id: string) => {
    return `/api/users/socialgroupselect/${id}/`;
};

export const usersSocialgroupselectUpdate = async (
    id: string,
    socialGroupRequest: SocialGroupRequest,
    options?: RequestInit,
): Promise<SocialGroup> => {
    return usersSocialgroupselectUpdateMutator<SocialGroup>(getUsersSocialgroupselectUpdateUrl(id), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(socialGroupRequest),
    });
};

export const getUsersSocialgroupselectUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof usersSocialgroupselectUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: SocialGroupRequest }) => {
        return usersSocialgroupselectUpdate(id, arg, options);
    };
};
export const getUsersSocialgroupselectUpdateMutationKey = (id: string) =>
    [`/api/users/socialgroupselect/${id}/`] as const;

export type UsersSocialgroupselectUpdateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersSocialgroupselectUpdate>>
>;
export type UsersSocialgroupselectUpdateMutationError = unknown;

export const useUsersSocialgroupselectUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof usersSocialgroupselectUpdate>>,
            TError,
            Key,
            SocialGroupRequest,
            Awaited<ReturnType<typeof usersSocialgroupselectUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof usersSocialgroupselectUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersSocialgroupselectUpdateMutationKey(id);
    const swrFn = getUsersSocialgroupselectUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersSocialgroupselectPartialUpdateUrl = (id: string) => {
    return `/api/users/socialgroupselect/${id}/`;
};

export const usersSocialgroupselectPartialUpdate = async (
    id: string,
    patchedSocialGroupRequest: PatchedSocialGroupRequest,
    options?: RequestInit,
): Promise<SocialGroup> => {
    return usersSocialgroupselectPartialUpdateMutator<SocialGroup>(getUsersSocialgroupselectPartialUpdateUrl(id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(patchedSocialGroupRequest),
    });
};

export const getUsersSocialgroupselectPartialUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof usersSocialgroupselectPartialUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: PatchedSocialGroupRequest }) => {
        return usersSocialgroupselectPartialUpdate(id, arg, options);
    };
};
export const getUsersSocialgroupselectPartialUpdateMutationKey = (id: string) =>
    [`/api/users/socialgroupselect/${id}/`] as const;

export type UsersSocialgroupselectPartialUpdateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersSocialgroupselectPartialUpdate>>
>;
export type UsersSocialgroupselectPartialUpdateMutationError = unknown;

export const useUsersSocialgroupselectPartialUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof usersSocialgroupselectPartialUpdate>>,
            TError,
            Key,
            PatchedSocialGroupRequest,
            Awaited<ReturnType<typeof usersSocialgroupselectPartialUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof usersSocialgroupselectPartialUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersSocialgroupselectPartialUpdateMutationKey(id);
    const swrFn = getUsersSocialgroupselectPartialUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersSsouserRetrieveUrl = (id: string) => {
    return `/api/users/ssouser/${id}/`;
};

export const usersSsouserRetrieve = async (id: string, options?: RequestInit): Promise<JwtUser> => {
    return usersSsouserRetrieveMutator<JwtUser>(getUsersSsouserRetrieveUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getUsersSsouserRetrieveKey = (id: string) => [`/api/users/ssouser/${id}/`] as const;

export type UsersSsouserRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof usersSsouserRetrieve>>>;
export type UsersSsouserRetrieveQueryError = unknown;

export const useUsersSsouserRetrieve = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof usersSsouserRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof usersSsouserRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersSsouserRetrieveKey(id) : null));
    const swrFn = () => usersSsouserRetrieve(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersSubscriptionCreateUrl = () => {
    return `/api/users/subscription/`;
};

export const usersSubscriptionCreate = async (
    pushSubscriptionRequest: PushSubscriptionRequest,
    options?: RequestInit,
): Promise<PushSubscription> => {
    return usersSubscriptionCreateMutator<PushSubscription>(getUsersSubscriptionCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(pushSubscriptionRequest),
    });
};

export const getUsersSubscriptionCreateMutationFetcher = (
    options?: SecondParameter<typeof usersSubscriptionCreateMutator>,
) => {
    return (_: Key, { arg }: { arg: PushSubscriptionRequest }) => {
        return usersSubscriptionCreate(arg, options);
    };
};
export const getUsersSubscriptionCreateMutationKey = () => [`/api/users/subscription/`] as const;

export type UsersSubscriptionCreateMutationResult = NonNullable<Awaited<ReturnType<typeof usersSubscriptionCreate>>>;
export type UsersSubscriptionCreateMutationError = unknown;

export const useUsersSubscriptionCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof usersSubscriptionCreate>>,
        TError,
        Key,
        PushSubscriptionRequest,
        Awaited<ReturnType<typeof usersSubscriptionCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof usersSubscriptionCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersSubscriptionCreateMutationKey();
    const swrFn = getUsersSubscriptionCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersTestCreateUrl = () => {
    return `/api/users/test`;
};

export const usersTestCreate = async (options?: RequestInit): Promise<void> => {
    return usersTestCreateMutator<void>(getUsersTestCreateUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getUsersTestCreateMutationFetcher = (options?: SecondParameter<typeof usersTestCreateMutator>) => {
    return (_: Key, __: { arg: Arguments }) => {
        return usersTestCreate(options);
    };
};
export const getUsersTestCreateMutationKey = () => [`/api/users/test`] as const;

export type UsersTestCreateMutationResult = NonNullable<Awaited<ReturnType<typeof usersTestCreate>>>;
export type UsersTestCreateMutationError = unknown;

export const useUsersTestCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof usersTestCreate>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof usersTestCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof usersTestCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersTestCreateMutationKey();
    const swrFn = getUsersTestCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

/**
 * Returns the authenticated user's timetable/profile info.
 * @summary Current user profile (singleton list endpoint)
 */
export const getCurrentUserListUrl = () => {
    return `/api/users/timetableprofile/`;
};

export const currentUserList = async (options?: RequestInit): Promise<TimeTableUser[]> => {
    return currentUserListMutator<TimeTableUser[]>(getCurrentUserListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getCurrentUserListKey = () => [`/api/users/timetableprofile/`] as const;

export type CurrentUserListQueryResult = NonNullable<Awaited<ReturnType<typeof currentUserList>>>;
export type CurrentUserListQueryError = unknown;

/**
 * @summary Current user profile (singleton list endpoint)
 */
export const useCurrentUserList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof currentUserList>>, TError> & { swrKey?: Key; enabled?: boolean };
    request?: SecondParameter<typeof currentUserListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getCurrentUserListKey() : null));
    const swrFn = () => currentUserList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersTimetableprofileCreateUrl = () => {
    return `/api/users/timetableprofile/`;
};

export const usersTimetableprofileCreate = async (
    userBaseRequest: UserBaseRequest,
    options?: RequestInit,
): Promise<UserBase> => {
    return usersTimetableprofileCreateMutator<UserBase>(getUsersTimetableprofileCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(userBaseRequest),
    });
};

export const getUsersTimetableprofileCreateMutationFetcher = (
    options?: SecondParameter<typeof usersTimetableprofileCreateMutator>,
) => {
    return (_: Key, { arg }: { arg: UserBaseRequest }) => {
        return usersTimetableprofileCreate(arg, options);
    };
};
export const getUsersTimetableprofileCreateMutationKey = () => [`/api/users/timetableprofile/`] as const;

export type UsersTimetableprofileCreateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersTimetableprofileCreate>>
>;
export type UsersTimetableprofileCreateMutationError = unknown;

export const useUsersTimetableprofileCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof usersTimetableprofileCreate>>,
        TError,
        Key,
        UserBaseRequest,
        Awaited<ReturnType<typeof usersTimetableprofileCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof usersTimetableprofileCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersTimetableprofileCreateMutationKey();
    const swrFn = getUsersTimetableprofileCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersTimetableprofileRetrieveUrl = (id: string) => {
    return `/api/users/timetableprofile/${id}/`;
};

export const usersTimetableprofileRetrieve = async (id: string, options?: RequestInit): Promise<UserBase> => {
    return usersTimetableprofileRetrieveMutator<UserBase>(getUsersTimetableprofileRetrieveUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getUsersTimetableprofileRetrieveKey = (id: string) => [`/api/users/timetableprofile/${id}/`] as const;

export type UsersTimetableprofileRetrieveQueryResult = NonNullable<
    Awaited<ReturnType<typeof usersTimetableprofileRetrieve>>
>;
export type UsersTimetableprofileRetrieveQueryError = unknown;

export const useUsersTimetableprofileRetrieve = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof usersTimetableprofileRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof usersTimetableprofileRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersTimetableprofileRetrieveKey(id) : null));
    const swrFn = () => usersTimetableprofileRetrieve(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersTimetableprofileUpdateUrl = (id: string) => {
    return `/api/users/timetableprofile/${id}/`;
};

export const usersTimetableprofileUpdate = async (
    id: string,
    userBaseRequest: UserBaseRequest,
    options?: RequestInit,
): Promise<UserBase> => {
    return usersTimetableprofileUpdateMutator<UserBase>(getUsersTimetableprofileUpdateUrl(id), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(userBaseRequest),
    });
};

export const getUsersTimetableprofileUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof usersTimetableprofileUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: UserBaseRequest }) => {
        return usersTimetableprofileUpdate(id, arg, options);
    };
};
export const getUsersTimetableprofileUpdateMutationKey = (id: string) =>
    [`/api/users/timetableprofile/${id}/`] as const;

export type UsersTimetableprofileUpdateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersTimetableprofileUpdate>>
>;
export type UsersTimetableprofileUpdateMutationError = unknown;

export const useUsersTimetableprofileUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof usersTimetableprofileUpdate>>,
            TError,
            Key,
            UserBaseRequest,
            Awaited<ReturnType<typeof usersTimetableprofileUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof usersTimetableprofileUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersTimetableprofileUpdateMutationKey(id);
    const swrFn = getUsersTimetableprofileUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersTimetableprofilePartialUpdateUrl = (id: string) => {
    return `/api/users/timetableprofile/${id}/`;
};

export const usersTimetableprofilePartialUpdate = async (
    id: string,
    patchedUserBaseRequest: PatchedUserBaseRequest,
    options?: RequestInit,
): Promise<UserBase> => {
    return usersTimetableprofilePartialUpdateMutator<UserBase>(getUsersTimetableprofilePartialUpdateUrl(id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(patchedUserBaseRequest),
    });
};

export const getUsersTimetableprofilePartialUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof usersTimetableprofilePartialUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: PatchedUserBaseRequest }) => {
        return usersTimetableprofilePartialUpdate(id, arg, options);
    };
};
export const getUsersTimetableprofilePartialUpdateMutationKey = (id: string) =>
    [`/api/users/timetableprofile/${id}/`] as const;

export type UsersTimetableprofilePartialUpdateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersTimetableprofilePartialUpdate>>
>;
export type UsersTimetableprofilePartialUpdateMutationError = unknown;

export const useUsersTimetableprofilePartialUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof usersTimetableprofilePartialUpdate>>,
            TError,
            Key,
            PatchedUserBaseRequest,
            Awaited<ReturnType<typeof usersTimetableprofilePartialUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof usersTimetableprofilePartialUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersTimetableprofilePartialUpdateMutationKey(id);
    const swrFn = getUsersTimetableprofilePartialUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersTimetableprofileUpdatePartialUpdateUrl = () => {
    return `/api/users/timetableprofile/update/`;
};

export const usersTimetableprofileUpdatePartialUpdate = async (
    patchedUserBaseRequest: PatchedUserBaseRequest,
    options?: RequestInit,
): Promise<UserBase> => {
    return usersTimetableprofileUpdatePartialUpdateMutator<UserBase>(getUsersTimetableprofileUpdatePartialUpdateUrl(), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(patchedUserBaseRequest),
    });
};

export const getUsersTimetableprofileUpdatePartialUpdateMutationFetcher = (
    options?: SecondParameter<typeof usersTimetableprofileUpdatePartialUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: PatchedUserBaseRequest }) => {
        return usersTimetableprofileUpdatePartialUpdate(arg, options);
    };
};
export const getUsersTimetableprofileUpdatePartialUpdateMutationKey = () =>
    [`/api/users/timetableprofile/update/`] as const;

export type UsersTimetableprofileUpdatePartialUpdateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersTimetableprofileUpdatePartialUpdate>>
>;
export type UsersTimetableprofileUpdatePartialUpdateMutationError = unknown;

export const useUsersTimetableprofileUpdatePartialUpdate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof usersTimetableprofileUpdatePartialUpdate>>,
        TError,
        Key,
        PatchedUserBaseRequest,
        Awaited<ReturnType<typeof usersTimetableprofileUpdatePartialUpdate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof usersTimetableprofileUpdatePartialUpdateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersTimetableprofileUpdatePartialUpdateMutationKey();
    const swrFn = getUsersTimetableprofileUpdatePartialUpdateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersUpdateDashboardCreateUrl = () => {
    return `/api/users/update_dashboard`;
};

export const usersUpdateDashboardCreate = async (options?: RequestInit): Promise<void> => {
    return usersUpdateDashboardCreateMutator<void>(getUsersUpdateDashboardCreateUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getUsersUpdateDashboardCreateMutationFetcher = (
    options?: SecondParameter<typeof usersUpdateDashboardCreateMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return usersUpdateDashboardCreate(options);
    };
};
export const getUsersUpdateDashboardCreateMutationKey = () => [`/api/users/update_dashboard`] as const;

export type UsersUpdateDashboardCreateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersUpdateDashboardCreate>>
>;
export type UsersUpdateDashboardCreateMutationError = unknown;

export const useUsersUpdateDashboardCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof usersUpdateDashboardCreate>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof usersUpdateDashboardCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof usersUpdateDashboardCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersUpdateDashboardCreateMutationKey();
    const swrFn = getUsersUpdateDashboardCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersUpdateSocialGroupPermCreateUrl = () => {
    return `/api/users/update_social_group_perm`;
};

export const usersUpdateSocialGroupPermCreate = async (options?: RequestInit): Promise<void> => {
    return usersUpdateSocialGroupPermCreateMutator<void>(getUsersUpdateSocialGroupPermCreateUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getUsersUpdateSocialGroupPermCreateMutationFetcher = (
    options?: SecondParameter<typeof usersUpdateSocialGroupPermCreateMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return usersUpdateSocialGroupPermCreate(options);
    };
};
export const getUsersUpdateSocialGroupPermCreateMutationKey = () => [`/api/users/update_social_group_perm`] as const;

export type UsersUpdateSocialGroupPermCreateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersUpdateSocialGroupPermCreate>>
>;
export type UsersUpdateSocialGroupPermCreateMutationError = unknown;

export const useUsersUpdateSocialGroupPermCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof usersUpdateSocialGroupPermCreate>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof usersUpdateSocialGroupPermCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof usersUpdateSocialGroupPermCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersUpdateSocialGroupPermCreateMutationKey();
    const swrFn = getUsersUpdateSocialGroupPermCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersUploadPermsRetrieveUrl = () => {
    return `/api/users/upload_perms`;
};

export const usersUploadPermsRetrieve = async (options?: RequestInit): Promise<void> => {
    return usersUploadPermsRetrieveMutator<void>(getUsersUploadPermsRetrieveUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getUsersUploadPermsRetrieveKey = () => [`/api/users/upload_perms`] as const;

export type UsersUploadPermsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof usersUploadPermsRetrieve>>>;
export type UsersUploadPermsRetrieveQueryError = unknown;

export const useUsersUploadPermsRetrieve = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof usersUploadPermsRetrieve>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof usersUploadPermsRetrieveMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersUploadPermsRetrieveKey() : null));
    const swrFn = () => usersUploadPermsRetrieve(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersUsePreloadCreateUrl = () => {
    return `/api/users/use_preload`;
};

export const usersUsePreloadCreate = async (options?: RequestInit): Promise<void> => {
    return usersUsePreloadCreateMutator<void>(getUsersUsePreloadCreateUrl(), {
        ...options,
        method: 'POST',
    });
};

export const getUsersUsePreloadCreateMutationFetcher = (
    options?: SecondParameter<typeof usersUsePreloadCreateMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return usersUsePreloadCreate(options);
    };
};
export const getUsersUsePreloadCreateMutationKey = () => [`/api/users/use_preload`] as const;

export type UsersUsePreloadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof usersUsePreloadCreate>>>;
export type UsersUsePreloadCreateMutationError = unknown;

export const useUsersUsePreloadCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof usersUsePreloadCreate>>,
        TError,
        Key,
        Arguments,
        Awaited<ReturnType<typeof usersUsePreloadCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof usersUsePreloadCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersUsePreloadCreateMutationKey();
    const swrFn = getUsersUsePreloadCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersUserConnectionsRetrieveUrl = () => {
    return `/api/users/user_connections`;
};

export const usersUserConnectionsRetrieve = async (options?: RequestInit): Promise<void> => {
    return usersUserConnectionsRetrieveMutator<void>(getUsersUserConnectionsRetrieveUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getUsersUserConnectionsRetrieveKey = () => [`/api/users/user_connections`] as const;

export type UsersUserConnectionsRetrieveQueryResult = NonNullable<
    Awaited<ReturnType<typeof usersUserConnectionsRetrieve>>
>;
export type UsersUserConnectionsRetrieveQueryError = unknown;

export const useUsersUserConnectionsRetrieve = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof usersUserConnectionsRetrieve>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof usersUserConnectionsRetrieveMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersUserConnectionsRetrieveKey() : null));
    const swrFn = () => usersUserConnectionsRetrieve(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersUsermanageListUrl = () => {
    return `/api/users/usermanage/`;
};

export const usersUsermanageList = async (options?: RequestInit): Promise<UserManage[]> => {
    return usersUsermanageListMutator<UserManage[]>(getUsersUsermanageListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getUsersUsermanageListKey = () => [`/api/users/usermanage/`] as const;

export type UsersUsermanageListQueryResult = NonNullable<Awaited<ReturnType<typeof usersUsermanageList>>>;
export type UsersUsermanageListQueryError = unknown;

export const useUsersUsermanageList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof usersUsermanageList>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof usersUsermanageListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersUsermanageListKey() : null));
    const swrFn = () => usersUsermanageList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersUsermanageUpdateUrl = (id: string) => {
    return `/api/users/usermanage/${id}/`;
};

export const usersUsermanageUpdate = async (
    id: string,
    userManageUpdateRequest: UserManageUpdateRequest,
    options?: RequestInit,
): Promise<UserManageUpdate> => {
    return usersUsermanageUpdateMutator<UserManageUpdate>(getUsersUsermanageUpdateUrl(id), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(userManageUpdateRequest),
    });
};

export const getUsersUsermanageUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof usersUsermanageUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: UserManageUpdateRequest }) => {
        return usersUsermanageUpdate(id, arg, options);
    };
};
export const getUsersUsermanageUpdateMutationKey = (id: string) => [`/api/users/usermanage/${id}/`] as const;

export type UsersUsermanageUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof usersUsermanageUpdate>>>;
export type UsersUsermanageUpdateMutationError = unknown;

export const useUsersUsermanageUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof usersUsermanageUpdate>>,
            TError,
            Key,
            UserManageUpdateRequest,
            Awaited<ReturnType<typeof usersUsermanageUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof usersUsermanageUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersUsermanageUpdateMutationKey(id);
    const swrFn = getUsersUsermanageUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersUsermanagePartialUpdateUrl = (id: string) => {
    return `/api/users/usermanage/${id}/`;
};

export const usersUsermanagePartialUpdate = async (
    id: string,
    patchedUserManageUpdateRequest: PatchedUserManageUpdateRequest,
    options?: RequestInit,
): Promise<UserManageUpdate> => {
    return usersUsermanagePartialUpdateMutator<UserManageUpdate>(getUsersUsermanagePartialUpdateUrl(id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(patchedUserManageUpdateRequest),
    });
};

export const getUsersUsermanagePartialUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof usersUsermanagePartialUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: PatchedUserManageUpdateRequest }) => {
        return usersUsermanagePartialUpdate(id, arg, options);
    };
};
export const getUsersUsermanagePartialUpdateMutationKey = (id: string) => [`/api/users/usermanage/${id}/`] as const;

export type UsersUsermanagePartialUpdateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersUsermanagePartialUpdate>>
>;
export type UsersUsermanagePartialUpdateMutationError = unknown;

export const useUsersUsermanagePartialUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof usersUsermanagePartialUpdate>>,
            TError,
            Key,
            PatchedUserManageUpdateRequest,
            Awaited<ReturnType<typeof usersUsermanagePartialUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof usersUsermanagePartialUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersUsermanagePartialUpdateMutationKey(id);
    const swrFn = getUsersUsermanagePartialUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersUserpreloadListUrl = () => {
    return `/api/users/userpreload/`;
};

export const usersUserpreloadList = async (options?: RequestInit): Promise<UserPreloadGet[]> => {
    return usersUserpreloadListMutator<UserPreloadGet[]>(getUsersUserpreloadListUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getUsersUserpreloadListKey = () => [`/api/users/userpreload/`] as const;

export type UsersUserpreloadListQueryResult = NonNullable<Awaited<ReturnType<typeof usersUserpreloadList>>>;
export type UsersUserpreloadListQueryError = unknown;

export const useUsersUserpreloadList = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof usersUserpreloadList>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof usersUserpreloadListMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersUserpreloadListKey() : null));
    const swrFn = () => usersUserpreloadList(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersUserpreloadCreateUrl = () => {
    return `/api/users/userpreload/`;
};

export const usersUserpreloadCreate = async (
    userPreloadSetRequest: UserPreloadSetRequest,
    options?: RequestInit,
): Promise<UserPreloadSet> => {
    return usersUserpreloadCreateMutator<UserPreloadSet>(getUsersUserpreloadCreateUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(userPreloadSetRequest),
    });
};

export const getUsersUserpreloadCreateMutationFetcher = (
    options?: SecondParameter<typeof usersUserpreloadCreateMutator>,
) => {
    return (_: Key, { arg }: { arg: UserPreloadSetRequest }) => {
        return usersUserpreloadCreate(arg, options);
    };
};
export const getUsersUserpreloadCreateMutationKey = () => [`/api/users/userpreload/`] as const;

export type UsersUserpreloadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof usersUserpreloadCreate>>>;
export type UsersUserpreloadCreateMutationError = unknown;

export const useUsersUserpreloadCreate = <TError = unknown>(options?: {
    swr?: SWRMutationConfiguration<
        Awaited<ReturnType<typeof usersUserpreloadCreate>>,
        TError,
        Key,
        UserPreloadSetRequest,
        Awaited<ReturnType<typeof usersUserpreloadCreate>>
    > & { swrKey?: string };
    request?: SecondParameter<typeof usersUserpreloadCreateMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersUserpreloadCreateMutationKey();
    const swrFn = getUsersUserpreloadCreateMutationFetcher(requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersUserpreloadRetrieveUrl = (id: string) => {
    return `/api/users/userpreload/${id}/`;
};

export const usersUserpreloadRetrieve = async (id: string, options?: RequestInit): Promise<UserPreloadGet> => {
    return usersUserpreloadRetrieveMutator<UserPreloadGet>(getUsersUserpreloadRetrieveUrl(id), {
        ...options,
        method: 'GET',
    });
};

export const getUsersUserpreloadRetrieveKey = (id: string) => [`/api/users/userpreload/${id}/`] as const;

export type UsersUserpreloadRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof usersUserpreloadRetrieve>>>;
export type UsersUserpreloadRetrieveQueryError = unknown;

export const useUsersUserpreloadRetrieve = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRConfiguration<Awaited<ReturnType<typeof usersUserpreloadRetrieve>>, TError> & {
            swrKey?: Key;
            enabled?: boolean;
        };
        request?: SecondParameter<typeof usersUserpreloadRetrieveMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false && !!id;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersUserpreloadRetrieveKey(id) : null));
    const swrFn = () => usersUserpreloadRetrieve(id, requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersUserpreloadUpdateUrl = (id: string) => {
    return `/api/users/userpreload/${id}/`;
};

export const usersUserpreloadUpdate = async (
    id: string,
    userPreloadSetRequest: UserPreloadSetRequest,
    options?: RequestInit,
): Promise<UserPreloadSet> => {
    return usersUserpreloadUpdateMutator<UserPreloadSet>(getUsersUserpreloadUpdateUrl(id), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(userPreloadSetRequest),
    });
};

export const getUsersUserpreloadUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof usersUserpreloadUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: UserPreloadSetRequest }) => {
        return usersUserpreloadUpdate(id, arg, options);
    };
};
export const getUsersUserpreloadUpdateMutationKey = (id: string) => [`/api/users/userpreload/${id}/`] as const;

export type UsersUserpreloadUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof usersUserpreloadUpdate>>>;
export type UsersUserpreloadUpdateMutationError = unknown;

export const useUsersUserpreloadUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof usersUserpreloadUpdate>>,
            TError,
            Key,
            UserPreloadSetRequest,
            Awaited<ReturnType<typeof usersUserpreloadUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof usersUserpreloadUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersUserpreloadUpdateMutationKey(id);
    const swrFn = getUsersUserpreloadUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersUserpreloadPartialUpdateUrl = (id: string) => {
    return `/api/users/userpreload/${id}/`;
};

export const usersUserpreloadPartialUpdate = async (
    id: string,
    patchedUserPreloadSetRequest: PatchedUserPreloadSetRequest,
    options?: RequestInit,
): Promise<UserPreloadSet> => {
    return usersUserpreloadPartialUpdateMutator<UserPreloadSet>(getUsersUserpreloadPartialUpdateUrl(id), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(patchedUserPreloadSetRequest),
    });
};

export const getUsersUserpreloadPartialUpdateMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof usersUserpreloadPartialUpdateMutator>,
) => {
    return (_: Key, { arg }: { arg: PatchedUserPreloadSetRequest }) => {
        return usersUserpreloadPartialUpdate(id, arg, options);
    };
};
export const getUsersUserpreloadPartialUpdateMutationKey = (id: string) => [`/api/users/userpreload/${id}/`] as const;

export type UsersUserpreloadPartialUpdateMutationResult = NonNullable<
    Awaited<ReturnType<typeof usersUserpreloadPartialUpdate>>
>;
export type UsersUserpreloadPartialUpdateMutationError = unknown;

export const useUsersUserpreloadPartialUpdate = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof usersUserpreloadPartialUpdate>>,
            TError,
            Key,
            PatchedUserPreloadSetRequest,
            Awaited<ReturnType<typeof usersUserpreloadPartialUpdate>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof usersUserpreloadPartialUpdateMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersUserpreloadPartialUpdateMutationKey(id);
    const swrFn = getUsersUserpreloadPartialUpdateMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersUserpreloadDestroyUrl = (id: string) => {
    return `/api/users/userpreload/${id}/`;
};

export const usersUserpreloadDestroy = async (id: string, options?: RequestInit): Promise<void> => {
    return usersUserpreloadDestroyMutator<void>(getUsersUserpreloadDestroyUrl(id), {
        ...options,
        method: 'DELETE',
    });
};

export const getUsersUserpreloadDestroyMutationFetcher = (
    id: string,
    options?: SecondParameter<typeof usersUserpreloadDestroyMutator>,
) => {
    return (_: Key, __: { arg: Arguments }) => {
        return usersUserpreloadDestroy(id, options);
    };
};
export const getUsersUserpreloadDestroyMutationKey = (id: string) => [`/api/users/userpreload/${id}/`] as const;

export type UsersUserpreloadDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof usersUserpreloadDestroy>>>;
export type UsersUserpreloadDestroyMutationError = unknown;

export const useUsersUserpreloadDestroy = <TError = unknown>(
    id: string,
    options?: {
        swr?: SWRMutationConfiguration<
            Awaited<ReturnType<typeof usersUserpreloadDestroy>>,
            TError,
            Key,
            Arguments,
            Awaited<ReturnType<typeof usersUserpreloadDestroy>>
        > & { swrKey?: string };
        request?: SecondParameter<typeof usersUserpreloadDestroyMutator>;
    },
) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const swrKey = swrOptions?.swrKey ?? getUsersUserpreloadDestroyMutationKey(id);
    const swrFn = getUsersUserpreloadDestroyMutationFetcher(id, requestOptions);

    const query = useSWRMutation(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};

export const getUsersUsersitesRetrieveUrl = () => {
    return `/api/users/usersites`;
};

export const usersUsersitesRetrieve = async (options?: RequestInit): Promise<void> => {
    return usersUsersitesRetrieveMutator<void>(getUsersUsersitesRetrieveUrl(), {
        ...options,
        method: 'GET',
    });
};

export const getUsersUsersitesRetrieveKey = () => [`/api/users/usersites`] as const;

export type UsersUsersitesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof usersUsersitesRetrieve>>>;
export type UsersUsersitesRetrieveQueryError = unknown;

export const useUsersUsersitesRetrieve = <TError = unknown>(options?: {
    swr?: SWRConfiguration<Awaited<ReturnType<typeof usersUsersitesRetrieve>>, TError> & {
        swrKey?: Key;
        enabled?: boolean;
    };
    request?: SecondParameter<typeof usersUsersitesRetrieveMutator>;
}) => {
    const { swr: swrOptions, request: requestOptions } = options ?? {};

    const isEnabled = swrOptions?.enabled !== false;
    const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getUsersUsersitesRetrieveKey() : null));
    const swrFn = () => usersUsersitesRetrieve(requestOptions);

    const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

    return {
        swrKey,
        ...query,
    };
};
